export const teData = {
  locale: {
    home_instavc_build:
      "ఉపాధ్యాయులు మరియు విద్యార్థుల మధ్య వర్చువల్ కమ్యూనికేషన్‌ను రూపొందించడం",
    home_instavc_conference_platform:
      "అసమానమైన వినియోగదారు అనుభవంతో నేర్చుకునే వేదికలు",
    home_instavc_start_conference:
      "START CONFERENCE | JOIN CONFERENCE | INSTA CONFERENCE",
    home_instavc_Hippa:
      "HIPAA ELIGIBLE AND PCI DSS, SOC, ISO/EIC 27001, ISO/EIC 27017, ISO/EIC 27018, AND ISO 9001 పాటించేవారు.",
    home_instavc_copyrights:
      "© 2018 · instaVC · Pఎఒప్లెళిన్క్ యూనిఫైడ్ కమ్యూనికేషన్స్ ప్వ్త్. ల్ట్డ్.",
    home_instavc_terms_agree: "నేను ఒప్పుకునుచునాను",
    home_instavc_terms: "నిబంధనలు మరియు షరతులు",

    visibility: "దృశ్యమానత",
    members: " సభ్యులు",
    create_class: "తరగతిని సృష్టించండి",
    public_class: "పబ్లిక్ - క్లాస్ సభ్యులు మాత్రమే చేరగలరు",
    private_class: "ప్రైవేట్ - మీ ఇన్‌స్టిట్యూట్‌లోని ఎవరైనా చేరవచ్చు",
    private: " ప్రైవేట్",
    filter_by: "ద్వారా వడపోత:",
    blocked: "నిరోధించబడింది",
    deleted: "తొలగించబడింది",
    unblock: "అన్‌బ్లాక్ చేయండి",
    make_active: "యాక్టివ్‌గా చేయండి",
    addNewSubject: "కొత్త సబ్జెక్ట్ జోడించండి",
    editSubject: "విషయాన్ని సవరించండి",
    editQuestionnarie: "ప్రశ్నాపత్రాన్ని సవరించండి",
    editAssignment: "అసైన్‌మెంట్‌ని సవరించండి",
    addNewClass: "కొత్త తరగతిని జోడించండి",
    assign_teacher: "టీచర్‌ని కేటాయించండి",
    exculde_students: "విద్యార్థులను మినహాయించండి",
    dateOfJoining: "చేరిన తేదీ",
    classes: "తరగతులు",
    users: "వినియోగదారులు",
    classList: "తరగతుల జాబితా",
    add_teacher: "టీచర్‌ని జోడించండి",
    add_student: "విద్యార్థిని జోడించండి",
    mySessions: "నా సెషన్స్",
    reports: "నివేదికలు",

    inclass_admin_teacher: "ఉపాధ్యాయులు",
    inclass_admin_student: "విద్యార్థులు",
    inclass_admin_studentName: "విద్యార్థి పేరు",
    inclass_admin_studentID: "విద్యార్థి ID",
    inclass_teacher_designation: "హోదా",
    inclass_teacher_department: "శాఖ",
    inclass_student_rollnumber: "రోల్ నంబర్",
    inclass_teacher_status: "స్థితి",
    inclass_admin_user_info: "వినియోగదారు సమాచారం",
    inclass_admin_professional_info: "వృత్తిపరమైన సమాచారం",
    inclass_student_classname: "తరగతి పేరు",

    instavc_login: "లాగ్ ఇన్",
    instavc_login_email: "ఇమెయిల్",
    instavc_login_password: "పాస్వర్డ్",
    instavc_login_button: "లాగ్ ఇన్",
    instavc_login_forgotpassword: "పాస్వర్డ్ మర్చిపోయారా ?",
    instavc_login_have_account: "ఖాతా లేదు ?",
    instavc_login_signup: "చేరడం",
    instavc_signup: "చేరడం",
    instavc_signup_firstname: "మొదటి నామ్e",
    instavc_signup_lastname: "చివరి పేరు",
    instavc_signup_email: "ఇమెయిల్",
    instavc_signup_password: "పాస్వర్డ్",
    instavc_signup_cpassword: "పాస్వర్డ్ను నిర్ధారించండి",
    instavc_signup_button: "చేరడం",
    instavc_signup_already_have_account: "ఖాతా కలిగి ఉన్నారా?",
    instavc_signup_login: "లాగ్ ఇన్",
    instavc_signup_fname_error: "మొదటి పేరు వర్ణమాలలు మాత్రమే ఉండాలి",
    instavc_signup_lname_error: "చివరి పేరు వర్ణమాలలు మాత్రమే ఉండాలి",
    instavc_signup_email_error: "ఇమెయిల్ సరైన ఆకృతిలో ఉండాలి",
    instavc_signup_password_error:
      "పాస్‌వర్డ్ ఎనిమిది అక్షరాల పొడవు ఉండాలి మరియు ఒక పెద్ద అక్షరం, ఒక చిన్న అక్షరం, ఒక అంకెల మరియు ఒక ప్రత్యేక అక్షరం కలయికగా ఉండాలి ",
    instavc_signup_cpassword_error:
      "పాస్వర్డ్ పై పాస్వర్డ్తో సరిపోలాలని నిర్ధారించండి ",
    instavc_forgotpassword_link:
      "మీ ఖాతాతో అనుబంధించబడిన ఇమెయిల్ ఐడిని నమోదు చేయండి. మీ పాస్‌వర్డ్‌ని రీసెట్ చేయడానికి మేము మీకు OTPని మెయిల్ చేస్తాము.",
    instavc_forgotpassword_email: "ఈ - మెయిల్ అడ్రస్ నింపండి",
    instavc_forgotpassword: "పాస్వర్డ్ మర్చిపోయారా",
    instavc_forgotpassword_button: "పాస్వర్డ్ మర్చిపోయారా",
    instavc_confirmpass_heading: "విద్యార్థిని సృష్టించండి",
    instavc_confirmpass_verificationcode: "ధృవీకరణ కోడ్ను నమోదు చేయండి",
    instavc_confirmpass_newpassword: "క్రొత్త పాస్‌వర్డ్‌ను నమోదు చేయండి",
    instavc_confirmpass_retypepassword:
      "క్రొత్త పాస్‌వర్డ్‌ను మళ్లీ టైప్ చేయండి",
    instavc_confirmpass_button: "టీచర్‌ని సృష్టించండి",
    instavc_forgotpassword_signin: "సైన్ ఇన్ చేయండి",
    instavc_forgotpassword_passwordcreated:
      "అభినందనలు! మీ కొత్త పాస్‌వర్డ్ అప్‌డేట్ చేయబడింది, మీరు ఇప్పుడు ఇన్‌క్లాస్‌కి సైన్ ఇన్ చేయవచ్చు.",
    instavc_dashboard: "డాష్బోర్డ్",
    instavc_dashboard_schedule: "షెడ్యూల్ సెషన్",
    instavc_dashboard_meetinglist: "గత సెషన్‌లు",
    instavc_dashboard_conferenceplatform:
      "అసమాన వినియోగదారు అనుభవంతో సమావేశల వేదికలు",
    instavc_dashboard_SC_room: "కాన్ఫరెన్స్ ప్రారంభించండి",
    instavc_dashboard_SC_roomlist:
      "మీ షెడ్యూల్ చేసిన సెషన్‌ని ఎంచుకోవడం ద్వారా",
    instavc_dashboard_startconference: "కాన్ఫరెన్స్ ప్రారంభించండి",
    instavc_dashboard_JC: "సమావేశంలో చేరండి",
    instavc_dashboard_JC_ID: "కాన్ఫరెన్స్ ఇద్ లేదా షెడ్యూల్డ్ ద్వారా",
    instavc_dashboard_JC_button: "కాన్ఫరెన్స్‌లో చేరండి",
    instavc_dashboard_SC: "కాన్ఫరెన్స్ ప్రారంభించండి",
    instavc_dashboard_SC_p2p: "మీ జాబితా నుండి గదిని ఎంచుకోవడం ద్వారా",
    instavc_dashboard_instaconference: "ఇన్‌స్ట కాన్ఫరెన్స్",
    instavc_dashboard_buynow: "ఇప్పుడే కొనండి",
    instavc_dashboard_myprofile: "నా జీవన వివరణ",
    instavc_dashboard_settings: "సెట్టింగులు",
    instavc_dashboard_myadmin: "నా అడ్మిన్",
    instavc_dashboard_affiliate: "నా అనుబంధ",
    instavc_dashboard_logout: "లాగ్ అవుట్",
    conference_myrooms: "నా రూములు",
    conference_myrooms_host: "ఉపాధ్యాయ ID",
    conference_myrooms_roomhost: "మీరు ఈ గదికి హోస్ట్.",
    conference_myrooms_search: "వెతకండి ...",
    conference_myrooms_hostuser: "హోస్ట్ వినియోగదారు",
    conference_myrooms_gotopremium: "ప్రీమియానికి వెళ్లండి",
    conference_myrooms_buynow: "ఇప్పుడే కొనండి",
    conference_myrooms_renewal: "పునరుద్ధరణ",
    conference_setup: "సెటప్",
    conference_myrooms_renewnow: "ఇప్పుడు పునరుద్ధరించండి",
    // "conference_myrooms_hosts": "హోస్ట్",
    conference_myrooms_join: "చేరండి",
    conference_myrooms_setup: "గది సెటప్",
    conference_myrooms_sethost_email:
      "మిమ్మల్ని హోస్ట్‌గా సెట్ చేయండి లేదా అతన్ని / ఆమెను హోస్ట్‌గా మార్చడానికి వినియోగదారు ఇమెయిల్ చిరునామాను నమోదు చేయండి.",
    conference_myrooms_selfhost: "మిమ్మల్ని మీరు హోస్ట్‌గా సెట్ చేసుకోండి",
    conference_myrooms_otherhost:
      "లేదా - మీరు ఏదైనా వినియోగదారుని హోస్ట్‌గా చేయాలనుకుంటే, అతని / ఆమె ఇమెయిల్ చిరునామాను నమోదు చేయండి.",
    conference_myrooms_email: "ఇమెయిల్ చిరునామా",
    Cancel: "రద్దు చేయండి",
    conference_myrooms_apply: "వర్తిస్తాయి",
    view_schedule_myrooms: "నా రూములు",
    view_schedule_search: "వెతకండి ...",
    view_schedule_schedule: "షెడ్యూల్",
    view_schedule_calender:
      "ఈ గది షెడ్యూల్‌లను తనిఖీ చేయడానికి క్యాలెండర్ క్రింద ఉంది",
    video_recordings: "వీడియో రికార్డింగ్‌లు",
    view_recordings_search: "వెతకండి",
    view_recordings_month: "ఈ నెల",
    view_recordings_week: "గడచిన ఏడు రోజులలో",
    view_recordings_today: "ఈరోజు",
    no_recordings: "ఇప్పటివరకు రెకొర్‌దింగ్‌లు లేవు!",
    no_recordings_message: "ప్రస్తుతం ఇక్కడ వీడియోలు లేవు.",
    no_recordings_startmessage:
      "మీరు రికార్డింగ్ ప్రారంభించిన తర్వాత మీ అన్ని వీడియోలను ఇక్కడ చూడవచ్చు.",
    stop_recording: "మీరు ఈ రికార్డింగ్‌ను ఆపాలనుకుంటున్నారా?",
    stop_recording_agree: "అంగీకరిస్తున్నారు",
    stop_recording_disagree: "విభేదిస్తున్నారు",
    conference_in_use: "సమావేశం వాడుకలో ఉంది",
    conference_mode: "సమావేశపు మోడ్",
    large_conference_mode: "పెద్ద సమావేశపు మోడ్",
    conference_setup_configuration: "ఆకృతీకరణ",
    conference_setup_generateid: "సెషన్ ఐడి కనుగొనబడలేదు, ఒకటి రూపొందించండి!",
    conference_setup_regenerate: "పునరుత్పత్తి",
    conference_setup_meetingid: "సెషన్ Id",
    conference_setup_camera: "ఫేస్ టైమ్ హ్డ్ కెమెరా",
    conference_setup_defaultmicrophone:
      "డిఫాల్ట్ - అంతర్గత మైక్రోఫోన్ (అంతర్నిర్మిత)",
    conference_setup_microphone: "అంతర్గత మైక్రోఫోన్ (అంతర్నిర్మిత)",
    conference_setup_volume: "శబ్దం",
    conference_setup_videomode: "వీడియో మోడ్",
    conference_setup_forward: "పంపించడుం",
    conference_setup_mix: "కలపడం",
    conference_setup_invite: "ఆహ్వానించండి",
    conference_setup_invitepeople: "ప్రజలను ఆహ్వానించండి",
    conference_setup_invitefriends:
      "సహకరించడానికి మీ స్నేహితులు మరియు సహోద్యోగులను ఆహ్వానించండి.",
    conference_setup_invite_directlink: "మీ గదికి ప్రత్యక్ష లింక్",
    conference_setup_invite_sharelink:
      "మీ పాల్గొనేవారు మీ సెషన్‌లో చేరడానికి ఈ లింక్‌ను భాగస్వామ్యం చేయండి",
    conference_setup_invite_link:
      "https://connect.instavc.com/conference-guest/eddca0fc7adcdc61a24dabe02597412a36bb96dac7302f3cedb6aac50169d58614eb46b940b556a9/f",
    conference_setup_invitebyemail: "మెయిల్ ద్వారా ఆహ్వానించండి",
    conference_setup_invite_enteremail:
      "మీ పాల్గొనేవారిని ఆహ్వానించడానికి ఇష్టపడే ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    conference_setup_invite_emailid: "ఇమెయిల్ చిరునామా",
    conference_setup_invite_close: "ఆపేయండి",
    conference_setup_invite_button: "ఆహవనించండి",
    conference_setup_advancesettings: "ముందస్తు సెట్టింగ్‌లు",
    conference_setup_changeresolution: "రిజల్యూషన్ ఎంచుకోండి",
    conference_setup_lowbandwidth: "తక్కువ బ్యాండ్‌విడ్త్",
    conference_setup_poornetwork: "తక్కువ నెట్‌వర్క్",
    conference_setup_vga: "VGA - (640x480)",
    conference_setup_vga_graphics:
      "వీడియో గ్రాఫిక్స్ అర్రే (వ్గా) వీడియో రిజల్యూషన్ కోసం",
    conference_setup_hd1080: "HD1080p - (1920x1080)",
    conference_setup_fhd: "పూర్తి హై డెఫినిషన్ (ఫ్డ్) వీడియో రిజల్యూషన్ కోసం",
    conference_setup_4k: "4K - (3840 x 2160)",
    conference_setup_4k_fhd:
      "పూర్తి హై డెఫినిషన్ (ఫ్డ్) వీడియో రిజల్యూషన్ కోసం",
    conference_setup_sif: "SIF - (320x240)",
    conference_setup_sif_vr: "సిఫ్ వీడియో రిజల్యూషన్ కోసం",
    conference_setup_hd720: "HD720p - (1280x720)",
    conference_setup_hd720_vr: "హై డెఫినిషన్ (హ్డ్) వీడియో రిజల్యూషన్ కోసం",
    conference_setup_2k: "2K - (2048×1080)",
    conference_setup_2k_fhd:
      "పూర్తి హై డెఫినిషన్ (ఫ్డ్) వీడియో రిజల్యూషన్ కోసం",
    conference_setup_broadcastoptions: "ప్రసార ఎంపికలు",
    conference_setup_enable: "ప్రారంభించు",
    conference_setup_disable: "నిష్క్రాకమన్",
    conference_setup_reportquality:
      "వాయిస్ మరియు వీడియో కాల్‌లను మెరుగుపరచడంలో సహాయపడటానికి నాణ్యతా గణాంకాలను నివేదించండి",
    conference_setup_havetroubleshoot:
      "మీరు కాన్ఫరెన్స్ ట్రబుల్షూట్ చేయాలనుకుంటున్నారా,అపుడు ఇక్కడ లింక్ క్లిక్ చేయండి ",
    conference_setup_conferencetroubleshoot: "కాన్ఫరెన్స్ ట్రబుల్షూటర్",
    conference_troubleshoot: "టరౌబ్లేషూట్",
    conference_troubleshoot_faq: "తరచుగా అడిగే ప్రశ్న",
    conference_troubleshoot_emailreport: "ఇమెయిల్ నివేదిక ",
    conference_troubleshoot_gotoconference: "సమావేశమునకు వెళ్లండి",
    conference_troubleshoot_os: "ఆపరేటింగ్ సిస్టమ్",
    conference_troubleshoot_version: "సంస్కరణ:",
    conference_troubleshoot_browser: "బ్రౌజర్",
    conference_troubleshoot_chromeversion: "క్రోమ్ సంస్కరణ",
    conference_troubleshoot_privatebrowsing: "ప్రైవేట్ బ్రౌజింగ్",
    conference_troubleshoot_displayresolution: "తీర్మానాలను ప్రదర్శించు",
    conference_troubleshoot_aspectratio: "కారక నిష్పత్తిని ప్రదర్శించు",
    conference_troubleshoot_hasspeakers: "సిస్టమ్‌లో స్పీకర్లు ఉన్నాయి ?",
    conference_troubleshoot_foundspeaker: "స్పీకర్ పరికరాలు కనుగొనబడ్డాయి ",
    conference_troubleshoot_hasmicrophone: "సిస్టమ్‌లో మైక్రోఫోన్ ఉనద ?",
    conference_troubleshoot_foundmicrophone:
      "మైక్రోఫోన్ పరికరాలు కనుగొనబడ్డాయి ",
    conference_troubleshoot_haswebcam: "సిస్టమ్‌లో వెబ్‌క్యామ్ ఉనద ?",
    conference_troubleshoot_foundcameras: "కెమెరా పరికరాలు కనుగొనబడ్డాయి ",
    conference_troubleshoot_webcampermission:
      "వెబ్‌సైట్‌లో వెబ్‌క్యామ్ అనుమతులు ఉన్నాయి ?",
    conference_troubleshoot_microphonepermission:
      "వెబ్‌సైట్‌లో మైక్రోఫోన్ అనుమతులు ఉన్నాయి ?",
    conference_troubleshoot_getUsermedia:
      "బ్రౌజర్ ఈ పేజీలో గెతూసెర్Mఎదిఅ ని అనుమతులు ఉనాయ ?",
    conference_troubleshoot_changeoutput_audiodevice:
      "మీరు అవుట్పుట్ ఆడియో పరికరాలను మార్చగలరా ?",
    conference_troubleshoot_changecamera_resolution:
      "క్రొత్త సమావేశ అభ్యర్థన చేయకుండా మీరు కెమెరా తీర్మానాలను మార్చగలరా ?",
    conference_troubleshoot_supportwebrtc:
      "బ్రౌజర్ Wఎబ్ఱ్ట్C కి మద్దతు ఇస్తుంది (గాని 1.0 లేదా 1.1)?",
    conference_troubleshoot_supportortc:
      "బ్రౌజర్ ఓర్ట్క్ కి మద్దతు ఇస్తుంది (Wఎబ్ఱ్ట్C 1.1)?",
    conference_troubleshoot_turnserver: "టర్న్ సర్వర్‌ను చేరుకోగలదా? ?",
    conference_troubleshoot_turn: "టర్న్: 139.59.64.172: 443",
    conference_troubleshoo_coturn: "టర్న్:కోతుర్న్.ఇన్‌స్టావ్క్.కామ్:443",
    conference_troubleshoot_replacetracks:
      "మీరు తోటివారితో తిరిగి చర్చలు జరపకుండా ట్రాక్‌లను మార్చగలరా ?",
    conference_troubleshoot_record_remoteaudio:
      "మీ బ్రౌజర్ రిమోట్ ఆడియోను రికార్డ్ చేయగలదా లేదా వెబ్ ఆడియో ఆపి లో రిమోట్ ఆడియో స్ట్రీమ్‌ను ప్రాసెస్ చేయగలదా",
    conference_troubleshoot_browsersupports_websocketapi:
      "బ్రౌజర్‌లు వెబ్‌సాకెట్స్ ఆపి కి మద్దతు ఇస్తాయి ",
    conference_troubleshoot_blockwebsocket:
      "మీ సిస్టమ్ వెబ్‌సాకెట్స్ ప్రోటోకాల్‌ను నిరోధించింది లేదా వెబ్‌సాకెట్స్ సర్వర్ ప్రాప్యత చేయలేదా? కాదు",
    conference_troubleshoot_supportwebaudioapi:
      "బ్రౌజర్ వెబ్ ఆడియో ఆపి కి మద్దతు ఇస్తుందా?",
    conference_troubleshoot_supportsctp:
      "బ్రౌజర్ స్క్‌త్ప్ డేటా ఛానెల్‌లకు మద్దతు ఇస్తుందా?",
    conference_troubleshoot_supportsrtp:
      "బ్రౌజర్ ర్టీప్ డేటా ఛానెల్‌లకు మద్దతు ఇస్తుందా? ?",
    conference_troubleshoot_support_screencapturing:
      "ఈ పేజీ స్క్రీన్ క్యాప్చరింగ్ ఆపి కి మద్దతు ఇస్తుందా?",
    conference_troubleshoot_support_multimonitor:
      "ఏదైనా మానిటర్ యొక్క బహుళ-మానిటర్ ఎంపిక & సంగ్రహించే స్క్రీన్‌కు బ్రౌజర్ మద్దతు ఇస్తుందా??",
    conference_troubleshoot_mobiledevice: "ఇది మొబైల్ పరికరమా? ?",
    conference_troubleshoot_supportscreencap_canvas:
      "కాన్వాస్ నుండి స్క్రీన్ క్యాప్చర్ చేయడానికి బ్రౌజర్ మద్దతు ఇస్తుందా?",
    conference_troubleshoot_supportscreencap_video:
      "వీడియో నుండి స్క్రీన్ క్యాప్చర్ చేయడానికి బ్రౌజర్ మద్దతు ఇస్తుందా?",
    conference_troubleshoot_supportpromisses:
      "బ్రౌజర్ వాగ్దానాలకు మద్దతు ఇస్తుందా?",
    conference_troubleshoot_ipaddress:
      "ఇప్ చిరునామాలను చూపించడానికి క్లిక్ చేయండి",
    conference_troubleshoot_stunserver: "స్టన్ సర్వర్ చేరుకోగలదా ?",
    cancel: "రద్దు చేయండి",
    instavc_conference_revoke_fromhost: "హోస్ట్ నుండి ఉపసంహరించుకోండి",
    instavc_conference_startvideoconf_button:
      "వీడియో కాన్ఫరెన్స్ ప్రారంభించండి",
    instavc_conference_loading:
      "మీ స్క్రీన్‌ను లోడ్ చేస్తోంది దయచేసి వేచి ఉండండి",
    instavc_conference_authenticating:
      "ఇన్‌స్టావ్క్ సర్వర్‌లోకి ప్రామాణీకరిస్తోంది ....",
    instavc_conference_joinconference: "సమావేశంలో చేరడం",
    instavc_conference_publishyourvideo: "మీ వీడియోను ప్రచురిస్తోంది",
    instavc_conference_publishyouraudio: "మీ ఆడియోను ప్రచురిస్తోంది",
    instavc_conference_settings: "సెట్టింగులు",
    instavc_conference_setting: "సమావేశపు సెట్టింగులు",
    instavc_conference_setting_source: "మూలము",
    instavc_conference_setting_camera: "కెమెరా",
    instavc_conference_audioinputs: "ఆడియో ఇన్‌పుట్‌లు",
    instavc_conference_setting_apply: "వర్తిస్తాయి",
    instavc_conference_setting_resolution: "స్పష్టత",
    instavc_conference_setting_qr: "క్యూ ఆర్(బీటా)",
    instavc_conference_whiteboard: "తెల్లబల్ల",
    instavc_conference_screenshare: "స్క్రీన్ చూపించ్‌దం",
    instavc_conference_presenter: "వ్యాఖ్యాత",
    instavc_conference_stopshare: "భాగస్వామ్యం ఆపుట",
    instavc_conf_install_Screenshare: "స్క్రీన్ భాగస్వామ్యం ఇన్‌స్టాల్ చేయండి",
    instavc_conference_videosync: "కలిసి చూడండి",
    instavc_conference_videourl: "వీడియో యూఅరెఎల్",
    instavc_conference_enter_videourl: "వీడియో యూఅరెఎల్ ను నమోదు చేయండి",
    instavc_conference_videourl_note:
      "గమనిక: నమోదుచేయపడిన పాల్గొనేవారు మాత్రమే ఈ వీడియోను చూడగలరు, ఆలస్యంగా చేరినవారు వీడియోను చూడలేరు",
    instavc_conf_recordings: "రికార్డింగ్",
    instavc_conference_sharecontent: "మీ స్క్రీన్‌ను భాగస్వామ్యం చేయండి",
    instavc_conference_sharecontent_screen:
      "కనెక్ట్.ఇన్‌స్టావ్క్.కామ్ మీ స్క్రీన్ విషయాలను పంచుకోవాలనుకుంటుంది. మీరు భాగస్వామ్యం చేయాలనుకుంటున్నదాన్ని ఎంచుకోండి",
    instavc_conference_shareentire_screen: " మీ మొత్తం స్క్రీన్ ",
    instavc_conference_sharescreen_applicationwindow: " అనువర్తన గవాక్షం ",
    instavc_conference_sharescreen_chrometab: " క్రోమ్ టాబ్ ",
    instavc_conference_sharescreen_share: " భాగస్వామ్యం ",
    instavc_conf_sharescreen: " మీరు మీ స్క్రీన్ ని భాగస్వామ్యం చేస్తున్నారు!",
    instavc_conf_share_otherparticipants:
      " ఇతర సహభాగులు మీ స్క్రీన్ మీద అప్లికేషన్ లు మరియు డాక్యుమెంటేషన్ లను చూడవచ్చు. ",
    instavc_stopsharing: " భాగస్వామ్యాన్ని నిలుపు ",
    instavc_conference_chat: " చాట్ ",
    instavc_conference_additional_camera: " అదనపు కెమెరా ",
    instavc_conference_sharescreen_groupchat: " గ్రూప్ చాట్ ",
    instavc_conference_sharescreen_GC: " జి.సి. ",
    instavc_conference_entermessage: " ఏదైనా చెప్పండి!",
    instavc_conference_adddevice: " పరికరాలను జోడించు ",
    instavc_conference_adddevice_addcamera: " కెమెరాజోడించు ",
    instavc_conference_adddevice_source: " సోర్స్ ",
    instavc_conference_adddevice_camera: " క్యామర ",
    instavc_conference_adddevice_cameraname: " ఫేస్ టైమ్ హెచ్‌డి  కెమెరా ",
    instavc_conference_adddevice_close: " ఆపేయండి ",
    instavc_conference_adddevice_publish: " ప్రచురణ ",
    instavc_conference_info: " సమాచారము ",
    questions: " ప్రశ్నలు ",
    instavc_conference_askquestions: " ప్రశ్నలు అడగండి ",
    instavc_conference_info_meetingid: " వ్యక్తిగత సెషన్ ID ",
    instavc_conference_fullscreen: " పూర్తి తెర ",
    conference_setup_invitepeoplel: " వ్యక్తులను ఆహ్వానించు ",
    conference_setup_invite_linktojoin:
      "https://connect.instavc.com/conference-guest/93ac2135d88727ca29061b4b6bf9477bc8f285a8121ff580649512abad353fbc6751a134d56438f7/f",
    conference_setup_invite_byemail: " మెయిల్ ద్వారా ఆహ్వానించు ",
    instavc_conference_participants: " పాల్గొనేవారు ",
    instavc_conference_participants_search: " శోధన ...",
    instavc_conference_participant: " పాల్గొనేవారు ",
    instavc_conference_participants_muteall: " అన్నీ మ్యూట్ చేయి ",
    instavc_conference_participants_unmuteall: " అన్ మ్యూట్ ఆల్ ",
    instavc_conference: " సదస్సు ",
    instavc_conf_more: " మరిన్ని ",
    instavc_conference_picturemode:
      " ఈ వీడియో పిక్చర్ ఇన్ పిక్చర్ మోడ్ లో ప్లే అవుతోంది ",
    instavc_conference_mediastreams_stats: " మీడియా స్ట్రీమ్ గణాంకాలు ",
    instavc_conference_mediastreams_audio: " శ్రవ్య ",
    instavc_conference_mediastreams_audio_send: " పంపు ",
    instavc_conference_mediastreams_audio_codec: " కోడెక్ ",
    instavc_conference_mediastreams_audio_rates: " రేట్లు(కెబీపీఎస్)",
    instavc_conference_mediastreams_audio_lost: " పోగొట్టుకున్న ",
    instavc_conference_mediastreams_audio_fraction: " భిన్నం ",
    instavc_conference_mediastreams_video: " వీడియో ",
    instavc_conference_mediastreams_video_send: " పంపు ",
    instavc_conference_mediastreams_video_codec: " కోడెక్ ",
    instavc_conference_mediastreams_video_rates: " రేట్లు(కెబీపీఎస్)",
    instavc_conference_mediastreams_video_lost: " పోగొట్టుకున్న ",
    instavc_conference_mediastreams_video_fraction: " భిన్నం ",
    instavc_conference_resolution: " తీర్మానం ",
    instavc_conference_framerate: " ఫ్రేమ్ రేటు ",
    instavc_conference_nack: " నాక్ ",
    instavc_conference_pli: " పిఎలఆి ",
    instavc_conference_bw: " లభ్యం అవుతున్న బిడబ్ల్యు ",
    instavc_conference_audiomuted: " ఆడియో మ్యూట్ చేయబడింది ",
    instavc_conference_microphonemuted: " మీ మైక్రోఫోన్ మ్యూట్ చేయబడింది ",
    join_conference_join_meetinginvitation: "సెషన్ ఆహ్వానాలలో చేరండి ",
    join_conference_search: " శోధన ...",
    "join_conference_meeting details": " మీటింగ్ పేరున్ఆహ్వానిత:న్వీత్ొర్ నేమ్",
    "జాయ్న్_కాన్ఫరెన్స్_జాయ్న్ ": " జాయ్న్ ",
    join_conference_nomeetings: " సెషన్‌లు లేవు",
    join_conference_noupcomingmeetings:
      " అయ్యో! మీకు ఇంకా రాబోయే సెషన్‌లు ఏవీ లేవు!",
    insta_conference_mycontacts: " నా పరిచయాలు ",
    insta_conference_search: " శోధన ...",
    insta_conference_typemessage: " ఒక సందేశాన్ని టైప్ చేయండి ",
    insta_conference_addcontact: " కాంటాక్ట్ జోడించు ",
    insta_conference_enteremail: " మెయిల్ ఐడి ఎంటర్ చేయండి ",
    insta_conference_add: " ఆడ్ ",
    insta_conference_nouserfound:
      " ఈ ఇమెయిల్ చిరునామాతో అటువంటి యూజర్ కనుగొనబడలేదు ",
    instavc_conf_callnot_allowed:
      " మీరు ఇప్పటికే కాల్ లో ఉన్నప్పుడు ఇతర యూజర్ లకు కాల్ చేయలేరు. ",
    insta_conference_pendingapproval: " పెండింగ్ అప్రూవల్ ",
    insta_conference_outgoingvideocall: " అవుట్ గోయింగ్ వీడియో కాల్ ",
    insta_conference_calling: " కాలింగ్ ....",
    insta_conference_incomingvideocall: " ఇన్ కమింగ్ వీడియో కాల్ ",
    insta_conference_calldecline: " నిరాకరించు ",
    insta_conference_callaccept: " ఆమోదించు ",
    insta_conference_instavcalert:
      " కనెక్ట్.ఇన్‌స్టావ్క్.కామ్ అనుమతించాలని కోరుతోంది ",
    insta_conference_usemicrophone: " మీ మైక్రోఫోన్ ఉపయోగించండి ",
    insta_conference_usecamera: " మీ కెమెరాను ఉపయోగించండి ",
    insta_conference_blockdevices: " బ్లాక్ ",
    insta_conference_allowdevices: " అనుమతించు ",
    instavc_schedulemeeting_createmeeting:
      " కొత్త సెషన్‌ను సృష్టించండి / సవరించండి ",
    instavc_schedulewebinar_createmeeting:
      " కొత్త వెబినార్ సృష్టించు/ సవరించు ",
    instavc_schedulemeeting_meetingname: " మీ సెషన్‌కు పేరు పెట్టండి ",
    instavc_schedulemeeting_selectnames_tomeeting:
      " మీ సెషన్ కోసం గదిని ఎంచుకోండి ",
    instavc_schedulemeeting_setduration: " వ్యవధిని అమర్చు ",
    instavc_schedulemeeting_15min: "పదిఏణు నిమిషాలు ",
    instavc_schedulemeeting_30min: "మూపై నిమిషాలు",
    instavc_schedulemeeting_60min: "మారవై నిమిషాలు ",
    instavc_schedulemeeting_setcustom: " అనుకూలీకరణను అమర్చు ",
    instavc_schedulemeeting_customduration: " కస్టమ్ వ్యవధి ",
    instavc_schedulemeeting_minutes: " నిమిషాలు ",
    instavc_schedulemeeting_setconfpassword:
      " మీ కాన్ఫరెన్స్ పాస్ వర్డ్ సెట్ చేయండి ",
    instavc_schedulemeeting_typepassword:
      " మీ సెషన్ కోసం పాస్‌వర్డ్‌ను టైప్ చేయండి ",
    instavc_schedulemeeting_conferencecolor:
      " మీ కాన్ఫరెన్స్ ఐకాన్ కు రంగుఇవ్వండి ",
    instavc_schedulemeeting_invitepeople: "ఈ సెషన్‌కు వ్యక్తులను ఆహ్వానించండి",
    instavc_schedulemeeting_search: " శోధన ...",
    instavc_schedulemeeting_SM: "SM",
    instvc_SM_message:
      " అధీకృత యూజర్ లైసెన్స్ ఉన్న వినియోగదారుల సంఖ్య లైసెన్స్ పరిమితిని అధిగమించింది. ఒకవేళ మీరు మరింత మందివ్యక్తులను ఆహ్వానించాలని అనుకున్నట్లయితే, మీరు ",
    instavc_SM_message_href: " ప్రీమియంకు వెళ్లండి ",
    instavc_schedulemeeting_notify:
      " ఈ సెషన్ గురించి ఎంచుకున్న వ్యక్తులకు తెలియజేయండి",
    instavc_schedulemeeting_addreminder: " రిమైండర్ లు జోడించు ",
    instavc_schedulemeeting_add: " ఆడ్ ",
    instavc_schedulemeeting_addmeetingreminder: " సెషన్ రిమైండర్‌ని జోడించండి",
    instavc_schedulemeeting_adddatetime: " తేదీ పిక్కర్ మరియు టైమ్ పిక్కర్ ",
    instavc_schedulemeeting_apply: " అప్లై ",
    instavc_schedulemeeting_name: "దయచేసి సెషన్ పేరును నమోదు చేయండి ",
    instavc_schedulemeeting_selectroom: " దయచేసి రూమ్ ఎంచుకోండి ",
    instavc_schedulemeeting_selectduration: " దయచేసి కాలవ్యవధిని ఎంచుకోండి ",
    instavc_recuring_schedule: " పునరావృత షెడ్యూల్ ",
    instavc_schedulemeeting_nothinginreminders: " జ్ఞాపికల్లో ఏదీ లేదు ",
    instavc_schedulemeeting_createbutton: " క్రియేట్ ",
    instavc_schedulemeeting_createdsuccessfully:
      " స్చ్డ్యూల్ విజయవంతంగా సృష్టించబడింది ",
    instavc_meetinglist_calender: " క్యాలండర్ ",
    instavc_meetinglist_selecteddates: " మీరు ఎంచుకున్న తేదీలు ",
    instavc_meetinglist_schedulecreted: " షెడ్యూల్స్ సృష్టించబడ్డాయి ",
    instavc_meetinglist_pastschedule: " గత షెడ్యూల్ ",
    instavc_meetinglist: " సెషన్స్ జాబితా ",
    instavc_meetinglist_meetingdetils:
      "సెషన్ పేరు, సెషన్ సమయం, నిర్వహించబడింది",
    "instavc_meetinglist_search ": " శోధన ...",
    instavc_meetinglist_deleterecuring: " పునరావృత షెడ్యూల్ తొలగించు ",
    instavc_meetinglist_alow_deleterecuring:
      " మీరు ప్రస్తుత షెడ్యూల్, లేదా అన్ని షెడ్యూల్ లను మాత్రమే డిలీట్ చేయాలని అనుకుంటున్నారా??",
    instavc_meetinglist_schedule_series:
      " సిరీస్ లోని మిగతా షెడ్యూల్స్ అన్నీ అలాగే ఉంటాయి.:",
    instavc_meetinglist_schedule_seriesdelete:
      " సీరిస్ లోని అన్ని షెడ్యూల్స్ డిలీట్ చేయబడతాయి:",
    instavc_meetinglist_allrecuringsch: " అన్ని రికరింగ్ షెడ్యూల్స్ ",
    instavc_meetinglist_cancelchanges: " మార్పులను రద్దు చేయి ",
    instavc_meetinglist_noschedules: " షెడ్యూల్స్ లేవు ",
    instavc_ml_schedulemessage:
      " ఇంకా సెషన్ షెడ్యూల్ ఏదీ సృష్టించబడలేదు! దిగువ బటన్‌ను క్లిక్ చేయడం ద్వారా మీ షెడ్యూల్‌ని సృష్టించండి.",
    instavc_create_schedule: " షెడ్యూల్ సృష్టించు ",
    instavc_meetinglist_currentschedule: " ప్రస్తుత షెడ్యూల్ ",
    instavc_meetinglist_join: " జాయ్న్ ",
    instavc_meetinglist_buynow: " ఇప్పుడు కొనుగోలు చేయండి ",
    instavc_dashboard_chooseplan: " ప్లాన్ ఎంచుకోండి ",
    instavc_package_smbplan: " ఎస్ఎంబీ ప్లాన్ లు ",
    instavc_package_smbplan_host: "( హోస్ట్ ఆధారిత లైసెన్స్)",
    instavc_package_smbplandescription:
      "ఒక రూమ్ లో ఒక్కసారి 1 హోస్ట్ మాత్రమే ఉండవచ్చు. ఒక కొనుగోలుదారుడు గదిని నియంత్రించగల హోస్ట్ ఖాతాను సెట్ చేయవచ్చు లేదా మార్చవచ్చు. కాల్ సమయంలో హోస్ట్ యాక్సెస్ లు పంచుకోబడవు. హోస్ట్ కాన్ఫరెన్స్ లో చేరేంత వరకు ఇతర యూజర్ లు అందరూ కూడా ఇంటరాక్ట్ కాలేరు..",
    instavc_package_basic: " ప్రాథమిక ",
    instavc_package_hostuser_smb: "ఒక హోస్ట్ మరియు ",
    instavc_package_hostuser_smb_users: " వినియోగదారులు ",
    instavc_package_currency: "$",
    instavc_package_permonth: "/ నెల ",
    instavc_package_bill_smb: " వార్షికంగా బిల్లు చేయబడింది ",
    instavc_package_include_smb: " ఈ ప్యాకేజీలో ఇవి చేర్చబడతాయి ",
    instavc_package_specifictions_Whiteboard: " వైట్ బోర్డ్ ",
    instavc_package_specifictions_Screen: " స్క్రీన్ షేర్ ",
    instavc_package_specifictions_nChat: " చాట్ ",
    instavc_package_specifictions_Recording: " రికార్డింగ్ ",
    instavc_package_specifictions_PresenterMode: " ప్రజంటర్ రీతి ",
    instavc_package_buynowbutton: " ఇప్పుడు కొనుగోలు చేయండి ",
    instavc_package_fullfeatures_smb: " పూర్తి ఫీచర్లు ",
    instavc_package_billinginfo: " బిల్లింగ్ సమాచారం ",
    instavc_package_billinginfo_name: " పేరు ",
    instavc_package_billinginfo_orginazation: " ఆర్జినేషన్ ",
    instavc_package_biilinginfo_gstin: " జిఎస్‌టిఇన్ ",
    "Save ": " భద్రపరుచు ",
    instavc_package_billinginfo_edit: " సవరించు ",
    instavc_package_billingdetails: " బిల్లింగ్ వివరాలు ",
    instavc_package_billingdetails_firstname: " మొదటి పేరు ",
    instavc_package_billingdetails_lastname: " చివరి పేరు ",
    instavc_package_billingdetails_address: " చిరునామా ",
    instavc_package_billingdetails_zip: " జిప్ ",
    instavc_package_shippinginfo: " షిప్పింగ్ సమాచారం ",
    instavc_package_shippinginfo_edit: " మార్చడం ",
    instavc_package_shippingdetails: " షిప్పింగ్ వివరాలు ",
    instavc_package_shippingdetails_firstname: " మొదటి పేరు ",
    instavc_package_shippingdetails_lastname: " చివరి పేరు ",
    instavc_package_shippingdetails_address: " చిరునామా ",
    instavc_package_shippingdetails_zip: " జిప్ ",
    instavc_package_cartsummary: " బండి సారాంశం ",
    instavc_package_hostbase: " హోస్ట్ ఆధారిత లైసెన్స్ (లైసెన్స్ పేరు)",
    instavc_package_smbplan_basic: " ఎస్ఎంబీ ప్లాన్ - బేసిక్ ",
    instavc_package_plandetails:
      "$ 144.02\n\nbilled for 1 year\n$ 13 per month",
    instavc_package_term: " టర్మ్ ",
    instavc_package_1year: "ఒక సంవత్సరం ",
    instavc_package_2years: "రెండు సంవత్సరాలు ",
    instavc_package_3years: "మూడు సంవత్సరాలు ",
    instavc_package_4years: "నాల్గు సంవత్సరాలు ",
    instavc_package_5years: "ఐదు సంవత్సరాలు ",
    instavc_package_subtotal: " ఉపమొత్తం ",
    instavc_package_taxes: " పన్నులు మరియు ఫీజులు (గీఎస్టీ+18%)",
    instavc_package_launchoffer: " లౌంచొఫ్ఫెర్ ",
    instavc_package_promo: " ప్రోమో విజయవంతంగా అప్లై చేయబడింది ",
    instavc_package_remove: " తొలగించు ",
    instavc_package_havepromocode: " ప్రోమో కోడ్ ఉందా? ఇక్కడ వర్తించు ",
    instavc_package_entercouponcode:
      " దయచేసి చెల్లుబాటు అయ్యే కూపన్ కోడ్ నమోదు చేయండి",
    "instavc_package_total ": " మొత్తం ",
    instavc_package_offerdisclaimer: " ఆఫర్ అస్వీకారం వీక్షించండి ",
    instavc_package_paynow: " ఇప్పుడు చెల్లించండి ",
    instavc_package_payment_instavclicense:
      " ఈన్స్తVC లైసెన్స్ కొరకు పీపుల్ లింక్ యూనిఫైడ్ కమ్యూనికేషన్న్పేమెంట్ ",
    instavc_package_phone: "Phone",
    instavc_package_entervalid_contactnumber:
      " దయచేసి చెల్లుబాటు అయ్యే కాంటాక్ట్ నెంబరు నమోదు చేయండి ",
    instavc_package_email: " ఇమెయిల్ ",
    instavc_package_enteremail:
      " దయచేసి చెల్లుబాటు అయ్యే emai id ని నమోదు చేయండి. ఉదాహరణ : you@example.com ",
    instavc_package_paybycard: " కార్డు ద్వారా చెల్లించండి ",
    instavc_package_securedbyrazorpay: " రేజర్ పే ద్వారా సురక్షితం చేయబడింది ",
    instavc_package_card: " కార్డ్ ",
    instavc_package_enterotp:
      " సేవ్ చేయబడ్డ కార్డులను యాక్సెస్ చేసుకోవడం కొరకు xxxxxxxxxxxxxపై పంపిన OTPని నమోదు చేయండి ",
    instavc_package_resendotp: " ఒత్ప్ని తిరిగి పంపు ",
    instavc_package_skipsavedcards: " సేవ్ చేయబడ్డ కార్డులను దాటవేయండి ",
    instavc_package_enter_otp: " దయచేసి ఓటిపి ఎంటర్ చేయండి ",
    instavc_package_skipthesavedcards:
      " సేవ్ చేయబడ్డ కార్డులను విడిచిపెట్టండి ",
    instavc_package_cardnumber: " కార్డ్ నెంబరు",
    instavc_package_entervalid_cardnumber:
      " దయచేసి చెల్లుబాటు అయ్యే కార్డు నెంబరు నమోదు చేయండి",
    "instavc_package_expiry ": " గడువు ముగిసింది ",
    instavc_package_cardholdername: " కార్డు హోల్డర్ పేరు ",
    instavc_package_cvv: " సి.వి.వి. ",
    instavc_package_3digitcode:
      " ఇది మీ కార్డు వెనక ప్రింట్ చేయబడ్డ 3 అంకెల కోడ్",
    "instavc_package_pay ": " పాయ్ ",
    instavc_package_remembercard: " కార్డ్ గుర్తుంచుకో ",
    instavc_package_medium: " ఒక మోస్తరు ",
    instavc_package_hostuser_medium: "ఒక హోస్ట్ మరియు 50 వినియోగదారులు ",
    instavc_package_month_medium: "$15/ నెలకు ",
    instavc_package_bill_medium: " వార్షికంగా బిల్లు చేయబడింది + గీఎస్టీ 18%",
    instavc_package_include_medium: " ఈ ప్యాకేజీలో ఇవి చేర్చబడతాయి ",
    instavc_package_specifictions_medium:
      " వైట్ బోర్డ్nస్క్రీన్ షేర్nచాట్nరికార్డింగ్nప్రజెంటర్ మోడ్ ",
    instavc_package_buynow_medium: " ఇప్పుడు కొనుగోలు చేయండి ",
    instavc_package_fullfeatures_medium: " పూర్తి ఫీచర్లు ",
    instavc_package_advanced: " ఆధునిక ",
    instavc_package_hostuser_advanced: "ఒక హోస్ట్ మరియు వాంధ వినియోగదారులు ",
    instavc_package_month_advanced: "$16/ నెలకు ",
    instavc_package_bill_advanced: " వార్షికంగా బిల్లు చేయబడింది + గీఎస్టీ18%",
    instavc_package_include_advanced: " ఈ ప్యాకేజీలోతో చేర్చబడుతుంది",
    "instavc_package_specifictions_advanced ":
      " వైట్ బోర్డ్nస్క్రీన్ షేర్nచాట్nరికార్డింగ్nప్రజెంటర్ మోడ్ ",
    instavc_package_buynow_advanced: " ఇప్పుడు కొనుగోలు చేయండి ",
    instavc_package_fullfeatures_advanced: " పూర్తి ఫీచర్లు ",
    instavc_package_virtualmcu: " వర్చువల్ ఏంసియు లైసెన్స్ ",
    instavc_package_virtualmcu_room: "( గది ఆధారిత లైసెన్స్)",
    instavc_package_vmcudetails:
      "ఒక రూమ్ కు ఒక్కసారి 1 హోస్ట్ మాత్రమే ఉండవచ్చు. ఒక కొనుగోలుదారుడు గదిని నియంత్రించగల హోస్ట్ ఖాతాను సెట్ చేయవచ్చు లేదా మార్చవచ్చు. కాల్ సమయంలో హోస్ట్ యాక్సెస్ లు పంచుకోబడవు. హోస్ట్ కాన్ఫరెన్స్ లో చేరేంత వరకు ఇతర యూజర్ లు అందరూ కూడా ఇంటరాక్ట్ కాలేరు..",
    instavc_package_instavc: " ఇన్‌స్తవిసీ ",
    instavc_package_silver: " వెండి ",
    instavc_package_userrooms_silver_users: " వినియోగదారులు ",
    instavc_package_userrooms_silver_rooms: " గదులు ",
    instavc_package_month_silver: "$281/ నెలకు ",
    instavc_package_bill_silver: " వార్షికంగా బిల్లు చేయబడింది + గీఎస్టీ18%",
    instavc_package_include_silver: " తీశ్ పాకేజ్ ఇంక్లుదేశ్ విత్ ",
    instavc_package_specifictions_silver:
      " వ్ిటేబోఅరడనస్క్రీన్ శారెంచట్ంరేకొర్‌డింగ్ంప్ర్ేసెంటెర్ మోడ్ ",
    instavc_package_buynow_silver: " ఇప్పుడు కొనుగోలు చేయండి ",
    instavc_package_fullfeatures_silver: " పూర్తి ఫీచర్లు ",
    instavc_package_gold: " బంగారం ",
    instavc_package_userrooms_gold: "రెండు వందల వినియోగదారులు - మూపై గదులు ",
    instavc_package_month_gold: "$467/ నెలకు ",
    instavc_package_bill_gold: " వార్షికంగా బిల్లు చేయబడింది + గీఎస్టీ18%",
    instavc_package_include_gold: " తీశ్ పాకేజ్ ఇంక్లుదేశ్ విత్ ",
    instavc_package_specifictions_gold:
      "వైట్ బోర్డ్nస్క్రీన్ షేర్nChatnరికార్డింగ్nప్రజెంటర్ మోడ్ ",
    instavc_package_buynow_gold: " ఇప్పుడు కొనుగోలు చేయండి ",
    instavc_package_fullfeatures_gold: " పూర్తి ఫీచర్లు ",
    instavc_package_platinum: " ప్లాటినం ",
    instavc_package_userrooms_platinum: "ఐదు వందల వినియోగదారులు - యాబై గదులు ",
    instavc_package_month_platinum: "$ 933/ నెలకు ",
    instavc_package_bill_platinum: " వార్షికంగా బిల్లు చేయబడింది + గీఎస్టీ18%",
    instavc_package_include_platinum: " తీశ్ పాకేజ్ ఇంక్లుదేశ్ విత్ ",
    instavc_package_specifictions_platinum:
      " వ్ిటేబోఅరడనస్క్రీన్ శారెంచట్ంరేకొర్‌డింగ్ంప్ర్ేసెంటెర్ మోడ్ ",
    instavc_package_buynow_platinum: " ఇప్పుడు కొనుగోలు చేయండి ",
    instavc_package_fullfeatures_platinum: " FuLL ఫీచర్లు ",
    instavc_package_legacybaselicense: " లెగసీ ఆధారిత లైసెన్స్ ",
    instavc_package_licensebased_ports: " పోర్టుల సంఖ్య ఆధారంగా లైసెన్స్ ",
    instavc_package_hardwareendpoint: " ఇన్‌స్తవిసీ హార్డ్ వేర్ ఎండ్ పాయింట్ ",
    instavc_package_webrtcconf_legacysupport:
      " లెగసీ సపోర్ట్ లతో వెబ్ ఆర్ టిసి కాన్ఫరెన్సింగ్ ",
    instavc_package_sip: " సిప్ / బిఎఫ్‌సిపి సపోర్ట్ ",
    instavc_package_chh323: " ఛః323 / హ్.239 సపోర్ట్ ",
    instavc_package_contactus: " మమ్మల్ని సంప్రదించండి ",
    instavc_myprofile_dashboard: " డ్యాష్ బోర్డ్ ",
    instavc_myprofile_settings: " అమర్పులు ",
    instavc_myprofile: " నా ప్రొఫైల్ ",
    instavc_myprofile_personaldetail: " వ్యక్తిగత వివరాలు ",
    instavc_myprofile_personaldetails_name: " పేరు ",
    instavc_myprofile_personaldetails_email: " ఇమెయిల్ ",
    instavc_myprofile_personaldetails_phoneno: " ఫోన్ నెంబరు ",
    instavc_myprofile_personaldetails_address: " చిరునామా ",
    instavc_myprofile_personaldetails_city: " నగరం ",
    instavc_myprofile_edit: " ఎడిటి ",
    instavc_myprofile_personaldetails: " వ్యక్తిగత వివరాలు ",
    instavc_myprofile_firstname: " మొదటి పేరు ",
    instavc_myprofile_lastname: " చివరి పేరు ",
    instavc_myprofile_email: " ఇమెయిల్ ",
    instavc_myprofile_phoneno: " ఫోన్ నెంబరు ",
    instavc_myprofile_professionaldetails: " ప్రొఫెషనల్ వివరాలు ",
    instavc_myprofile_position: " స్థానము ",
    instavc_myprofile_professionaldetails_email: " ఇమెయిల్ ",
    instavc_myprofile_professionaldetails_phoneno: " ఫోన్ నెంబరు ",
    instavc_myprofile_professionaldetails_address: " చిరునామా ",
    instavc_myprofile_professionaldetails_branch: " శాఖ ",
    instavc_myprofile_professionaldetails_edit: " ఎడిటి ",
    instavc_myprofile_officialdetails: " అధికారిక వివరాలు ",
    instavc_myprofile_officialdetails_position: " స్థానము ",
    instavc_myprofile_officialdetails_email: " ఇమెయిల్ ",
    instavc_myprofile_officialdetails_phoneno: " ఫోన్ నెంబరు ",
    instavc_myprofile_officialdetails_branch: " శాఖ ",
    instavc_myprofile_officialdetails_address: " చిరునామా ",
    instavc_myprofile_contactinfo: " కాంటాక్ట్ సమాచారం ",
    instavc_myprofile_contactinformation: " సంప్రదింపు సమాచారం ",
    instavc_myprofile_add: "ADD",
    instavc_myprofile_contactinformation_address: " చిరునామా ",
    instavc_myprofile_contactinformation_city: " నగరం / పట్టణం ",
    instavc_myprofile_contactinformation_zip: " జిప్ ",
    instavc_myprofile_contactinformation_landmark: " ల్యాండ్ మార్క్ ",
    instavc_myprofile_address: " చిరునామా ",
    instavc_myprofile_landmark: " ల్యాండ్ మార్క్ ",
    instavc_myprofile_delete: " అలర్ట్ ",
    instavc_myprofile_deletealert:
      " దీనిని మీరు కచ్చితంగా డిలీట్ చేయాలని అనుకుంటున్నారా?",
    instavc_myprofile_disagree: " అంగీకరించని ",
    instavc_myprofile_agree: " ఒప్పుకోలు ",
    instavc_myprofile_websitelinks: " వెబ్ సైట్ లింక్ ",
    instavc_myprofile_website_add: " ఆడ్ ",
    instavc_myprofile_website: " వెబ్ సైట్ ",
    instavc_myprofile_websiteexample: "https://www.google.com",
    instavc_myprofile_sociallinks: " సామాజిక లింకులు ",
    instavc_myprofile_sociallinks_add: " ఆడ్ ",
    instavc_myprofile_sociallink: " సామాజిక లింకులు ",
    instavc_myprofile_sociallinks_example: "https://www.facebook.com/xxx",
    instavc_myprofile_basicinfo: " ప్రాథమిక సమాచారం ",
    instavc_myprofile_basicinfo_add: " ఆడ్ ",
    instavc_myprofile_basicinfo_dob: " పుట్టిన తేది ",
    instavc_myprofile_basicinfo_gender: " లింగము ",
    instavc_myprofile_basicinformation: " ప్రాథమిక సమాచారం ",
    instavc_myprofile_basicinformation_dob: " పుట్టిన తేది ",
    instavc_myprofile_basicinformation_gender: " లింగము ",
    instavc_myprofile_basicinformation_deletealert:
      " అలర్ట్nమీరు దీనిని డిలీట్ చేయాలని అనుకుంటున్నారా?",
    instavc_myprofile_basicinformation_disagree: " అంగీకరించని ",
    instavc_myprofile_basicinformation_agree: " ఒప్పుకోలు ",
    instavc_myprofile_uploadnewavatar: " కొత్త అవతార్ అప్ లోడ్ ",
    instavc_myprofile_cropimage: " పంట చిత్రం ",
    instavc_myprofile_locale: " స్థానిక ",
    instavc_myprofile_localesettings: " స్థానిక అమర్పులు ",
    instavc_myprofile_preferredlanguage: " ఇష్టపడే భాష:",
    instavc_myprofile_language: " ఇంగ్లీష్ ",
    instavc_settings: " అమర్పులు ",
    instavc_settings_changepassword: " అనుమతిపదాన్ని మార్చు ",
    instavc_settings_changepass: " అనుమతిపదాన్ని మార్చు ",
    instavc_settings_currentpassword: "ప్రస్తుత పాస్వర్డ్",
    instavc_settings_newpassword: " కొత్త పాస్వర్డ్",
    conf_password: "పాస్‌వర్డ్ నిర్ధారించండి",
    instavc_settings_enter_currentpassword:
      " దయచేసి ప్రస్తుత పాస్ వర్డ్ నమోదు చేయండి ",
    instavc_settings_enter_newpassword:
      " దయచేసి కొత్త పాస్ వర్డ్ నమోదు చేయండి ",
    enter_confpassword: "దయచేసి కన్ఫర్మ్ పాస్వర్డ్ ఎంటర్ చేయండి",
    newpassword_confpassword_should_same:
      "కొత్త పాస్‌వర్డ్ మరియు కన్ఫర్మ్ పాస్‌వర్డ్ ఒకేలా ఉండాలి",
    curnt_psw_and_new_psw_should_not_same:
      "ప్రస్తుత పాస్‌వర్డ్ మరియు కొత్త పాస్‌వర్డ్ ఒకేలా ఉండకూడదు",
    instavc_settings_help: " సహాయం ",
    instavc_settings_affiliate: " అఫిలియేట్ అవ్వండి ",
    instavc_settings_support: " Support Center ",
    instavc_settings_newticket: " కొత్త టిక్కెట్ తెరువు ",
    instavc_settings_ticketstatus: " టిక్కెట్ స్థితిని తనిఖీ చేయండి ",
    instavc_settings_troubleshoot: " సమస్యా పరిష్కారం ",
    instavc_legacy_dailout: " డయల్ అవుట్ ",
    instavc_legacy_stats: " గణాంకాలు ",
    instavc_legacy_dail_in_detail: " డయల్-ఇన్ వివరాలు ",
    instavc_legacy_h323_endpoint: " H.323 ఎండ్ పాయింట్ ",
    instavc_legacy_sip_endpoint: " ఎస్ ఐపి ఎండ్ పాయింట్ ",
    instavc_admin_users: " వినియోగదారులు ",
    instavc_courses: "కోర్సులు",
    instavc_admin_username: "టీచర్ పేరు",
    instavc_admin_user_accountstatus: " ఖాతా స్థితి ",
    instavc_admin_user_confirmed: " ధృవీకరించబడింది",
    instavc_admin_user_unconfirmed: " నిర్ధారించబడలేదు ",
    instavc_admin_user_resetall: " అన్నింటిని రీసెట్ చేయండి ",
    instavc_admin_user_sync: " సమకాలీకరణ ",
    instavc_admin_user_status: " స్థితి ",
    instavc_admin_user_phonenumber: " ఫోన్ నెంబరు ",
    instavc_admin_user_created: " సృష్టించబడింది ",
    instavc_admin_user_all: " అన్ని ",
    instavc_admin_groups: " సమూహాలు ",
    instavc_admin_addmore: " మరిన్ని జోడించు ",
    instavc_admin_group_peoplelink: " క్వీన్స్, GOLIVE, పీపుల్ లింక్ ",
    instavc_admin_select_plan: " ప్లాన్ ఎంచుకోండి ",
    instavc_admin_lastmodified: " చివరిగా సవరించబడింది ",
    instavc_admin_email_verified: " ఇమెయిల్ వెరిఫై చేయబడింది ",
    instavc_admin_verified: " ధ్రువీకరించబడింది ",
    instavc_admin_Unverified: " ధ్రువీకరించబడని ",
    instavc_admin_licenses: " లైసెన్సులు ",
    instavc_admin_addlicense: " లైసెన్స్ లను జోడించు ",
    instavc_admin_defaultroom: " స్వయంసిద్ధ గది ",
    instavc_admin_hostlicense: " హోస్ట్ ఆధారిత లైసెన్స్ ",
    instavc_admin_roomlicense: " గది ఆధారిత లైసెన్స్ ",
    instavc_admin_virtualmcu: " వర్చువల్ MCU ఆధారిత లైసెన్స్ ",
    instavc_admin_enterprise: " ఎంటర్ ప్రైజ్ లైసెన్స్ ",
    instavc_mcuserver: " MCU సర్వర్ ",
    instavc_mculink: "https://awsmcu.instavc.com",
    instavc_admin_expirydate: " గడువు తేదీ ",
    instavc_admin_settings: " అడ్మిన్ సెట్టింగ్ లు ",
    instavc_default_offer: " రీఫరల్ కొరకు డిఫాల్ట్ ఆఫర్ ",
    instavc_enter_coupon_code: " కూపన్ కోడ్ ఎంటర్ చేయండి ",
    instavc_current_partshare: " ప్రస్తుత భాగస్వామి భాగస్వామ్యం ",
    instavc_share_value: " షేర్ వాల్యూ ",
    instavc_affliate_share: " ప్రస్తుత అనుబంధ భాగస్వామ్యం ",
    instavc_enter_share: " షేర్ వాల్యూ ఎంటర్ చేయండి (%)",
    instavc_roomname: " గది పేరు ",
    instavc_room_ten: " పది ",
    instavc_room_twenty: " ఇరవై ",
    instavc_room_thirty: " ముప్పై ",
    instavc_room_hostbased: " హోస్ట్ ఆధారిత ",
    instavc_virtualmcu: " వర్చువల్ MCU ",
    instavc_rooms_enterprises: " ఎంటర్ ప్రైజ్ ",
    instavc_roomid: " గది ID ",
    instavc_roomtype: "వయస్సు",
    instavc_room_options: " గది ఐచ్ఛికాలు ",
    instavc_commercialtype: " సబ్జెక్టులు ",
    instavc_free: " ఉచిత ",
    instavc_poc: " భావన యొక్క రుజువు ",
    instavc_commercial: " వాణిజ్య ",
    instavc_createdAt: " ఈ సందర్భంగా రూపొందించిన ",
    instavc_useraccess: " వినియోగదారు ప్రాప్తి ",
    instavc_peoplelinkroom: " పీపుల్ లింక్ గది ",
    instavc_inputlimit: " మూలాంశ పరిమితి ",
    instavc_participant_limit: " పాల్గొనేవారి పరిమితి ",
    instavc_adduser: " వినియోగదారుని జోడించు ",
    instavc_searchbyname: " పేరు ద్వారా శోధించు ",
    instavc_manage_plans: " ప్లాన్ లు/ప్రొడక్ట్ లను నిర్వహించండి ",
    instavc_new_plans: " కొత్త ప్లాన్/ప్రొడక్ట్ ",
    instavc_allplan_list: " అన్ని ప్లాన్ ల జాబితా ",
    instavc_sortby: " క్రమీకరించు ",
    instavc_active: " క్రియాశీల ",
    instavc_inactive: " క్రియాహీనం ",
    instavc_create_plan: " కొత్త ప్లాన్ సృష్టించు ",
    instavc_plan_name: " ప్రణాళిక పేరు ",
    instavc_enteramount: " మొత్తం ఎంటర్ చేయండి (నిమిషం: INR 100)",
    instavc_select_product: " ఉత్పత్తిని ఎంచుకోండి ",
    instavc_host_room: "1 హోస్ట్ /గది ",
    instavc_multiroom: " మల్టీ హోస్ట్/ రూమ్ ",
    instavc_legacyrooms: " లెగసీ రూమ్ ",
    instavc_number_hosts: " హోస్ట్ ల సంఖ్య ",
    instavc_number_participants: " పాల్గొనేవారి సంఖ్య ",
    instavc_number_room: " గదుల సంఖ్య ",
    instavc_subscriptiom_period: " చందా కాలం ",
    instavc_sub_yearly: " వార్షిక ",
    instavc_sub_monthly: " నెలవారీ ",
    instavc_sub_weekly: " వారం ",
    instavc_setinterval: " విరామాన్ని అమర్చు ",
    instavc_type: " రకం ",
    instavc_subscription: " సభ్యత్వం ",
    instavc_onetime: " ఒక్కసారి ",
    instavc_description: " వివరణ ",
    instavc_planid: " ప్లాన్ఐడి ",
    instavc_orders: " ఆదేశాలు ",
    instavc_orderid: " ఆర్డర్ Id ",
    instavc_none: " ఏదీ కాదు ",
    instavc_customer: " కస్టమర్ ",
    instavc_build_anually: " అనుయాలీని నిర్మించు ",
    instavc_recurring_billing: " రికరింగ్ బిల్లింగ్ ",
    instavc_next_due: " తరువాత గడువు నాడు ",
    instavc_invoice_details: " ఇన్ వాయిస్ ల వివరాలు ",
    instavc_recurring_payment: " రికరింగ్ పేమెంట్ ",
    instavc_todays_sale: " నేటి అమ్మకం ",
    instavc_total_order: " మొత్తం ఆర్డర్లు ",
    instavc_total_rooms: " మొత్తం గదులు ",
    instavc_current_conference: " ప్రస్తుత సమావేశాలు ",
    instavc_current_user: " ప్రస్తుత వినియోగదారులు ",
    instavc_live_broadcast: " ప్రత్యక్ష ప్రసారాలు ",
    instavc_loading_chart: " లోడింగ్ ఛార్టు ",
    instavc_view: " వీక్షణం ",
    instavc_coupon_info: " కూపన్ సమాచారం ",
    instavc_new_coupon: " కొత్త కూపన్ ",
    instavc_create_coupon: " కొత్త కూపన్ సృష్టించు ",
    instavc_coupon_code: " కూపన్ కోడ్ ",
    instavc_company_code: " కంపెనీ కోడ్ ",
    instavc_select_plan: " ప్లాన్ లను ఎంచుకోండి ",
    instavc_discount: " డిస్కౌంట్ ",
    instavc_activestatus: " క్రియాశీల స్థితి ",
    instavc_usage: " వాడుక ",
    instavc_activeusage: " క్రియాత్మక మైన వాడుక ",
    instavc_singleuse: " సింగిల్ యూజ్ ",
    instavc_multiuse: " బహుళ ఉపయోగం ",
    instavc_first_page: " మొదటి పుట ",
    instavc_previosu_page: " మునుపటి పుట ",
    instavc_next_page: " తదుపరి పేజీ ",
    instavc_last_page: " చివరి పుట ",
    instavc_plan: " ప్రణాళిక ",
    instavc_request_withdrawal: " ఉపసంహరణ అభ్యర్థన ",
    instavc_withdraw: " ఉపసంహరించు ",
    instavc_account: " ఖాతా ",
    instavc_verification: " ధృవీకరణ ",
    instavc_withdraw_history: " చరిత్రను ఉపసంహరించు ",
    instavc_add_bank: " విత్ డ్రా కొరకు బ్యాంకు ఖాతాను జోడించండి ",
    instavc_bank_description:
      "మీ ఆర్థిక సమాచారాన్ని గోప్యంగా ఉంచడం ద్వారా మీ బ్యాంకు ఖాతాను మేం సంరక్షిస్తాం. ఈ ఖాతా నుంచి విత్ డ్రా కొరకు మేం అభ్యర్థనను అందుకున్నప్పుడల్లా మేం మీకు స్టేటస్ ని ఇమెయిల్ చేస్తాం. విత్ డ్రాయల్ వైఫల్యాలు మరియు రిటర్న్ అమౌంట్ పరిహరించడం కొరకు, ఈ అకౌంట్ మీద ఉండే పేరు విధిగా మీ బ్యాంకు ఖాతాపై ఉన్న పేరుతో జత కావాలి. మీ బ్యాంకు యొక్క పాలసీలు మరియు హాలిడే షెడ్యూల్ స్ఆధారంగా బదిలీని పూర్తి చేయడానికి కొంత సమయం పట్టవచ్చు..",
    instavc_bank_accountnumber: " బ్యాంకు ఖాతా నెంబరు ",
    instavc_enter_accountnumber: " మీ ఖాతా నెంబరు నమోదు చేయండి ",
    instavc_account_name: " ఖాతాదారుని పేరు ",
    instavc_per_bank_account: " బ్యాంకు ఖాతా ప్రకారం ",
    instavc_ifsc: " ఐఎఫ్ ఎస్ సి కోడ్ ",
    instavc_bankname: " బ్యాంకు పేరు ",
    instavc_branchname: " బ్యాంక్ బ్రాంచీ పేరు ",
    instavc_confirmdetails: " వివరాలను ధృవీకరించు ",
    instavc_pandetails:
      " మీ పాన్ కు అనుగుణంగా దిగువ వివరాలను దయచేసి అందించండి. ",
    instavc_enter_pan: " పాన్ ప్రకారం మీ పేరు నమోదు చేయండి ",
    instavc_fathername: " తండ్రి పేరు ",
    instavc_enter_fathername: " తండ్రి పేరు నమోదు చేయండి ",
    instavc_pannumber: " పాన్ నెంబరు ",
    instavc_panexampe: "Ex: BNZPM2501G",
    instavc_upload_pan_copy: " పాన్ కాపీని అప్ లోడ్ చేయండి ",
    instavc_save_details: " వివరాలు భద్రపరుచు ",
    instavc_sales: " అమ్మకాలు ",
    instavc_transactionid: " లావాదేవీ Id ",
    instavc_date: " తేదీ ",
    instavc_amount: " అమౌంట్ ",
    instavc_setaccount_withdraw:
      " విత్ డ్రాకు ముందు ఖాతా వివరాలను సెటప్ చేయడం ",
    instavc_first_withdraw:
      " ఒకవేళ మీరు మొదటిసారి విత్ డ్రా చేయాలని అభ్యర్థించబడ్డ యూజర్ అయితే, మీరు ఖాతా వివరాలను నింపాల్సి ఉంటుంది మరియు తరువాత ట్యాబ్ ల్లో పాన్ కార్డు వివరాలను ఉపయోగించి మీ ఖాతాను వెరిఫై చేయాల్సి ఉంటుంది. మీరు వెరిఫికేషన్ పూర్తి చేసిన తరువాత, మీ లభ్యం అవుతున్న బ్యాలెన్స్ నుంచి విత్ డ్రా చేసుకోవడానికి మీరు అభ్యర్థించవచ్చు.",
    instavc_accountdetails: " ఖాతా వివరాలు నింపండి ",
    instavc_available_balance: " అందుబాటులో ఉన్న బ్యాలెన్స్ ",
    instavc_amount_withdraw: " విత్ డ్రా చేయాల్సిన మొత్తం ",
    instavc_enteramount_withdraw:
      " మీరు విత్ డ్రా చేయాలని అనుకుంటున్న మొత్తాన్ని నమోదు చేయండి ",
    instavc_select_payment_mode: " చెల్లింపు విధానం ఎంచుకోండి ",
    instavc_paypal_payment: " పేపాల్ చెల్లింపు ",
    instavc_bank_transaction: " బ్యాంకు లావాదేవీ ",
    instavc_paypalfee: " Paypal Fee ",
    instavc_totalamount_withdraw: " విత్ డ్రా చేయాల్సిన మొత్తం ",
    instavc_sendrequest: " అభ్యర్థన పంపు ",
    instavc_no_request_withdraw:
      " విత్ డ్రా కొరకు ఇంకా ఎలాంటి అభ్యర్థనలు లేవనెత్తలేదు!",
    instavc_start_process_withdraw:
      " దిగువ నుంచి విత్ డ్రా చేయడం కొరకు మీరు ప్రాసెసింగ్ ప్రారంభించవచ్చు..",
    instavc_request_withdraw_now: " ఇప్పుడు ఉపసంహరించుకోవాలని అభ్యర్థించు ",
    instavc_current_commission: " ప్రస్తుత కమిషన్ ",
    instavc_from: " నుంచి ",
    instavc_to: " వరకు ",
    instavc_today: " ఈ రోజు ",
    instavc_last7days: " గడిచిన ఏడు రోజులు ",
    instavc_lastmonth: " ఈ నెల ",
    instavc_paid_customers: " డాబులు కట్టిన వినియోగదారులు ",
    instavc_share_referral_link: " మీ రీఫరల్ లింక్ ని స్నేహితులతో పంచుకోండి ",
    instavc_copylink: " లింక్ కాపీ ",
    instavc_minimum_payout: " కనీస చెల్లింపు ",
    instavc_referral_signup: " రీఫరల్ సైన్ అప్ లు ",
    instavc_referral_clicks: " రీఫరల్ క్లిక్ లు ",
    instavc_paid: " చెల్లించబడింది ",
    instavc_unpaid: " చెల్లించని ",
    instavc_totalearned: " మొత్తం సంపాదించిన ",
    instavc_myreferral: " నా రీఫరల్స్ ",
    instavc_viewall: " అన్నీ వీక్షించు ",
    instavc_mysales: " నా అమ్మకాలు ",
    instavc_sms_mfa: " ఎస్ఎమ్ఎస్ ఎమెఫ్ స్థితి ",
    instavc_facebook: " ఫేస్ బుక్ ",
    instavc_twitter: " ట్విట్టర్ ",
    instavc_linkedin: " లింక్డిన్ ",
    instavc_referred_users: " రిఫర్ చేయబడ్డ వినియోగదారులు ",
    instavc_created_date: " సృష్టించిన తేదీ ",
    instavc_myearnings: " నా సంపాదన ",
    instavc_earnings: " సంపాదన ",
    instavc_commission_share: " కమిషన్ షేర్ ",
    instavc_commission_percentage: " కమిషన్ శాతం ",
    instavc_coupon_offers: " కూపన్లు/ఆఫర్ లు ",
    instavc_my_referral_account: " నా రీఫరల్ ఖాతా ",
    instavc_req_withdraw: " అభ్యర్థన ఉపసంహరణ ",
    instavc_authenticating: " ఇన్‌స్ట వీసీ సర్వర్ కు ప్రామాణీకరణ చేస్తోంది ...",
    instavc_join_access_media:
      " చేరారు.. మీడియా పరికరాలను ప్రాప్తి చేస్తోంది...",
    instavc_publish_success: " ప్రచురణ విజయవంతమైంది ",
    instavc_recieves: " అందుకుంటుంది ",
    instavc_host_screenshare:
      " స్క్రీన్/డాక్యుమెంట్ షేరింగ్ కొరకు మీరు హోస్ట్ గా మారాల్సి ఉంటుంది లేదా ",
    instavc_request_sharescreen:
      " స్క్రీన్/ డాక్యుమెంట్ షేరింగ్ కొరకు యాక్సెస్ ని అభ్యర్థించండి ",
    instavc_note: " గమనిక ",
    instavc_filesize: " ఫైలు సైజు 10MB కంటే ఎక్కువ ఉండరాదు ",
    instavc_become_host:
      " హోస్ట్ కావడం కొరకు వీడియోమీద డోటెడ్ ఓవర్ ఫ్లో మెనూ ఐకాన్ లను క్లిక్ చేయండి. ",
    instavc_clicklink:
      " హోస్ట్ లింక్ అవ్వండి, పాప్ అప్ లో హోస్ట్ పాస్ వర్డ్ నమోదు చేయండి మరియు హోస్ట్ బటన్ అవ్వండి మీద క్లిక్ చేయండి. ",
    instavc_doc_share: " పత్ర భాగస్వామ్యం ",
    instavc_search_host: " హోస్ట్ కోసం వేచి ఉంది ",
    instavc_wait_for_host:
      "దయచేసి ఈ సెషన్‌ను హోస్ట్ ప్రారంభించడానికి వేచి ఉండండి ",
    instavc_open_black_dialog: " నలుపు డైలాగ్ తెరువు ",
    instavc_open_white_dialog: " తెలుపు డైలాగ్ తెరువు ",
    instavc_dail_detail: " డయల్ - లో - వివరాలు ",
    instavc_request_access: " ప్రాప్తిని అభ్యర్థించు ",
    instavc_inordder_enable: " ఎనేబుల్ చేయడానికి ",
    instavc_host_permission: " హోస్ట్ నుంచి మీకు యాక్సెస్ పర్మిషన్ అవసరం ",
    instavc_please_wait: " దయచేసి వేచి ఉండండి ",
    instavc_host_to_permit: "(హోస్ట్) కు అనుమతి ",
    instavc_alternate_content: " ప్రత్యామ్నాయ విషయం ",
    instavc_meeting_room: "'యొక్క సెషన్ గది ",
    instavc_host_left_conference: " హోస్ట్ కాన్ఫరెన్స్ విడిచిపెట్టారు!",
    instavc_conf_end: " కాన్ఫరెన్స్ లో ఆటోమేటిక్ గా ముగుస్తుంది ",
    instavc_seconds: " సెకన్లు ",
    instavc_waiting_msg:
      "వేచి ఉన్నందుకు ధన్యవాదాలు. హోస్ట్ చేరినప్పుడు మేము సెషన్‌ను ప్రారంభిస్తాము",
    instavc_let_hostname: " మీరు వేచి ఉన్నవిషయాన్ని హోస్ట్ కు తెలియజేయదలిచారా?",
    instavc_exitconf: " నిష్క్రమణ సమావేశం ",
    instavc_host_left: " ఎడమ కు హోస్ట్...",
    instavc_end_host_msg:
      " హోస్ట్ ఈ సెషన్‌ను ముగించారు. హాజరైనందుకు ధన్యవాదాలు.",
    instavc_close_conf:
      " మీరు ఇంటికి తిరిగి వెళ్లవచ్చు (లేదా) అప్లికేషన్ క్లోజ్ చేయవచ్చు.",
    instavc_gohome: " ఇంటికి వెళ్లు ",
    instavc_hand_raised: " చేయి ఎత్తబడింది ",
    instavc_ask: " అడగండి ",
    instavc_protocal: " ప్రోటోకాల్ ",
    instavc_bitrate: " బిట్రేట్ ",
    instavc_confirm_details: " మీ వివరాలను ధృవీకరించండి ",
    instavc_enter_info_conf:
      " కాన్ఫరెన్స్ ప్రారంభించడానికి ముందు దయచేసి మీ సమాచారాన్ని నమోదు చేయండి..",
    instavc_have_acc: " ఒకవేళ మీకు ఇప్పటికే అకౌంట్ ఉన్నట్లయితే?",
    instavc_host_access: " హోస్ట్ ప్రాప్తి ",
    instavc_host_pass: " హోస్ట్ పాస్ వర్డ్ నమోదు చేయండి ",
    instavc_becomehost: " హోస్ట్ అవ్వండి ",
    instavc_permit_screenshare: "స్క్రీన్-షేర్‌ను అనుమతించండి ",
    instavc_allow_access: " వైట్ బోర్డ్ ప్రాప్తిని అనుమతించు ",
    instavc_request_permission: " కు అదనపు అనుమతులను అభ్యర్థించింది ",
    instavc_deny: " నిరాకరించు ",
    // "instavc_planid" : " ప్రణాళికId ",
    instavc_customeremail: " కస్టమర్ ఇమెయిల్ ",
    instavc_orderlink: "ఆర్డర్ లింక్ ",
    instavc_customerid: " కస్టమర్ Id ",

    instavc_selectpackage: " ప్యాకేజీని ఎంచుకోండి ",
    instavc_host_package: " హోస్ట్ ఆధారిత ప్యాకేజీ ",
    instavc_virtualbase_mcu: "వర్చువల్ MCU బేస్డ్",
    instavc_plans_product: "ప్రణాళికలు / ఉత్పత్తులు",
    instavc_nodata: "సమాచారం అందుబాటులో లేదు",
    instavc_nodata_msg:
      "అయ్యో! మీకు చూపించడానికి ప్రస్తుతం డేటా అందుబాటులో లేదు",
    instavc_basicplan: "ప్రాథమిక ప్రణాళిక",
    instavc_host_participants: "30 మంది పాల్గొనే 1 హోస్ట్",
    instavc_link: "లింక్",
    instavc_cancel_order: "ఆర్డర్‌ను రద్దు చేయండి",
    instavc_per: "పర్",
    instavc_user_email: "వినియోగదారు ఇమెయిల్",
    instavc_owner: "యజమాని",
    instavc_user: "వాడుకరి",
    instavc_default_users: "డిఫాల్ట్ ఆఫర్లు",
    instavc_system_settings: "సిస్టమ్ అమరికలను",
    instavc_expires: "గడువు ముగిసేది",
    instavc_start_VC: "వీడియో కాన్ఫరెన్స్ ప్రారంభించండి",
    instavc_start_AC: "ఆడియో సమావేశాన్ని ప్రారంభించండి",
    instavc_date_error:
      "ప్రారంభ తేదీ మరియు సమయం ప్రస్తుత సమయం కంటే ఎక్కువగా ఉండాలి",
    instavc_browser_update: "బ్రౌజర్ నవీకరణ అవసరం",
    instavc_browser_note:
      "మీరు ఇప్పుడు మద్దతు లేని BROWSERNAME యొక్క పాత సంస్కరణను ఉపయోగిస్తున్నారని మేము గమనించాము.",
    instavc_browser_msg:
      "Instavc.com కు BROWSERNAME లేదా ఇతర ఆధునిక బ్రౌజర్‌ల యొక్క నవీకరించబడిన సంస్కరణ అవసరం",
    instavc_browser_upgrade:
      "మంచి అనుభవం కోసం దయచేసి ఈ బ్రౌజర్‌ల యొక్క తాజా సంస్కరణల్లో దేనినైనా అప్‌గ్రేడ్ చేయండి",
    instavc_googlechrome: "గూగుల్ క్రోమ్",
    instavc_gc_version74: "వెర్షన్ 74",
    instavc_mfirefox: "మొజిల్లా ఫైర్ ఫాక్స్",
    instavc_mff_version: "వెర్షన్ 66",
    instavc_opera: "ఒపేరా",
    instavc_opera_version: "సంస్కరణ 60.0+",
    instavc_microsoftedge: "మైక్రోసాఫ్ట్ ఎడ్జ్",
    instavc_ms_version: "సంస్కరణ 44+",
    instavc_safari: "ఆపిల్ సఫారి",
    instavc_safari_version: "వెర్షన్ 12.1",
    instavc_contact_msg:
      "ఇప్పటికే అప్‌గ్రేడ్ చేయబడింది, కానీ ఇప్పటికీ సమస్య ఉందా? వద్ద మమ్మల్ని సంప్రదించండి",
    instavc_camera_busy: "కెమెరా బిజీగా ఉన్నట్లు అనిపిస్తుంది!",
    instavc_close_camera:
      "దయచేసి అన్ని అనువర్తనాలను మూసివేసి, మళ్లీ ప్రయత్నించండి.",
    instavc_resolution: "తీర్మానానికి మద్దతు లేదు!",
    instavc_camera_notsupport: "మీ కెమెరా ఈ రిజల్యూషన్‌కు మద్దతు ఇవ్వదు.",
    instavc_camera_reconfig:
      "తక్కువ రిజల్యూషన్‌తో మీ సెట్టింగ్‌లను తిరిగి కాన్ఫిగర్ చేసి, మళ్లీ ప్రయత్నించండి.",
    instavc_change_resolution: "తీర్మానాన్ని మార్చండి",
    instavc_confirmation: "నిర్ధారణ",
    instavc_yes: "అవును",
    instavc_delete_room: "మీరు ఖచ్చితంగా గదిని తొలగించాలనుకుంటున్నారా?",
    instavc_delete_license:
      "మీరు ఖచ్చితంగా లైసెన్స్‌ను తొలగించాలనుకుంటున్నారా?",
    instavc_help: "మీకు సహాయం చేయడానికి మేము ఇక్కడ ఉన్నాము",
    instavc_browse_questions: "తరచుగా అడిగే ప్రశ్నల ద్వారా బ్రౌజ్ చేయండి.",
    instavc_os: "ఆపరేటింగ్ సిస్టమ్",
    instavc_macos: "Mac OS X వెర్షన్:",
    instavc_chrome_version: "Chrome సంస్కరణ:",
    instavc_private_browsing: "ప్రైవేట్ బ్రౌజింగ్?",
    instavc_faq_no: "తోబుట్టువుల",
    instavc_display_resolution: "instavc_డిస్ప్లే_రిజల్యూషన్",
    instavc_aspect_ratio: "కారక నిష్పత్తిని ప్రదర్శించు",
    instavc_sys_hasspeakers: "సిస్టమ్‌లో స్పీకర్లు ఉన్నాయా?",
    instavc_found_speakers: "స్పీకర్ పరికరాలు కనుగొనబడ్డాయి: 2",
    instavc_speakers1: "స్పీకర్ 1",
    instavc_speakers2: "స్పీకర్ 2",
    instavc_sys_have_microphone: "సిస్టమ్‌లో మైక్రోఫోన్ ఉందా?",
    instavc_found_microphone: "మైక్రోఫోన్ పరికరాలు కనుగొనబడ్డాయి: 2",
    instavc_microphone1: "మైక్రోఫోన్ 1",
    instavc_microphone2: "మైక్రోఫోన్ 2",
    instavc_has_webcam: "సిస్టమ్‌కు వెబ్‌క్యామ్ ఉందా?",
    instavc_found_speakers1: "స్పీకర్ పరికరాలు కనుగొనబడ్డాయి: 1",
    instavc_camera1: "కెమెరా 1",
    instavc_webcam_permission: "వెబ్‌సైట్‌లో వెబ్‌క్యామ్ అనుమతులు ఉన్నాయా?",
    instavc_microphone_permission: "వెబ్‌సైట్‌లో మైక్రోఫోన్ అనుమతులు ఉన్నాయా?",
    instavc_browser_allows: "బ్రౌజర్ ఈ పేజీలో getUserMedia ని అనుమతిస్తుంది?",
    instavc_change_output_device: "మీరు అవుట్పుట్ ఆడియో పరికరాలను మార్చగలరా?",
    instavc_change_camera_resolutions:
      "క్రొత్త getUserMedia అభ్యర్థన చేయకుండా మీరు కెమెరా తీర్మానాలను మార్చగలరా?",
    instavc_browser_support_webrtc:
      "బ్రౌజర్ WebRTC కి మద్దతు ఇస్తుంది (గాని 1.0 లేదా 1.1)?",
    instavc_browser_support_ortc:
      "బ్రౌజర్ ORTC (WebRTC 1.1) కు మద్దతు ఇస్తుందా?",
    instavc_initial_setup:
      "మీ ప్రారంభ సెటప్ ప్రాసెస్ చేయబడుతున్నప్పుడు వేచి ఉండండి!",
    instavc_close_browser:
      "ఈ సమయంలో మీ బ్రౌజర్‌ను మూసివేయవద్దు లేదా వెనుక బటన్‌ను ఉపయోగించవద్దు.",
    instavc_whoops: "అయ్యో!",
    instavc_nonet_msg:
      "ఇంటర్నెట్ కనెక్షన్ కనుగొనబడలేదు. దయచేసి మీ కనెక్షన్‌ను తనిఖీ చేయండి లేదా మళ్లీ ప్రయత్నించండి.",
    instavc_nosearch: "శోధన ఫలితాలు ఏవీ కనుగొనబడలేదు ",
    instavc_noserchmsg: "మీ శోధనకు సరిపోయే ఏ అంశాన్ని మేము కనుగొనలేము.",
    instavc_nosearch_filter:
      "మీరు వెతుకుతున్నదాన్ని కనుగొనడానికి మీ శోధన లేదా ఫిల్టర్‌ను సర్దుబాటు చేయడానికి ప్రయత్నించండి.",
    instavc_gotohoem_page: "హోమ్ పేజీకి వెళ్ళండి",
    instavc_pageloading: "పేజీ లోడ్ అవుతోంది ... దయచేసి వేచి ఉండండి!",
    instavc_process: "ప్రాసెస్ చేస్తోంది ...",
    instavc_session_timeout: "సెషన్ సమయం ముగిసింది",
    instavc_session_inactivity:
      "నిష్క్రియాత్మకత కారణంగా మీ సెషన్ సమయం ముగిసింది.",
    instavc_session_msg: "దయచేసి సైన్ ఇన్ అవ్వడానికి ఎంచుకోండి.",
    instavc_session_reconnect: "రీకనెక్ట్",
    instavc_site_notreached: "ఈ సైట్‌ను చేరుకోవడం సాధ్యం కాదు!",
    instavc_site_webaddress: "మీకు సరైన వెబ్ చిరునామా ఉందని నిర్ధారించుకోండి",
    instavc_check_internet: "మీ నెట్‌వర్క్‌ను తనిఖీ చేయండి",
    instavc_search_url: "ఇతర బ్రౌజర్‌లో URL కోసం శోధించండి",
    instavc_goto: "వెళ్ళండి",
    instavc_request_for_access: "ప్రాప్యత కోసం అభ్యర్థన",
    instavc_start_collabrate: "వైట్‌బోర్డ్‌లో సహకరించడం ప్రారంభించడానికి",
    instavc_large_conference_mode:
      'దీని "పెద్ద సమావేశం" మోడ్, హోస్ట్ మీకు అనుమతి ఇచ్చే వరకు మీరు ఇతరులతో మాట్లాడలేరు లేదా చూడలేరు',
    instavc_allow_participants:
      'దీని "పెద్ద సమావేశం" మోడ్, మీరు పాల్గొనేవారిని మాట్లాడటానికి మానవీయంగా అనుమతించాలి',
    instavc_buy_premium: "ఈ లక్షణాలను అన్‌లాక్ చేయడానికి ప్రీమియం కొనండి",
    instavc_alert_tryagain: "ఏదో తప్పు జరిగింది, దయచేసి మళ్ళీ ప్రయత్నించండి",
    instavc_enter_name: "మీ పేరు రాయుము, మీ పేరు రాయండి",
    instavc_confirm: "నిర్ధారించండి",
    instavc_ok: "అలాగే",
    instavc_askquestion: "ఒక ప్రశ్న అడగండి...",
    instavc_recieve: "స్వీకరించండి",
    instavc_delay: " xఆలస్యం (MS)",
    instavc_audio_opus: "ఆడియో / ఓపస్",
    instavc_video_vp8: "వీడియో / VP8",
    instavc_browser_not_support_incall:
      "కాల్ సమయంలో రిజల్యూషన్ మార్పుకు మీ బ్రౌజర్ మద్దతు ఇవ్వదు!",
    instavc_failed_toPublish: "వీడియో ప్రచురించడంలో విఫలమైంది",
    instavc_publish_fail: "ప్రచురించడం విఫలమైంది",
    instavc_video_cant_publish:
      "వినియోగదారు పరిమితి కారణంగా వీడియో ప్రచురించబడదు",
    instavc_failed_joinConference: "సమావేశంలో చేరడంలో విఫలమైంది",
    instavc_mute_audio:
      "రిమోట్ ఆడియో మ్యూట్ చేయబడితే మీరు మ్యూట్ చేయలేరు / మ్యూట్ చేయలేరు",
    instavc_remote_audio_muted: "రిమోట్ ఆడియో మ్యూట్ చేయబడింది!",
    instavc_enter_conferenceid: "మీ కాన్ఫరెన్స్ ID ని నమోదు చేయండి",
    instavc_share_screen: "స్క్రీన్‌ను భాగస్వామ్యం చేయండి",
    instavc_sharing_your_screen: "మీ స్క్రీన్‌ను పంచుకుంటున్నారు ...",
    instavc_stop: "ఆపు",
    instavc_back: "తిరిగి",
    instavc_choose_plan: "దిగువ జాబితా నుండి మీ ప్రణాళికను ఎంచుకోండి",
    instavc_have_promotionalcode: "ప్రచార కోడ్ / భాగస్వామి కోడ్ ఉందా?",
    instavc_contact_pricing: "ధర కోసం మమ్మల్ని సంప్రదించండి",
    instavc_payment_failed: "చెల్లింపు విఫలమైంది",
    instavc_payment_error:
      "దురదృష్టవశాత్తు మీ చెల్లింపును నిర్వహించేటప్పుడు లోపం సంభవించింది.",
    instavc_contact_support:
      "ఏదైనా సహాయం అవసరమైతే దయచేసి మా మద్దతు బృందాన్ని సంప్రదించండి.",
    instavc_tryagain: "మళ్ళీ ప్రయత్నించండి",
    instavc_payment_success: "చెల్లింపు విజయవంతమైంది",
    instavc_thanks_for_payment: "మీ చెల్లింపుకు ధన్యవాదాలు!",
    instavc_payment_processed:
      "మీ చెల్లింపు విజయవంతంగా ప్రాసెస్ చేయబడింది. స్వయంచాలక చెల్లింపు రసీదు",
    instavc_mail_sent: "త్వరలో మీ నమోదిత ఇమెయిల్ చిరునామాకు పంపబడుతుంది",
    instavc_goto_homepage: "హోమ్ పేజీకి తిరిగి వెళ్ళు",
    instavc_want_toend_call: "కాల్ ముగించాలనుకుంటున్నారా?",
    instavc_exit_window:
      "ఈ విండోను మూసివేయడం మీ కాల్ నుండి నిష్క్రమిస్తుంది. మీరు ఖచ్చితంగా ఈ కాల్‌ను ముగించాలనుకుంటున్నారా?",
    instavc_create_room: "గదిని సృష్టించండి",
    instavc_userlimit: "వినియోగదారు పరిమితి",
    instavc_edit_room: "గదిని సవరించండి",
    instavc_update: "నవీకరణ",
    instavc_manage_license: "లైసెన్స్‌లను నిర్వహించండి",
    instavc_package: "ప్యాకేజీ",
    instavc_no_of_rooms: "గదుల సంఖ్య",
    instavc_no_of_users: "వినియోగదారుల సంఖ్య",
    instavc_purchasedOn: "కొనుగోలు చేశారు",
    instavc_expiredon: "గడువు ముగిసింది",
    instavc_or: "లేదా",
    instavc_otherhost_email:
      "మీరు ఏదైనా వినియోగదారుని హోస్ట్‌గా చేయాలనుకుంటే, అతని / ఆమె ఇమెయిల్ చిరునామాను నమోదు చేయండి.",
    instavc_set_host_password: "హోస్ట్ పాస్‌వర్డ్‌ను సెట్ చేయండి",
    instavc_host_password: "పాస్‌వర్డ్ హోస్ట్ ",
    instavc_access_room: "ఈ గదిని మరెవరు యాక్సెస్ చేయవచ్చు?",
    instavc_select_user_host:
      "అతన్ని / ఆమెను హోస్ట్‌గా చేయడానికి జాబితా నుండి ఏదైనా వినియోగదారుని ఎంచుకోండి.",
    instavc_prologin: "InstaVC ప్రో లాగిన్ ",
    instavc_start: "ప్రారంభం",
    instavc_enter_website: "దయచేసి వెబ్‌సైట్ పేరును నమోదు చేయండి",
    instavc_enter_valid_email:
      "దయచేసి చెల్లుబాటు అయ్యే ఇమెయిల్‌ను నమోదు చేయండి",
    instavc_enter_valid_phone:
      "దయచేసి చెల్లుబాటు అయ్యే ఫోన్ నంబర్‌ను నమోదు చేయండి",
    instavc_field_required: "ఈ ఖాళీని తప్పనిసరిగా పూరించవలెను",
    instavc_invitedby: "ద్వారా ఆహ్వానించబడ్డారు",
    instavc_storage: "నిల్వ",

    affiliate_approve: "ఆమోదించబడింది",
    affiliate_pending: "పెండింగ్",
    affiliate_rejected: "తిరస్కరించబడిన",
    affiliate_user_status: "వినియోగదారు స్థితి",
    commission_other: "ఇతర కమీషన్లు",
    add_commission: "కమిషన్ జోడించండి",
    delete_commission: "మీరు కమిషన్‌ను తొలగించాలనుకుంటున్నారా",
    update_commission: "కమిషన్‌ను నవీకరించండి",
    name: "పేరు",
    offer_value: "ఆఫర్ విలువ ",
    add: "చేర్చు",
    update: "నవీకరణ",
    affiliates: "అనుబంధాలు",
    status: "స్థితి",
    status_change_message: "మీరు స్థితిని మార్చాలనుకుంటున్నారా?",
    approve: "ఆమోదించడానికి",
    reject: "తిరస్కరించు",
    commissions: "కమిషన్",
    withdraw_data: "డేటాను ఉపసంహరించుకోండి",
    withdraw_amount: "మొత్తాన్ని ఉపసంహరించుకోండి",
    payment_method: "చెల్లింపు పద్ధతి",
    payment_fee: "చెల్లింపు రుసుము",
    total_amount_withdraw: "ఉపసంహరణ కోసం మొత్తం మొత్తం",
    total_earnings: "మొత్తం సంపాదన",
    pending_amount: "పెండింగ్ మొత్తం",
    paid_amount: "చెల్లించిన మొత్తం",
    unpaid_amount: "చెల్లించని మొత్తం",
    requested_withdraw: "విత్‌డ్రా మొత్తాన్ని అభ్యర్థించారు",
    english: "ఆంగ్ల",
    french: "ఫ్రెంచ్",
    portuguese: "పోర్చుగీస్",
    hindi: "హిందీ",
    gujarati: "గుజరాతీ",
    kannada: "కన్నడ",
    marathi: "మరాఠీ",
    tamil: "తమిళ",
    telugu: "తెలుగు",
    urdu: "ఉర్దూ",
    spanish: "స్పానిష్",
    malyalam: "మలయాళం",
    italian: "ఇటాలియన్",
    bangla: "బంగ్లా",
    room: "గది",
    create: "సృష్టించు",
    repeat: "రిపీట్",
    daily: "డైలీ",
    repeat_every: "ప్రతి పునరావృతం",
    repeat_on: "పునరావృతం చేయండి",
    repeat_by: "ద్వారా పునరావృతం చేయండి",
    ends: "ఎండ్స్",
    after: "తరువాత",
    occurences: "సంఘటనలు",
    on: "పై",
    summary: "సారాంశం",
    repeats: "పునఃప్రసారాలు",
    withdraws: "విత్డ్రాస్",
    every: "ప్రతి",
    days: "రోజులు",
    weeks: "వారాలు",
    months: "నెలల",
    onday: "రోజు",
    years: "సంవత్సరాలు",
    times: "సార్లు",
    until: "వరకు",
    past_meeting_list: "గత సెషన్ జాబితా",
    organised_by: "ద్వారా నిర్వహించబడింది",
    delete: "తొలగించు",
    join: "చేరండి",
    to: "కు",
    enter_password: "రహస్య సంకేతం తెలపండి",
    submit: "లొంగు",
    enter_passwordmessage: "దయచేసి పాస్‌వర్డ్‌ను నమోదు చేయండి",
    delete_message: "మీరు తొలగించాలనుకుంటున్నారా",
    meeting_permanent: "శాశ్వతంగా సెషన్ చేయాలా?",
    day: "పగలు",
    password_message: "పాస్వర్డ్ తప్పు",
    timezone: "సమయమండలం",
    by: "ద్వారా",
    weekdays: ["ఆది", "సోమ", "మంగ", "బుధ", "గురు", "శుక్ర", "శని"],
    allweek: [
      "ఆదివారం",
      "సోమవారం",
      "మంగళవారం",
      "బుధవారం",
      "గురువారం",
      "శుక్రవారం",
      "శనివారం",
    ],
    day_month: "నెల రోజు",
    day_week: "వారంలో రోజు",
    week: "వారం",
    month: "నెల",
    year: "సంవత్సరము",
    enterpassword:
      "దయచేసి మీ క్రొత్త పాస్‌వర్డ్‌ను నమోదు చేసి పాస్‌వర్డ్‌ను నిర్ధారించండి",
    passwordmessage:
      "పాస్వర్డ్ మరియు పాస్వర్డ్ను నిర్ధారించండి రెండూ ఒకేలా ఉండాలి",
    passwordupdate:
      "పాస్‌వర్డ్ విజయవంతంగా నవీకరించబడింది, దయచేసి మీ కొత్త పాస్‌వర్డ్‌తో లాగిన్ చేయండి",
    numeric: ["మొదటి ", " రెండవ ", " మూడవ ", " నాల్గవ ", " ఐదవ"],
    verify_email: "మీ ఎమైని ధృవీకరించండిl",
    confirm_code: "నిర్ధారణ కోడ్",
    verify_msg: "దయచేసి కోడ్ కోసం మీ మొబైల్‌ను తనిఖీ చేయండి.",
    verify: "నిర్ధారించండి",
    not_recieved: "స్వీకరించలేదా?",
    resend_otp: "OTP ను మళ్ళీ పంపు",
    start_browsing: "బ్రౌజింగ్ ప్రారంభించండి",
    become_affiliate: "అనుబంధంగా అవ్వండి",
    affiliate: "అనుబంధ",
    verify_mobile: "మీ మొబైల్‌ను ధృవీకరించండి",
    instavc_allow_DocumentAccess: "పత్రం-భాగస్వామ్యాన్ని అనుమతించండి",
    instavc_allow_Notes: "గమనికలను అనుమతించండి",

    //common - CameraResolution
    camera_not_access: "కింది కారణాలలో ఒకటి కారణంగా కెమెరా యాక్సెస్ చేయబడదు:",
    camera_not_access_reason1:
      "రిజల్యూషన్ సెట్టింగులు ఈ డిస్ప్లేతో అనుకూలంగా ఉండకపోవచ్చు. మీ సెట్టింగులను తక్కువ రిజల్యూషన్‌తో కాన్ఫిగర్ చేసి, మళ్లీ ప్రయత్నించండి.",
    camera_not_access_reason2:
      "మీ కెమెరా వేరే అనువర్తనం ద్వారా ఉపయోగించబడుతోంది, దయచేసి అన్ని అనువర్తనాలను మూసివేసి, లింక్‌పై క్లిక్ చేయడం ద్వారా మళ్లీ ప్రయత్నించండి.",

    //Containers
    //content - components - assignQuestionnaire
    asgnQue_Assign_Question: "ప్రశ్నపత్రాన్ని కేటాయించండి",
    asgnQue_assigned_question: "కేటాయించిన ప్రశ్నపత్రం",
    //assignQuestList
    quslsit_assig_que_list: "కేటాయించిన ప్రశ్నాపత్రం జాబితా",
    quslsit_question_lists: "ప్రశ్నాపత్రం జాబితాలు",
    quslsit_add_new_question: "క్రొత్త ప్రశ్నపత్రాన్ని జోడించండి",
    quslsit_no_question_assign: "ప్రశ్నపత్రం ఇంకా కేటాయించబడలేదు!",
    quslsit_assign_new_ques:
      "పై కేటాయింపు ప్రశ్నపత్రం బటన్‌ను క్లిక్ చేయడానికి క్రొత్త ప్రశ్నాపత్రాన్ని కేటాయించండి",

    //model-assign-Questionnaire
    select_questionnaire: "ప్రశ్నపత్రాన్ని ఎంచుకోండి",
    duration: "వ్యవధి",
    time_limit: "నిర్ణీత కాలం",
    show_results: "ఫలితాలను చూపించు",
    save: "కాపాడుకొను",
    //viewAssigned
    content_group: "కంటెంట్ సమూహం",
    list_assigned_ques: "కేటాయించిన ప్రశ్నల జాబితా:",
    mins: "నిమిషాలు",
    marks: "మార్క్స్",
    //AssignedQuestions
    asgQues_5_Marks: "(5 మార్కులు)",
    asgQues_answers: "జవాబులు",
    asgQues_no_questions: "ప్రశ్నలు లేవు!",

    //content - components - contentGrade
    //GradeSetting
    grdSet_GPA_calculation: "శాతం నుండి GPA లెక్కింపు",
    grdSet_GPA_cal_msg:
      "శాతం 100% కోసం ఉంది, ఇది 100 పాయింట్లు తప్ప మరొకటి కాదు. కాబట్టి 25 పాయింట్లు GPA వ్యవస్థలో 1 పాయింట్‌కు సమానం. GPA ఫార్ములాకు శాతం మీ శాతాన్ని 100 ద్వారా విభజించి 4 తో గుణించాలి. మీరు శాతం 75% అయితే మీ గ్రేడ్ (75/100) * 4 = 3. ",
    grdSet_grade_point: "గ్రేడ్ పాయింట్లు ఉంటే",
    //managegrade
    mngGrd_grades: "తరగతులు",
    mngGrd_modify: "సవరించండి",
    mngGrd_save_grades: "గ్రేడ్‌లను సేవ్ చేయండి",
    mngGrd_modify_grades: "తరగతులను సవరించండి",
    mngGrd_grade_info: "గ్రేడ్ సమాచారం",
    //content - components - ContentParticipants
    //components-admnAnsView
    admnAns_answer_list_for_question:
      "ఈ కంటెంట్ సమూహం యొక్క అన్ని ప్రశ్నాపత్రాల సమాధానాల జాబితా క్రింద ఇవ్వబడింది.",
    //components-participants
    prtcpt_certification: "యోగ్యతాపత్రాలకు:",
    prtcpt_other_content_group: "ఇతర కంటెంట్ సమూహాలలో",
    prtcpt_sales: "అమ్మకాలు",
    prtcpt_marketing: "క్రయవిక్రయాలు",
    prtcpt_human_resource: "మానవ వనరుల",
    //manageparticipants
    mngPrtcpt_add_participants: "పాల్గొనేవారిని జోడించండి",
    mngPrtcpt_participants_list: "పాల్గొనేవారి జాబితాలు",
    mngPrtcpt_import_participants: "పాల్గొనేవారిని దిగుమతి చేయండి",
    mngPrtcpt_download_sample: "నమూనాను డౌన్‌లోడ్ చేయండి",
    mngPrtcpt_no_participants_added: "పాల్గొనేవారు ఇంకా జోడించబడలేదు!",
    mngPrtcpt_add_new_participant:
      "క్రొత్త పాల్గొనేవారిని జోడించండి, జోడించడానికి పైన క్లిక్ చేయి పాల్గొనే బటన్‌ను క్లిక్ చేయండి ",
    //modal-add-participants
    addPrtcpt_select_participants: "పాల్గొనేవారిని ఎంచుకోండి",
    addPrtcpt_model_add_participants: "పాల్గొనేవారిని జోడించండి",
    //partipantGradeView
    prtcptGrde_participant_grade: "పాల్గొనే గ్రేడ్ వివరాలు",
    prtcptGrde_grade_participants_list: "పాల్గొనేవారి జాబితా",
    //content - components - ContentQuestionnaire
    //managequestionnaire
    mngQuesnr_create_questionnaire: "ప్రశ్నపత్రాన్ని సృష్టించండి",
    questionnaire_list: "ప్రశ్నాపత్రం జాబితా",
    //managequestions
    mngQues_question_details: "ప్రశ్నాపత్రం వివరాలు",
    mngQues_no_question_created: "ఇంకా ప్రశ్న సృష్టించబడలేదు!",
    mngQues_create_new_question:
      "క్రొత్త ప్రశ్నను సృష్టించండి, సృష్టించడానికి పైన క్లిక్ చేయండి ప్రశ్న బటన్‌ను సృష్టించండి ",
    //modal-create-quest-group
    mdlGrp_questionnaire_name: "ప్రశ్నాపత్రం పేరు",
    mdlGrp_update: "నవీకరణ",
    mdlGrp_create: "సృష్టించు",
    //modal-create-questions
    mdlCrtQues_question_type: "ప్రశ్న రకం",
    mdlCrtQues_sel_question_type: "ప్రశ్న రకాన్ని ఎంచుకోండి",
    mdlCrtQues_single_sel_multiple_choice: "సింగిల్ సెలెక్ట్ మల్టిపుల్ ఛాయిస్",
    mdlCrtQues_multiselect_multiple_choice: "మల్టీసెలెక్ట్ మల్టిపుల్ ఛాయిస్",
    mdlCrtQues_ture_false: "ఒప్పు/తప్పు",
    mdlCrtQues_enter_answer_choice:
      "జవాబు ఎంపికలను నమోదు చేసి, ఏ సమాధానం సరైనదో గుర్తించండి",
    mdlCrtQues_add_another_choice: "+ మరొక ఎంపికను జోడించండి",
    //viewQuestionnaire
    viewQues_add_questions: "ప్రశ్నలను జోడించండి",
    viewQues_no_question_created: "ఇంకా ప్రశ్న సృష్టించబడలేదు!",
    viewQues_create_new_question:
      "క్రొత్త ప్రశ్నను సృష్టించండి, సృష్టించడానికి పైన క్లిక్ చేయండి ప్రశ్న బటన్ సృష్టించు",

    //content - components - createContent
    //createcontent
    crteContent_create_new_content: "క్రొత్త కంటెంట్‌ను సృష్టించండి",
    crteContent_update_content: "కంటెంట్‌ను నవీకరించండి",
    crteContent_save_content: "కంటెంట్‌ను సేవ్ చేయండి",
    crteContent_content_list: "కంటెంట్ జాబితాలు",
    edit_content: "కంటెంట్‌ను సవరించండి",
    crteContent_create_content: "కంటెంట్‌ను సృష్టించండి",
    crteContent_create_your_content_like:
      "చిత్రాలు, వీడియో ఫైల్‌లు, ఆడియో ఫైల్‌లు మరియు పత్రాలు వంటి మాధ్యమాలను జోడించడం ద్వారా మీ కంటెంట్‌ను సృష్టించండి.",
    crteContent_upload_document: "పత్రాలను అప్‌లోడ్ చేయండి",
    crteContent_upload_media: "మీడియాను అప్‌లోడ్ చేయండి",
    crteContent_document: "పత్రాలు",
    crteContent_media_files: "మీడియా ఫైళ్ళు",
    //view-content
    viewCon_content_view: "కంటెంట్ వీక్షణ",
    viewCon_content_list: "కంటెంట్ జాబితాలు",
    viewCon_View_content: "కంటెంట్‌ను చూడండి",
    viewCon_enable: "ప్రారంభించు: ",
    viewCon_document: "పత్రాలు",
    viewCon_media_files: "మీడియా ఫైళ్ళు",

    //content - components - contentRow
    conRow_by: "ద్వారా: ",

    //content - components - managecontent
    create_new_content: "కంటెంట్‌ను సృష్టించండి",
    mngCon_all: "అన్ని",
    mngCon_content_list: "కంటెంట్ జాబితాలు",
    mngCon_no_content_created: "ఇంకా కంటెంట్ సృష్టించబడలేదు!",
    mngCon_create_new_content:
      "క్రొత్త కంటెంట్‌ను సృష్టించండి, సృష్టించడానికి పైన క్లిక్ చేయండి కంటెంట్ బటన్‌ను సృష్టించండి",
    //content - components - model-access-right
    mdlAccRight_share_access: "ఇతర బోధకులతో ప్రాప్యతను పంచుకోండి",
    mdlAccRight_type_id_add: "ఇమెయిల్ ఐడిని టైప్ చేసి, జోడించండి",
    mdlAccRight_no_instructor_added: "ఇంకా బోధకుడు జోడించబడలేదు!.",
    mdlAccRight_add_people_from_addressbok:
      "మీ చిరునామా పుస్తకం నుండి లేదా ఇమెయిల్ చిరునామాను టైప్ చేయడం ద్వారా వ్యక్తులను జోడించండి.",
    mdlAccRight_contacts: "కాంటాక్ట్స్",
    mdlAccRight_add_contacts:
      "మీ చిరునామా పుస్తక పరిచయాల నుండి కంటెంట్ సమూహానికి పరిచయాలను జోడించండి ",
    mdlAccRight_no_contacts_added: "ఇంకా పరిచయాలు జోడించబడలేదు!.",
    //content - components - model-confirm-delete
    mdlConfDel_confirmation: "నిర్ధారణ",
    mdlConfDel_are_you_sure_delete:
      "మీరు దీన్ని ఖచ్చితంగా తొలగించాలనుకుంటున్నారా",
    mdlConfDel_delete: "తొలగించు",
    //content - components - model-create-content-group
    mdlCrtConGrp_alert_enter_group_title: "దయచేసి సమూహ శీర్షికను నమోదు చేయండి",
    mdlCrtConGrp_alert_enter_group_description:
      "దయచేసి సమూహ వివరణను నమోదు చేయండి",
    mdlCrtConGrp_group_name: "సముహం పేరు",
    //content - components - model-upload-doc
    mdlUpldoc_alert_enter_title_doc:
      "దయచేసి డాకుమెన్ యొక్క శీర్షికను నమోదు చేయండిt",
    mdlUpldoc_upload_document: "పత్రాలను అప్‌లోడ్ చేయండి",
    mdlUpldoc_document_title: "పత్రం శీర్షిక",
    mdlUpldoc_upload_doc_from_system:
      "మీ సిస్టమ్ నుండి పత్రాన్ని అప్‌లోడ్ చేయండి, ఇది .pdf, Excel, వర్డ్ డాక్యుమెంట్‌కు మద్దతు ఇస్తుంది.",
    mdlUpldoc_upload_doc: "పత్రాన్ని అప్‌లోడ్ చేయండి",
    mdlUpldoc_added_doc: "పత్రాలు జోడించబడ్డాయి",
    //content - components - model-upload-media
    mdlUplMedia_alert_enter_title_media: "దయచేసి మీడియా శీర్షికను నమోదు చేయండి",
    mdlUplMedia_alert_enter_title_url:
      "దయచేసి శీర్షిక మరియు URL ను నమోదు చేయండి",
    mdlUplMedia_alert_enter_youtube_vimeo_url:
      "దయచేసి చెల్లుబాటు అయ్యే మరియు URL ను నమోదు చేయండి (Youtube / Vimeo)",
    mdlUplMedia_upload_media: "మీడియాను అప్‌లోడ్ చేయండి",
    mdlUplMedia_upload_url: "URL ని అప్‌లోడ్ చేయండి",
    mdlUplMedia_Upload_media_system:
      "మీ సిస్టమ్ నుండి అధిక రిజల్యూషన్ ఫైల్‌లను అప్‌లోడ్ చేయండి, ఇది .jpg, .png, .jpeg, .mp3, .mp4కి మద్దతు ఇస్తుంది.",
    mdlUplMedia_add_media_url:
      "మీడియాను అటాచ్ చేయడానికి మీడియా URL చిరునామాను జోడించండి",
    mdlUplMedia_upload_media_url: "మీడియా URL ని అప్‌లోడ్ చేయండి",
    mdlUplMedia_upload_youtube_url: "గమనిక: యూట్యూబ్ URL ని అప్‌లోడ్ చేయండి",
    mdlUplMedia_Add_media_file: "మీడియా ఫైళ్ళు జోడించబడ్డాయి",

    //content - managecontent - index
    // "mngContent_content" : "విషయము",
    mngContent_participants: "పాల్గొనేవారు",
    mngContent_grade_settings: "గ్రేడ్ సెట్టింగులు",

    //content - index
    content_all_content_group: "అన్ని కంటెంట్ గుంపులు",
    create_new_group: "సమూహాన్ని సృష్టించండి",
    content_no_group_created: "సమూహాలు ఇంకా సృష్టించబడలేదు!",
    content_create_new_group:
      "క్రొత్త సమూహాన్ని సృష్టించండి, సృష్టించడానికి పైన క్లిక్ చేయండి గ్రూప్ బటన్‌ను సృష్టించండి",

    //ContentShare - contentList
    conList_all_group: "అన్ని గుంపులు",
    conList_content_list: "కంటెంట్ జాబితాలు",
    conList_no_content_created: "ఇంకా కంటెంట్ సృష్టించబడలేదు!",
    //contentShare - grouplist
    grpList_all_content_group: "అన్ని కంటెంట్ గుంపులు",
    grpList_no_group_created: "సమూహాలు ఇంకా సృష్టించబడలేదు!",

    //ContentShare - questionStepper
    queStepper_cant_skip: "మీరు ఐచ్ఛికం కాని దశను దాటవేయలేరు",
    queStepper_back: "తిరిగి",
    queStepper_next: "తరువాత",
    queStepper_skip: "దాటు",
    queStepper_finish: "ముగించు",
    queStepper_submit_next: "సమర్పించు & తరువాత",
    //contentshare - showContent
    conList_content_list: "కంటెంట్ జాబితా",
    showCont_document: "పత్రాలు",
    showCont_previous: "మునుపటి",
    showCont_next: "తరువాత",
    showCont_have_completed_topic: "నేను ఈ కంటెంట్‌లోని అంశాలను పూర్తి చేసాను",
    //contentShare - showMedia
    showMedia_page: "పేజీ",
    showMedia_of: "ఆఫ్",
    showMedia_previous: "మునుపటి",

    //contentShare - showquestions
    showQues_min_left: "నిమిషం మిగిలి ఉంది",
    showQues_completed_test: "మీరు ఈ ప్రశ్నపత్రంలో పరీక్షను పూర్తి చేసారు.",
    showQues_go_back_content_group: "కంటెంట్ సమూహానికి తిరిగి వెళ్ళు",
    //contentShare - viewUserScore
    viewUserScore_view_score: "స్కోరును చూడండి",
    viewUserScore_total_marks: "మొత్తం మార్కులు:",
    viewUserScore_scored_marks: "స్కోరు మార్కులు:",
    viewUserScore_GPA_score: "మీ GPA స్కోరు:",
    viewUserScore_below_list_of_answer:
      "ఈ కంటెంట్ సమూహం యొక్క అన్ని ప్రశ్నాపత్రాల సమాధానాల జాబితా క్రింద ఇవ్వబడింది.",
    viewUserScore_answered: "సమాధానం",
    viewUserScore_correct_answer: "సరైన సమాధానము",

    //schedule - components
    //ConfirmCancelInvite
    confCancle_confirmation: "నిర్ధారణ",
    confCancle_are_you_sure: "మీరు చెప్పేది నిజమా?",
    confCancle_delete_user: "వినియోగదారుని తొలగించండి",
    //confirmscheduledelete
    confSche_are_you_sure_delete:
      "మీరు ఖచ్చితంగా ఈ షెడ్యూల్‌ను తొలగించాలనుకుంటున్నారా?",
    confSche_no: "తోబుట్టువుల",
    //PastMeetingitem
    // "pastMtnItem_rn" : "RN",
    // "pastMtnItem_room_name" : "గది పేరు: ",
    // "pastMtnItem_webinar_list" : "వెబ్నార్ జాబితా",
    // "pastMtnItem_list_webinar" : "వెబ్‌ఇనార్ల జాబితా క్రింద ఉన్నాయి.",
    // "pastMtnItem_today" : "నేడు",
    // "pastMtnItem_webinar_title_falls" : "వెబ్‌నార్ శీర్షిక ఇక్కడ వస్తుంది",
    // "pastMtnItem_view" : "చూడండి ",
    // "pastMtnItem_upcoming" : "రాబోయే",

    //SchedulesView
    //"scheView_edit_content" : "కంటెంట్‌ను సవరించండి",
    scheView_scheduled_by: "దీని ద్వారా షెడ్యూల్ చేయబడింది: ",
    scheView_delete: "తొలగించు",
    scheView_download_calander: "కాలాండర్ డౌన్లోడ్",
    scheView_invite_participants: "పాల్గొనేవారిని ఆహ్వానించండి",
    scheView_start_conference: "కాన్ఫరెన్స్ ప్రారంభించండి",
    scheView_event_details: "ఈవెంట్ వివరాలు",
    scheView_room_name: "గది పేరు",
    scheView_minutes: "నిమిషాలు",
    scheView_conference_password: "కాన్ఫరెన్స్ పాస్వర్డ్",
    scheView_settings: "సెట్టింగులు",
    scheView_webinar_event: "వెబ్నార్ ఈవెంట్",
    scheView_list_webinar:
      "ఈ వెబ్‌నార్ ఈవెంట్‌ను instavc.com/webinar లో జాబితా చేయండి మరియు రిజిస్ట్రేషన్లను అంగీకరించండి. ",
    scheView_guest_login_anonymous: "అతిథి అనామకంగా లాగిన్ అవ్వవచ్చు",
    scheView_allow_invities:
      "సమావేశంలో చేరడానికి ఆహ్వానాలను మాత్రమే అనుమతించండి",
    scheView_enable_webinar_chat: "వెబ్‌నార్ చాట్‌ను ప్రారంభించండి",
    scheView_enable_hand_rise: "వెబ్‌నార్‌లో హ్యాండ్ రైజ్‌ను ప్రారంభించండి",
    scheView_list_of_people_invited:
      "ఆహ్వానించబడిన వ్యక్తుల జాబితా క్రింద ఉంది",
    scheView_alert_err_to_join: "చేరడానికి లోపం",
    //WebinarDetails
    webnrDtls_upcoming_webinar_room:
      "ఈ గది కోసం రాబోయే వెబ్‌నార్ క్రింద ఉన్నాయి.",
    // Webinar 1
    // Webinar 2
    // Webinar 3
    webnrDtls_webinar_details: "వెబ్నార్ వివరాలు",
    webnrDtls_webinar_list: "వెబ్నార్ల జాబితా",
    webnrDtls_webinar_title: "వెబ్నార్ శీర్షిక",
    webnrDtls_webinar_title_falls: "వెబ్నార్ శీర్షిక ఇక్కడ వస్తుంది",
    webnrDtls_get_more_joining: "ఈ వెబ్‌నార్‌లో చేరడం ద్వారా మరిన్ని పొందండి.",
    webnrDtls_join_webinar: "వెబ్‌నార్‌లో చేరండి",
    //webinarList
    webnrList_webinar_list: "వెబ్నార్ జాబితా",
    webnrList_below_list_of_webinar: "క్రింద వెబ్నార్ల జాబితా ఉంది.",
    webnrList_today: "నేడు",
    webnrList_webinar_title_falls: "వెబ్‌నార్ శీర్షిక ఇక్కడ వస్తుంది",
    webnrList_view: "చూడండి",
    webnrList_upcoming: "రాబోయే",

    //schedule -
    //AddressBook
    addBook_address_book: "చిరునామా పుస్తకం",
    addBook_contact: "కాంటాక్ట్స్",
    addBook_add_contact_to_meeting:
      "మీ చిరునామా పుస్తక పరిచయాల నుండి పరిచయాలను సెషన్‌కు జోడించండి ",
    //MeetingList
    meetingList_past_meetings: "గత సెషన్‌లు",
    meetingList_past_meetings_list: "గత సెషన్ల జాబితా",
    meetingList_room_name: "గది పేరు: ",
    meetingList_view_content: "కంటెంట్‌ను చూడండి",
    meetingList_recording: "రికార్డింగ్స్",
    meetingList_view: "చూడండి",
    //scheduleInvite
    scheInvt_err_invalid_id: "చెల్లని ఇమెయిల్ ఐడి",
    scheInvt_invite_participants: "పాల్గొనేవారిని ఆహ్వానించండి",
    scheInvt_address_book: "చిరునామా పుస్తకం",
    scheInvt_invite_people_to_meeting:
      "ఈ సెషన్‌కు వ్యక్తులను ఆహ్వానించండి. మీ చిరునామా పుస్తకం నుండి లేదా ఇమెయిల్ చిరునామాను టైప్ చేయడం ద్వారా వ్యక్తులను జోడించండి. ",
    scheInvt_start: "ప్రారంభమవుతుంది @",
    scheInvt_below_list_of_answer:
      "ఈ కంటెంట్ సమూహం యొక్క అన్ని ప్రశ్నపత్రాల సమాధానాల జాబితా క్రింద ఇవ్వబడింది. ",
    scheInvt_host: "హోస్ట్:",
    scheInvt_minutes: "నిమిషాలు",
    //Webinar 1
    scheInvt_add: "చేర్చు",
    scheInvt_no_participants_added: "పాల్గొనేవారు ఎవరూ జోడించబడలేదు",
    scheInvt_add_ppl_to_meetings:
      "ఈ సెషన్‌కు వ్యక్తులను మీ అడ్రస్ బుక్ నుండి పార్టిసిపెంట్‌లుగా జోడించండి లేదా శోధన ద్వారా వారిని జోడించండి.",
    scheInvt_send_invitation: "ఆహ్వానం పంపండి",
    scheInvt_send_passcodes: "పాస్‌కోడ్‌లను ప్రత్యేక మెయిల్‌లో పంపండి.",

    //documentShare
    //index,js
    docShare_doc_sharing: "పత్ర భాగస్వామ్యం",
    docShare_upload_doc_system_pdf:
      "మీ సిస్టమ్ నుండి పత్రాన్ని అప్‌లోడ్ చేయండి, ఇది .pdf, Excel, వర్డ్ డాక్యుమెంట్‌కు మద్దతు ఇస్తుంది. ",
    //Invitation - component - invitationbody
    invitBody_invite_only_upto: "మీరు 10 మంది వరకు మాత్రమే ఆహ్వానించగలరు",
    invitBody_invite_ppl_meeting_email_add:
      "ఈ సెషన్‌కు వ్యక్తులను ఆహ్వానించండి, మీ చిరునామా పుస్తకం నుండి వ్యక్తులను జోడించండి లేదా ఇమెయిల్ చిరునామా ద్వారా జోడించండి.",
    invitBody_copy: "అనుకరణ",
    invitBody_enter_emailid: "ఇమెయిల్ ID ని నమోదు చేయండి",
    invitBody_close: "దగ్గరగా",
    invitBody_send_invitation: "ఆహ్వానం పంపండి",

    docShare_upload_doc: "పత్రాన్ని అప్‌లోడ్ చేయండి",
    docShare_no_doc: "పత్రాలు లేవు",
    docShare_no_doc_in_list: "జాబితాలో ఇంకా పత్రాలు జోడించబడలేదు.",
    docShare_add_doc: "పత్రాలు జోడించబడ్డాయి",
    docShare_alert_title_doc: "దయచేసి పత్రం యొక్క శీర్షికను నమోదు చేయండి",
    docShare_alert_something_went_wrong:
      "ఏదో తప్పు జరిగింది దయచేసి మళ్ళీ ప్రయత్నించండి",
    //components - PermitDocShare
    permitDocShr_permit_doc_share_access:
      "పత్ర భాగస్వామ్య ప్రాప్యతను అనుమతించండి",
    permitDocShr_req_permission_doc_share:
      "పత్ర వాటాను యాక్సెస్ చేయడానికి అనుమతి కోరింది",
    permitDocShr_deny: "తిరస్కరించు",
    permitDocShr_allow: "అనుమతించు",
    //components - RequestDocShare
    reqDocShr_req_doc_share_access:
      "డాక్యుమెంట్ షేర్ యాక్సెస్ కోసం అభ్యర్థించండి",
    reqDocShr_access_permission_host:
      "పత్ర భాగస్వామ్యాన్ని ప్రారంభించడానికి, మీకు హోస్ట్ నుండి యాక్సెస్ అనుమతి అవసరం.",
    reqDocShr_plz_wait: "దయచేసి వేచి ఉండండి",
    reqDocShr_permission_start_doc_share:
      "పత్రం భాగస్వామ్యాన్ని ప్రారంభించడానికి (హోస్ట్) అనుమతి.",
    reqDocShr_doc_share: "పత్రం భాగస్వామ్యం!",
    //components - ShowDocument View
    showDocViewback: "తిరిగి",
    showDocViewdoc_title_name: "పత్రం శీర్షిక పేరు",
    showDocViewnext: "తరువాత",
    showDocViewprevious: "మునుపటి",

    //Broadcast -
    //boradcastScreenShare
    borcstScreen_alert_unsupported:
      "మద్దతు లేని ఆట ఆర్డర్ అభ్యర్థించబడింది. మద్దతు ఉన్న ఫార్మాట్‌లు webrtc మరియు hls. PlayOrder = webrtc, hls వంటి వాటిని ఉపయోగించండి",
    borcstScreen_alert_no_stream_spec:
      "స్ట్రీమ్ పేర్కొనబడలేదు. దయచేసి url కు ఐడి = {STREAM_ID add జోడించండి",
    borcstScreen_Plz_enable_js:
      "ఈ వీడియోను చూడటానికి దయచేసి జావాస్క్రిప్ట్‌ను ప్రారంభించండి మరియు వెబ్ బ్రౌజర్‌కు అప్‌గ్రేడ్ చేయడాన్ని పరిగణించండి ",
    borcstScreen_support_HTML5: "HTML5 వీడియోకు మద్దతు ఇస్తుంది",
    borcstScreen_steam_play_when_live:
      "వీడియో ప్రసారం ప్రత్యక్షంగా ఉన్నప్పుడు ప్లే అవుతుంది ",
    //broadcast
    broadcast_alert_unsupported:
      "మద్దతు లేని ఆట ఆర్డర్ అభ్యర్థించబడింది. మద్దతు ఉన్న ఫార్మాట్‌లు webrtc మరియు hls. PlayOrder = webrtc, hls ",
    broadcast_alert_no_stream_spec:
      "స్ట్రీమ్ పేర్కొనబడలేదు. దయచేసి url కు? Id = {STREAM_ID add ను జోడించండి ",
    broadcast_enter_your_name: "దయచేసి మీ పేరు నమోదు చేయండి",
    broadcast_enter_your_email: "దయచేసి మీ ఇమెయిల్‌ను నమోదు చేయండి",
    broadcast_user_details: "వినియోగదారు వివరాలు",
    broadcast_submit_next: "సమర్పించండి",
    broadcast_Plz_enable_js:
      "ఈ వీడియోను చూడటానికి దయచేసి జావాస్క్రిప్ట్‌ను ప్రారంభించండి మరియు వెబ్ బ్రౌజర్‌కు అప్‌గ్రేడ్ చేయడాన్ని పరిగణించండి ",
    broadcast_support_HTML5: "HTML5 వీడియోకు మద్దతు ఇస్తుంది",
    broadcast_steam_play_when_live:
      "వీడియో ఆవిరి ప్రత్యక్షంగా ఉన్నప్పుడు ప్లే అవుతుంది",
    //broadcastConference
    brdcstConf_whiteboard: "వైట్బోర్డ్",
    brdcstConf_screen_share: "స్క్రీన్ షేర్",
    // "brdcstConf_participants" : "పాల్గొనే",
    brdcstConf_broadcast: "ప్రసార",
    brdcstConf_right: "కుడి",
    //broadcast - component
    //broadcasterParicipants
    brdcstPart_broadcast_list: "బ్రాడ్‌కాస్టర్ జాబితా",

    //Containers - calender
    //index
    calender_scheduled_calendar: "షెడ్యూల్ క్యాలెండర్",
    calender_select_all: "అన్ని ఎంచుకోండి",
    calender_calender: "క్యాలెండర్",
    calender_daily: "డైలీ",
    calender_weekly: "వారానికి",
    calender_month: "నెల",
    calender_today: "నేడు",

    //Dashboard - componenet

    //MeetingReminder
    meetReminder_scheduled_confirm: "షెడ్యూల్ నిర్ధారణ",
    meetReminder_meeting_has_been_scheduled:
      "ఈ సమయంలో తదుపరి సెషన్ షెడ్యూల్ చేయబడింది",
    meetReminder_start_meeting: "ఈ సెషన్‌ను ప్రారంభించండి",
    meetReminder_join_meeting: "ఈ సెషన్‌లో చేరండి",
    meetReminder_quick_start_another_meeting:
      "మరొక సెషన్‌ను త్వరగా ప్రారంభించండి",
    //MyMeetingItem
    myMeetItem_start: "ప్రారంభం",
    myMeetItem_for: "కోసం",
    myMeetItem_minutes: "నిమిషాలు",
    myMeetItem_host: "హోస్ట్:",
    //MyMeeting
    myMeet_my_meetings: "నా సెషన్స్",
    myMeet_search_my_meetings: "నా సెషన్‌లను శోధించండి",
    //NoScheduledMeeting
    noScheMeet_no_meeting_scheduled: "సెషన్‌లు ఏవీ షెడ్యూల్ చేయబడలేదు",
    noScheMeet_no_upcoming_meetings:
      "మీకు ఇంకా రాబోయే సెషన్‌లు ఏవీ షెడ్యూల్ చేయబడలేదు. మీరు కొత్త షెడ్యూల్‌ని సృష్టించవచ్చు లేదా మీ సమావేశాన్ని ఇప్పుడే త్వరగా ప్రారంభించవచ్చు.",
    noScheMeet_create_schedule: "షెడ్యూల్ సృష్టించండి",
    noScheMeet_quick_start: "త్వరగా ప్రారంభించు",
    noScheMeet_or: "లేక",
    //RoomSettings
    roomSet_alert_select_license: "దయచేసి లైసెన్స్ ఎంచుకోండి",
    roomSet_manage_licenses: "లైసెన్స్‌లను నిర్వహించండి",
    roomSet_package: "ప్యాకేజీ",
    roomSet_no_of_rooms: "గదుల సంఖ్య",
    roomSet_no_of_user: "వినియోగదారుల సంఖ్య",
    roomSet_purchased_on: "కొనుగోలు చేశారు",
    roomSet_expired_on: "గడువు ముగిసింది ",
    roomSet_create_room: "గదిని సృష్టించండి",

    //conference - component
    //AddSipDevice
    addSipDev_add_sip_details: "SIP వివరాలను జోడించండి",
    addSipDev_sip_address: "SIP చిరునామా: ",
    addSipDev_connect: "కనెక్ట్",
    addSipDev_enter_sip_address: "SIP చిరునామాను నమోదు చేయండి ",
    //ConfNotification
    confNotf_notification: "ప్రకటనలు",
    confNotf_user_name: "వినియోగదారు పేరు",
    confNotf_want_to_join: "ఈ సెషన్ రూమ్‌లో చేరాలనుకుంటున్నాను.",
    confNotf_allow: " అనుమతించు ",
    confNotf_deny: "తిరస్కరించు",
    confNotf_ask_question: "ఒక ప్రశ్న అడిగారు.",
    confNotf_send_msg_lobby: "లాబీ నుండి సందేశం పంపారు.",
    //Loddy
    lobby_participants_loddy: "లాబీలో పాల్గొనేవారు",
    lobby_pramote_all: "అందరినీ ప్రోత్సహించండి ",
    lobby_user_name: "వినియోగదారు పేరు",
    //RemoveUserDialog
    removeUserDlg_manage_user_selecting:
      "ఈ ఎంపికలలో దేనినైనా ఎంచుకోవడం ద్వారా ఈ వినియోగదారుని నిర్వహించండి:",
    removeUserDlg_user_name: "వినియోగదారు పేరు",
    removeUserDlg_block_participant: "పాల్గొనేవారిని నిరోధించండి",
    removeUserDlg_send_to_lobby: "లాబీకి పంపండి",
    removeUserDlg_remote_participant: "పాల్గొనేవారిని తొలగించండి ",
    removeUserDlg_close: "దగ్గరగా",
    //participantsList
    PartList_participants_in_lobby: "లాబీలో పాల్గొనేవారు ",
    PartList_alert_something_went_wrong:
      "ఏదో తప్పు జరిగింది, దయచేసి మళ్ళీ ప్రయత్నించండి",
    PartList_in_webinar: "వెబ్‌నార్‌లో",
    PartList_promote_all: "అందరినీ ప్రోత్సహించండి",
    //participants2020	Retry
    //WaitingRoom
    waitingRoom_waiting_room: "వేచివుండు గది",
    waitingRoom_plz_wait_host_allow:
      "సమావేశంలో చేరడానికి హోస్ట్ మిమ్మల్ని అనుమతించే వరకు వేచి ఉండండి. ",
    waitingRoom_chat: "చాట్",
    waitingRoom_mins: "నిమిషాలు",
    waitingRoom_no_msg_yet: "సందేశాలు లేవు, ఇంకా!",
    waitingRoom_no_msg_from_host: "హోస్ట్ నుండి సందేశాలు లేవు.",
    //userRemoved
    userRemoved_you_removed_by_host:
      "మీరు పాల్గొనేవారి జాబితా నుండి హోస్ట్ ద్వారా తొలగించబడ్డారు ",
    //invitationSlide
    invitSlide_invite: "ఆహ్వానించండి",
    invitSlide_add_email: "ఇమెయిల్‌లను జోడించండి",
    invitSlide_add: "చేర్చు",
    invitSlide_broadcast_list: "ప్రసార లింక్",
    invitSlide_invite_people_to_meeting:
      "ఈ సెషన్‌కు వ్యక్తులను ఆహ్వానించండి. వ్యక్తుల ఇమెయిల్ చిరునామాను టైప్ చేయడం ద్వారా వారిని జోడించండి మరియు ఆహ్వానాన్ని పంపడానికి జాబితాకు జోడించండి.",
    invitSlide_err_invalid_id: "చెల్లని ఇమెయిల్ ఐడి",
    //participantsChat
    particiChat_no_chat_msg: "ఇంకా చాట్ సందేశాలు లేవు!",
    particiChat_start_conversation:
      "ఇక్కడ సందేశాలను చూడటానికి సంభాషణను ప్రారంభించండి.",

    //components - lobbyparticipants
    lobbyPartici_no_participants: "పాల్గొనేవారు లేరు",
    lobbyPartici_no_participants_lobby: "లాబీలో పాల్గొనేవారు లేరు",

    //conference
    //simulcast
    simulcast_alert_decline_access: "హోస్ట్ ప్రాప్యతను తిరస్కరించింది",
    simulcast_invalid_url: "చెల్లని URL",
    simulcast_no_host_available:
      "ఈ సమయంలో హోస్ట్ అందుబాటులో లేదనిపిస్తోంది, దయచేసి స్క్రీన్‌ను భాగస్వామ్యం చేయడానికి హోస్ట్ అవ్వండి ",
    //simulcastVAD & // Conference.js
    conference_access_to_participants: "పాల్గొనేవారికి ప్రాప్యత",
    conference_screen_share: "స్క్రీన్ షేర్",
    conference_chat: "కబుర్లు",
    conference_lock_all: "అన్నీ లాక్ చేయండి",
    conference_lock_conf: "లాక్ కాన్ఫరెన్స్e",
    conference_become_host: "హోస్ట్ అవ్వండి",
    conference_you_are_host: "మీరు హోస్ట్",
    conference_share: "వంతు",
    conference_document_share: "పత్రం భాగస్వామ్యం",
    conference_content_share: "కంటెంట్ భాగస్వామ్యం ",
    conference_more: "మరింత...",
    conference_become_host: "హోస్ట్ అవ్వండి ",
    conference_alert_no_host_aval_screen:
      "ఈ సమయంలో హోస్ట్ అందుబాటులో లేదనిపిస్తోంది, దయచేసి స్క్రీన్‌ను భాగస్వామ్యం చేయడానికి హోస్ట్ అవ్వండి ",
    conference_alert_no_host_aval_screen:
      " ఈ సమయంలో హోస్ట్ అందుబాటులో లేదనిపిస్తోంది, దయచేసి స్క్రీన్‌ను భాగస్వామ్యం చేయడానికి హోస్ట్ అవ్వండి ",
    conference_alert_no_host_aval_doc:
      " ఈ సమయంలో హోస్ట్ అందుబాటులో లేదనిపిస్తోంది, దయచేసి పత్రాన్ని భాగస్వామ్యం చేయడానికి హోస్ట్ అవ్వండి ",
    conference_alert_err_sip_device:
      " సిప్ పరికరాన్ని కనెక్ట్ చేస్తున్నప్పుడు లోపం",
    conference_alert_host_decline_access: " హోస్ట్ ప్రాప్యతను తిరస్కరించింది ",
    conference_alert_invalid_url: "చెల్లని URL",
    conference_unmute_mic_start_talk:
      " మాట్లాడటం ప్రారంభించడానికి మీ మైక్రోఫోన్‌ను అన్‌మ్యూట్ చేయండి",

    // tools
    confTools_new_whiteboard: " మీ క్రొత్త వైట్‌బోర్డ్ ఇక్కడకు వస్తుంది",
    confTools_video_sync: "మీ వీడియో సమకాలీకరణ ",
    confTools_microphone: " మీ వీడియో సమకాలీకరణ",
    confTools_type_text_here: "మీ వచనాన్ని టైప్ చేయండి ...",
    whiteboard: " వైట్బోర్డ్",

    //meetingRecording
    meetRec_video_rec_meeting_name: "సెషన్ పేరు యొక్క వీడియో రికార్డింగ్‌లు",
    meetRec_page_view: "పేజీ వీక్షణ:",

    //meetingRecording- recordinglistview
    recListView_title_name_rec: "రికార్డింగ్ యొక్క శీర్షిక పేరు ",
    recListView_name_user: "వినియోగదారు పేరు ",

    //Src
    //component - common - BrowserUpgrade
    brwUpg_req_fun_not_avail:
      "అవసరమైన కార్యాచరణ మీ బ్రౌజర్‌లో అందుబాటులో లేదు ",
    brwUpg_meeting_req_fun_sup:
      "ఈ సెషన్ సేవకు మీ బ్రౌజర్ మద్దతు లేని ఫంక్షనలిస్ట్ అవసరం.",
    brwUpg_plz_upgrade:
      " దయచేసి అప్‌గ్రేడ్ చేయండి, వేరే బ్రౌజర్‌కు మారండి లేదా మీ సెట్టింగ్‌లను తనిఖీ చేయండి. మద్దతు ఉన్న బ్రౌజర్‌లు:",
    //"    Samsung Internet
    //component - common - header - header.js
    header_content: " కంటెంట్",
    header_loading: " లోడ్...",

    //containers/admin/plans/components/createPlan.js
    crtePln_plz_enter_name: "దయచేసి ప్రణాళిక పేరును నమోదు చేయండి ",
    crtePln_plz_amount_Plan: "దయచేసి ప్రణాళిక మొత్తాన్ని నమోదు చేయండి ",
    crtePln_plz_enter_des: "దయచేసి వివరణను నమోదు చేయండి ",
    crtePln_Plz_sel_product: " దయచేసి ఉత్పత్తిని ఎంచుకోండి",

    crtePln_plz_sel_no_host: "దయచేసి సంఖ్యను ఎంచుకోండి. అతిధేయల ",
    crtePln_plz_enter_no_participants:
      "దయచేసి సంఖ్యను నమోదు చేయండి. పాల్గొనేవారి ",
    crtePln_plz_enter_roomno: " దయచేసి సంఖ్యను నమోదు చేయండి. గదులు",
    crtePln_select_period: "దయచేసి వ్యవధిని ఎంచుకోండి ",
    crtePln_sel_interval: " దయచేసి విరామం ఎంచుకోండి",
    crtePln_update_succ: "విజయవంతంగా నవీకరించబడింది ",
    crtePln_err_creating_plan: "ప్రణాళికను రూపొందించడంలో లోపం ",

    //containers/broadcast/components/BroadcastHandRaise.js
    brdcRaise_alert_question_50_char:
      "మీ ప్రశ్నకు కనీసం 50 అక్షరాల చాట్ ఉండాలి ",
    //containers/conference/components/components
    cofCom_no_part_lobby: "లాబీలో పాల్గొనేవారు లేరు.",
    //containers/conference/components/ConfirmUserDetails.js
    confmUser_plz_provide_name_email:
      "దయచేసి మీ పేరు మరియు ఇమెయిల్‌ను అందించండి ",
    confmUser_notes: "గమనికలు ",
    //containers/conference/ConferenceSetup.js
    confSetup_telepresence: " టెలీప్రెజెన్స్",
    confSetup_alert_not_generate_meetingID:
      "సెషన్ ఐడిని రూపొందించడం సాధ్యం కాలేదు, కొంత సమయం తర్వాత ప్రయత్నించండి",
    confSetup_auth_part_can_join: "అధీకృత పాల్గొనేవారు మాత్రమే చేరవచ్చు!",
    confSetup_invalid_link: "చెల్లని లింక్ ",
    confSetup_meeting_notyet_started:
      "ఈ సెషన్ ఇంకా ప్రారంభం కాలేదు. దయచేసి తర్వాత చేరండి!. మీరు హోస్ట్ అయితే, దయచేసి instaVCకి లాగిన్ చేసి సమావేశాన్ని ప్రారంభించండి",
    confSetup_meeting_locked_byhost: "ఈ సెషన్ హోస్ట్ ద్వారా లాక్ చేయబడింది",
    confSetup_meeting_notyet_started_wait_host:
      " ఈ సెషన్ ఇంకా ప్రారంభం కాలేదు. దయచేసి హోస్ట్ సెషన్‌ను ప్రారంభించే వరకు వేచి ఉండండి!",
    //containers/conference/components/NewChat.js" " కొత్త చార్ట్ ప్యానెల్ చాట్" : "

    //containers/conference/libs/InstaVC.js
    instaVc_server_busy:
      "సర్వర్ బిజీగా ఉంది! మరొక సర్వర్‌ను కనెక్ట్ చేయడానికి ప్రయత్నిస్తోంది ...",
    //load-messge

    instaVc_server_busy_reload_tojoin:
      " సర్వర్ బిజీగా ఉంది! మరొక సర్వర్‌ను కనెక్ట్ చేయడానికి ప్రయత్నిస్తోంది ...",
    instaVc_broadcast_failed: " ప్రసారం విఫలమైంది",
    instaVc_waiting_for_host: " హోస్ట్ వీడియో కోసం వేచి ఉంది",
    //containers/content/components/contentQuestionnaire/modal-create-quest-group.js
    modlCreate_plz_enter_title: "దయచేసి శీర్షికను నమోదు చేయండి ",
    modlCreate_poll: "ఎన్నికలో ",
    //containers/content/components/contentQuestionnaire/modal-create-poll-question.js
    poll_submitted: "పోల్ విజయవంతంగా సమర్పించబడింది.",
    mdlCretPoll_plz_enter_quest: " దయచేసి ప్రశ్నను నమోదు చేయండి",
    mdlCretPoll_option_should_not_same: " ఎంపికలు ఒకేలా ఉండకూడదు ",
    mdlCretPoll_plz_enter_option: " దయచేసి ఎంపికలను నమోదు చేయండి",
    mdlCretPoll_plz_select_type_option: " దయచేసి ఎంపికల రకాన్ని ఎంచుకోండి",
    alert_server_error: " అంతర్గత సర్వర్ లోపం, దయచేసి మళ్ళీ ప్రయత్నించండి",
    mdlCretPoll_update_ques: "పోల్ ప్రశ్నలను నవీకరించండి ",
    mdlCretPoll_create_ques: "ప్రశ్న సృష్టించండి ",
    mdlCretPoll_enter_que_here: "మీ ప్రశ్నను ఇక్కడ నమోదు చేయండి ",
    mdlCretPoll_end: "ముగింపు ",
    //containers/content/components/contentQuestionnaire/viewQuestionnaire.js
    delete_successfully: "విజయవంతంగా తొలగించబడింది ",

    //containers/content/components/hozContentNavBlock.js / managecontent-index.js
    // "mngContent_mngContent_content" : "విషయము ",
    // "mngContent_mngContent_participants" : "పాల్గొనేవారు ",
    mngContent_mngContent_fav_prog_lang:
      "మీకు ఇష్టమైన ప్రోగ్రామింగ్ భాష ఏమిటి?",
    mngContent_mngContent_pollings: "పోలింగ్ ",

    //containers/contentShare/showQuestions.js
    showQue_obtained_marks: "పొందిన మార్కులు:",
    //containers/contentShare/viewUserScore.js
    viewUser_your_grade: "మీ గ్రేడ్:",
    //containers/packages/Package.js
    package_one_host: "1 హోస్ట్ మరియు ",
    //"package_participants" : "పాల్గొనేవారు ",
    // SOHO
    //"    SMB 300
    package_concurrentUser_room2: "20 ఉమ్మడి వినియోగదారులు - 2 గదులు",
    package_concurrentUser_room5: "30 ఉమ్మడి వినియోగదారులు -5 గదులు",
    package_concurrentUser_room20: "100 ఏకకాలిక వినియోగదారులు - 20 గదులు",
    package_concurrentUser_room30: "200 ఏకకాలిక వినియోగదారులు - 30 గదులు",
    package_concurrentUser_room50: "500 ఏకకాలిక వినియోగదారులు - 50 గదులు",

    //containers/schedule/components/PastMeetingItem.js

    pastMeeting_rn: "RN",
    pastMeeting_chat_history_deleted: "చాట్ చరిత్ర విజయవంతంగా తొలగించబడింది",
    pastMeeting_past_meeting_dtls: "గత సెషన్ వివరాలు",
    pastMeeting_duration: "వ్యవధి",
    pastMeeting_download_parti_atten:
      "పాల్గొనేవారు మరియు హాజరైన వారిని డౌన్‌లోడ్ చేయండి",
    pastMeeting_download_webinar: "వెబ్‌నార్‌ను డౌన్‌లోడ్ చేయండి",
    // "pastMeeting_participants" : "పాల్గొనేవారు"
    pastMeeting_attendees: "హాజర్",
    pastMeeting_chat_history: "చాట్ చరిత్ర",
    pastMeeting_recordings: "రికార్డింగ్స్",
    pastMeeting_webinar_user: "వెబ్నార్ యూజర్ల",
    pastMeeting_webinar_chat: "వెబ్నార్ చాట్ ",
    pastMeeting_no_participants_in_meeting: "ఈ సెషన్‌లో పాల్గొనేవారు లేరు!",
    pastMeeting_no_parti_attended_meeting:
      "ఈ సెషన్‌కు హాజరైన పాల్గొనేవారు లేరు. ",
    pastMeeting_guest_list: "అతిథుల జాబితా",
    pastMeeting_no_guest_in_meeting: "ఈ సెషన్‌లో అతిథులు లేరు!",
    "pastMeeting_no_guests_were_invited ":
      "ఈ సెషన్‌కు ఆహ్వానించబడిన లేదా హాజరైన అతిథులు ఎవరూ లేరు.",
    pastMeeting_meeting_chat_history: "సెషన్ చాట్ చరిత్ర",
    pastMeeting_delete_all: "అన్నిటిని తొలిగించు",
    pastMeeting_no_chat_msg_inmeeting: "ఈ సెషన్‌లో చాట్ సందేశాలు లేవు! ",
    pastMeeting_no_conver_during_meeting: "సెషన్ సమయంలో చాట్‌లో సంభాషణలు లేవు.",
    pastMeeting_no_user_inwebinar: "ఈ వెబ్‌నార్‌లో వినియోగదారులు లేరు!",
    pastMeeting_no_user_attand_webinar:
      "ఈ వెబ్‌నార్‌కు హాజరైన వినియోగదారులు ఎవరూ లేరు",
    pastMeeting_webinar_chat_history: "వెబ్నార్ చాట్ చరిత్ర",
    pastMeeting_no_chat_msg_inwebinar: "ఈ వెబ్‌నార్‌లో చాట్ సందేశాలు లేవు!",
    pastMeeting_no_conver_during_webinar:
      "వెబ్‌నార్ సమయంలో చాట్‌లో సంభాషణలు లేవు.",
    pastMeeting_del_chat_history: "చాట్ చరిత్రను తొలగించు",
    pastMeeting_delete_all_chat_history:
      " మీరు ఖచ్చితంగా, మీరు అన్ని చాట్ చరిత్రను శాశ్వతంగా తొలగించాలనుకుంటున్నారా? ",

    pastMeeting_delete: "తొలగించు",
    //containers/schedule/components/Schedules.js
    schedul_webinar_description: "వెబ్నార్ వివరణ",
    schedul_upload_custom_banner:
      "మీ వెబ్‌నార్ ఈవెంట్ కోసం అనుకూల బ్యానర్‌ను అప్‌లోడ్ చేయండి. ",
    schedul_setting: "సెట్టింగులు",
    //containers/schedule/components/SchedulesView.js
    schedulView_time: "టైమ్",
    schedulView_edit: "సవరించు",
    schedulView_enable_training_mode: "శిక్షణ మోడ్‌ను ప్రారంభించండి",
    schedulView_audio_conference: "ఆడియో సమావేశం",
    schedulView_enable_mix_video: "డిఫాల్ట్‌గా మిక్స్ వీడియోను ప్రారంభించండి ",

    //class components
    //content - components - hozContentNavBlock
    // "hozConNav_content" : "విషయము"
    //scheduleMeeting
    scheMeet_room_reserved_from: "నుండి గది రిజర్వు చేయబడింది",
    scheMeet_meeting_name: "సెషన్ పేరుతో ",

    //dashboard - component -Contact
    contact_alert_already_in_call:
      "మీరు ఇతర వినియోగదారుని పిలవలేరు, మీరు ఎప్పుడు కాల్‌లో ఉన్నారు ",
    contact_alert_user_offline: "యూజర్ ఆఫ్‌లైన్",

    //dashboard - dashboard.js
    dashboard_alert_cannot_start:
      "మీరు ఇతర కాల్‌లో ఉన్నప్పుడు సమావేశాన్ని ప్రారంభించలేరు",
    dashboard_alert_cannot_join:
      "మీరు ఇతర కాల్‌లో ఉన్నప్పుడు మీరు సమావేశంలో చేరలేరు",
    dashboard_quick_start_conf: "త్వరిత ప్రారంభ సమావేశం",
    dashboard_maintenance_msg:
      "రొటీన్ మెయింటెనెన్స్ కారణంగా 2020 ఏప్రిల్ 22 న 8.30 PM IST నుండి 9.00 PM IST వరకు సర్వర్ పనితీరును మేము ఎదుర్కొంటున్నామని దయచేసి గమనించండి.",
    //coBrowsing
    "coBrows_host_share-video":
      "దయచేసి వేచి ఉండండి! హోస్ట్ వీడియోను భాగస్వామ్యం చేయబోతున్నారు",
    //Additionalcamera
    addCam_add_device: "పరికరాన్ని జోడించండి",

    // genral same lang
    answer_list: "సమాధానాల జాబితా",
    answer: "జవాబులు",
    answered: "సమాధానం",
    correct_answer: "సరైన సమాధానము",
    please_try_again: "దయచేసి మళ్ళీ ప్రయత్నించండి",
    question: "ప్రశ్న",
    cancel: "రద్దు చేయండి",
    questionnaire: "ప్రశ్నాపత్రం",
    content: "విషయము",
    address_book: "చిరునామా పుస్తకం",
    view: "చూడండి",
    rn: "RN",

    // new langs
    plz_enter_marks: "దయచేసి ప్రశ్న యొక్క గుర్తులను నమోదు చేయండి",
    plz_sel_crtans: "దయచేసి కారెంట్ జవాబును ఎంచుకోండి",
    truefalse_choice: "ట్రూ / ఫాల్స్ ఛాయిస్",
    questionnarie: "ప్రశ్నాపత్రం",
    content_title: "కంటెంట్ శీర్షిక",
    media_title: "మీడియా శీర్షిక",
    add_url_add: "URL చిరునామాను జోడించండి ... ",
    val_shuld_grtr_from_val: "విలువ నుండి విలువ కంటే ఎక్కువగా ఉండాలి",
    val_shuld_grtr_grade: " విలువ నుండి గ్రేడ్ కంటే ఎక్కువగా ఉండాలి",
    to_val: "విలువకు",
    enable_hand_raise: "వెబ్‌నార్‌లో హ్యాండ్ రైజ్ / ప్రశ్న అడగండి",
    enable_waiting_room: "వెయిటింగ్ రూమ్‌ను ప్రారంభించండి",
    allow_only_invite: "సమావేశంలో చేరడానికి ఆహ్వానితులను మాత్రమే అనుమతించండి",
    guest_login_anonymous: "అతిథి అనామకంగా లాగిన్ అవ్వవచ్చు",
    give_name_webinar: "మీ వెబ్‌నార్‌కు పేరు ఇవ్వండి",
    Webinar: "Webinar",
    video_syn: "వీడియో సమకాలీకరణ",
    notepad: "నోట్ప్యాడ్లో",
    enable_handraise: "వెబ్‌నార్‌లో హ్యాండ్ రైజ్‌ను ప్రారంభించండి ",

    //new one venkatesh
    polls_list: "పోల్స్ జాబితా",
    no_poll_assign: "ఇంకా పోల్ కేటాయించబడలేదు!",
    poll_view: "పోల్ వీక్షణ",

    // new Prudhvi
    filter_block: "ఫిల్టర్ బ్లాక్",
    file_size: "ఫైల్ పరిమాణం",
    select_room: "దయచేసి గదిని ఎంచుకోండి ",
    provide_event_name: "దయచేసి ఈవెంట్ పేరు ఇవ్వండి",
    end_time_greater_start_time:
      "ముగింపు సమయం ప్రారంభ సమయం కంటే ఎక్కువగా ఉండాలి!",
    invite_people_meeting: "ఈ సెషన్‌కు వ్యక్తులను ఆహ్వానించండి",
    download_ical: "ఐకాల్‌ను డౌన్‌లోడ్ చేయండి",
    download: "డౌన్లోడ్",
    delete_meeting: "ఈ సెషన్‌ను తొలగించండి",
    room: "room",
    new_event: "క్రొత్త ఈవెంట్",
    end_repeat: "ముగింపు పునరావృతం",
    invite_users_timezone: "క్రింది సమయమండలితో వినియోగదారులను ఆహ్వానించండి",
    update_event: "ఈవెంట్‌ను నవీకరించు",
    create_event: "ఈవెంట్‌ను సృష్టించండి",
    wrong_password: "సరియినది కాని రహస్య పదము",
    college: "కాలేజ్",
    university: "విశ్వవిద్యాలయ",
    country: "దేశం",
    time_period: "సమయ వ్యవధి:",
    currently_working_here: "ప్రస్తుతం ఇక్కడ పనిచేస్తున్నారు",
    from: "నుండి:",
    to: "వీరికి:",
    graduated: "పట్టా",
    enter_description: "మీ వివరణను ఇక్కడ నమోదు చేయండి ...",
    concentration: "ఏకాగ్రతా",
    school: "స్కూల్",
    poll_question: "పోల్ ప్రశ్నలు",
    create_poll_ques: "పోల్ ప్రశ్నను సృష్టించండి",
    options: "ఎంపికలు",
    no_ques_assigned_yet: "ఇంకా ప్రశ్నలు కేటాయించబడలేదు! ",
    create_new_ques_click_create_ques:
      "పై ప్రశ్నలను సృష్టించు బటన్‌ను క్లిక్ చేయడానికి, క్రొత్త ప్రశ్నలను సృష్టించండి",
    enter_room_name: "దయచేసి గది పేరును నమోదు చేయండి",
    billed_annually: "* ఏటా బిల్",
    subscribe_now: "ఇప్పుడే సబ్స్క్రయిబ్ చేయండి",
    group: "గ్రూప్",
    sample_webinar: "నమూనా వెబ్‌నార్",
    webinar_affiliate: "అనుబంధాల గురించి వెబ్‌నార్",
    webinar_one: "వెబ్నార్ వన్",
    workspace: "వర్క్స్పేస్",
    company: "కంపెనీ",
    add_another: "మరొకదాన్ని జోడించు",

    join_conference_join: "చేరండి",
    instavc_meetinglist_search: "వెతకండి ...",
    Save: "రక్షించు",
    instavc_package_total: "మొత్తం",
    instavc_package_expiry: "గడువు",
    instavc_package_pay: "చెల్లింపు",
    instavc_package_specifictions_advanced:
      "వైట్‌బోర్డ్ Screen n స్క్రీన్ భాగస్వామ్యం  n చాట్  n రికార్డ్  n ప్రతినిధి మోడ్",
    newChat_panel_chat: "ప్యానెల్ చార్ట్",
    instaVc_broadcast_scr_failed: "ప్రసార స్క్రీన్ విఫలమైంది",
    pastMeeting_notes: "గమనికలు",
    assignment: "అసైన్మెంట్",
    assignments: "అసైన్",
    create_new_poll:
      "కేటాయించడం ప్రారంభించడానికి క్రొత్త పోల్ ప్రశ్నను సృష్టించండి.",
    plz_title_url: "దయచేసి శీర్షిక మరియు URL ను నమోదు చేయండి",
    votes: "ఓట్లు",
    enter_content_title: "దయచేసి కంటెంట్ శీర్షికను నమోదు చేయండి",
    failed_result: "విఫలమైన ఫలితం",
    removed_successfully: "విజయవంతంగా తొలగించబడింది",
    enter_duration: "దయచేసి వ్యవధిని నమోదు చేయండి",
    select_questionnarie: "దయచేసి ప్రశ్నపత్రాన్ని ఎంచుకోండి",
    no_assignments: "అసైన్‌మెంట్‌లు లేవు",
    create_new_assignment:
      " క్రొత్త అసైన్‌మెంట్‌ను సృష్టించండి, సృష్టించడానికి పైన క్లిక్ చేయండి అసైన్‌మెంట్ బటన్‌ను సృష్టించండి ",
    create_assignment: "అసైన్‌మెంట్‌ను సృష్టించండి",
    assignments_list: "అసైన్‌మెంట్ జాబితా",
    assignment_description: "అసైన్మెంట్ వివరణ",
    assignment_name: "అసైన్మెంట్ పేరు",
    update_assignment: "అసైన్‌మెంట్‌ను నవీకరించండి",
    add_new_assignment: "క్రొత్త అసైన్‌మెంట్‌ను జోడించు",
    assignment_list: "అసైన్‌మెంట్ జాబితా",
    assign_assignments: "అసైన్‌మెంట్‌లను కేటాయించండి",
    assigned_assignments_list: "అసైన్డ్ అసైన్‌మెంట్ జాబితా",
    assignment_answer: "అసైన్‌మెంట్ సమాధానం",
    no_assig_submitted: "ఇంకా అసైన్‌మెంట్‌లు సమర్పించబడలేదు.",
    no_assig_submitted_participants:
      "పాల్గొనేవారి నుండి ఇంకా అసైన్‌మెంట్‌లు సమర్పించబడలేదు.",
    view_assignment: "అసైన్‌మెంట్ చూడండి",
    assigned_participants: "కేటాయించిన పాల్గొనేవారు",
    select_assignment: "అసైన్‌మెంట్ ఎంచుకోండి",
    fill_your_assignment: "మీ అసైన్‌మెంట్‌ను పూరించండి",
    submit_assignment: "అసైన్‌మెంట్ సమర్పించు",
    assignment_details: "అసైన్మెంట్ వివరాలు",
    assignment_submit_success: "అసైన్‌మెంట్ విజయవంతంగా సమర్పించబడింది",
    assignment_saved_success: "అసైన్‌మెంట్ విజయవంతంగా సేవ్ చేయబడింది",
    how_to_get_started: "ఎలా ప్రారంభించాలి.",
    create_new_room: "క్రొత్త గదిని సృష్టించండి",
    create_room_add_participants:
      "క్రొత్త గదిని సృష్టించండి మరియు పాల్గొనేవారిని గదికి చేర్చండి.",
    repeats_every: "ప్రతి పునరావృతం",
    now: "ఇప్పుడు",
    Plz_enter_title_meeting: "దయచేసి సెషన్ శీర్షికను నమోదు చేయండి",
    no_start_time: "ప్రారంభ సమయం కనుగొనబడలేదు",
    no_end_time: "నో ఎండ్ టైమ్ కనుగొనబడలేదు",
    item_id_not_found: "అంశం ID కనుగొనబడలేదు",
    msg_title_not_found: "సందేశ శీర్షిక కనుగొనబడలేదు",
    plz_join_conf_clicking_link:
      "దయచేసి క్రింది లింక్‌ను క్లిక్ చేయడం ద్వారా సమావేశంలో చేరండి",
    hi_there: "హాయ్ దేర్",
    room_permanently: "గది శాశ్వతంగా?",
    sure_want_to_delete_participants:
      "మీకు ఖచ్చితంగా తెలుసా, మీరు ఈ పాల్గొనేవారిని తొలగించాలనుకుంటున్నారా?",
    delete_participant: "పాల్గొనేవారిని తొలగించు",
    add_email: "ఇమెయిల్ జోడించండి",
    add_participants_to_the_room:
      "దిగువ ఇన్‌పుట్ బాక్స్‌లో పాల్గొనే వారి ఇమెయిల్ చిరునామాను టైప్ చేయడం ద్వారా ఈ గదికి చేర్చండి.",
    no_of_users: "వినియోగదారుల సంఖ్య",
    edit_the_name:
      "మీరు పేరు మరియు ఈ గది యొక్క వినియోగదారుల సంఖ్యను సవరించవచ్చు.",
    delete_room: "గదిని తొలగించు",
    are_you_sure_delete: "మీరు తొలగించాలనుకుంటున్నారా ఖచ్చితంగా",
    delete_this_room: "ఈ గదిని తొలగించు",
    delete_room_will_parmanently:
      "తొలగించు క్లిక్ చేయడం ద్వారా, ఈ గది శాశ్వతంగా తొలగించబడుతుంది.",
    enable_storage: "నిల్వను ప్రారంభించు",
    enable_recordings: "రికార్డింగ్‌లను ప్రారంభించు",
    enable_SIP: "SIP ని ప్రారంభించండి",
    addons: "ఆడ్డన్స్",
    expires_on: "ముగుస్తుంది",
    purchased_on: "కొనుగోలు చేయబడింది",
    more_storage: "మరింత నిల్వ",
    total_storage: "మొత్తం నిల్వ",
    storage_occupied: "నిల్వ ఆక్రమించబడింది",
    added: "చేర్చబడింది",
    open_graphs: "ఓపెన్ గ్రాఫ్స్",
    participant_controls: "పాల్గొనే నియంత్రణలు",
    "dashboard_controls ": "డాష్‌బోర్డ్ నియంత్రణలు",
    start_meeting: "ఒక సెషన్ ప్రారంభించండి",
    join_a_meeting: "సెషన్‌లో చేరండి",
    meeting_settings: "సమావేశ సెట్టింగ్‌లు",
    videos_to_get_started: "ప్రారంభించడానికి వీడియోలు",
    if_you_are_host:
      "మీరు హోస్ట్ అయితే, సెషన్‌ను ప్రారంభించడానికి దిగువ బటన్‌ను క్లిక్ చేయండి",
    guest_link: "అతిథి లింక్",
    pay_now: "ఇప్పుడు చెల్లించండి",
    promo_code_apply_here: "ప్రోమో కోడ్ ఉందా? ఇక్కడ వర్తించు",
    per_month: "ఒక నెలకి",
    billed_for: "బిల్",
    gst_applicable:
      "ప్రభుత్వ నిబంధనలకు అనుగుణంగా, భారతదేశంలోని వినియోగదారులకు అదనంగా 18% జీఎస్టీ వర్తిస్తుంది.",
    select_country_code: "కంట్రీ కోడ్ ఎంచుకోండి",
    country_code: "దేశం కోడ్",
    enter_email_id: "ఇమెయిల్ ఐడిని నమోదు చేయండి ...",
    downLoad_chat: "డౌన్‌లోడ్ చాట్",
    allow_guest_control_their:
      "అతిథి వారి వీడియో / ఆడియోను నియంత్రించడానికి అనుమతించండి",
    below_list_people_invited: "ఆహ్వానించబడిన వ్యక్తుల జాబితా క్రింద ఉంది",
    verification_code: "ధృవీకరణ కోడ్",
    open_link_enter_verify_code:
      "దిగువ URL లింక్‌ను తెరిచి, ఇంటిగ్రేషన్ కోసం మీ ధృవీకరణ కోడ్‌ను నమోదు చేయండి",
    social_media_integration: "సోషల్ మీడియా ఇంటిగ్రేషన్",
    integrate_social_media_platform:
      "మీరు సోషల్ మీడియా ప్లాట్‌ఫారమ్‌లను ఏకీకృతం చేయవచ్చు, ఒక బటన్‌ను క్లిక్ చేయడం ద్వారా, మీరు ధృవీకరణ కోడ్‌ను పొందుతారు, ఇంటిగ్రేషన్ కోసం దాన్ని ఉపయోగిస్తారు.",
    plz_enter_val_email: "దయచేసి చెల్లుబాటు అయ్యే ఇమెయిల్‌ను నమోదు చేయండి",
    record: "రికార్డ్",
    in_conference: "కాన్ఫరెన్స్లో",
    password_if_any: "పాస్వర్డ్ (ఏదైనా ఉంటే)",
    stop_send: "ఆపు & పంపండి",
    broadcast_not_enabled_meeting: "ఈ సెషన్ కోసం ప్రసారం ప్రారంభించబడలేదు",
    facebook_url: "ఫేస్బుక్ URL",
    enter_facebook_url: "Facebook RTMB URL ను నమోదు చేయండి",
    add_facebook_url: "Facebook RTMP URL ని జోడించండి",
    youtube_url: "యూట్యూబ్ URL",
    enter_youtube_url: "Youtube RTMB URL ను నమోదు చేయండి",
    add_youtube_url: "Youtube RTMP URL ని జోడించండి",
    register: "నమోదు",
    time_of_program: "ప్రోగ్రామ్ సమయం",
    date_of_program: "కార్యక్రమం యొక్క తేదీ",
    name_program_interested: "ప్రోగ్రామ్ పేరు ఆసక్తి",
    email_id: "ఇమెయిల్ ఐడి",
    dob: "పుట్టిన తేది",
    applicant_address: "దరఖాస్తుదారుడి చిరునామా",
    qualification: "అర్హతలు",
    designation: "హోదా",
    org_name_address: "సంస్థ పేరు & చిరునామా",
    fullname_participant: "పాల్గొనేవారి పూర్తి పేరు",
    registration_form: "సభ్యత్వ నమోదుపత్రం",
    thanks_submitting_data: "మీ డేటాను సమర్పించినందుకు ధన్యవాదాలు",
    manage_content: "కంటెంట్‌ను నిర్వహించండి",
    API_settings: "API సెట్టింగులు",
    schedule_API: "షెడ్యూల్ API",
    image_upload_success: "చిత్రం విజయవంతంగా అప్‌లోడ్ చేయబడింది",
    less_than_10MB: "దయచేసి 10MB కన్నా తక్కువ ఫైల్‌ను అప్‌లోడ్ చేయండి",
    at_time_of_event: "ఈవెంట్ సమయంలో",
    min_5: "5 నిమిషాల ముందు",
    min_10: "10 నిమిషాల ముందు",
    min_15: "15 నిమిషాల ముందు",
    min_30: "30 నిమిషాల ముందు",
    hrs_1: "1 గంట ముందు",
    hrs_2: "2 గంట ముందు",
    day_1: "1 రోజు ముందు",
    day_2: "2 రోజుల ముందు",
    jan: "జాన్",
    feb: "Feb",
    mar: "Mar",
    apr: "Apr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    aug: "Aug",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Dec",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
    all_day: "రోజంతా",
    starts_ddmmyyyy: "మొదలవుతుంది (dd / mm / yyyy) ",
    ends_ddmmyyyy: "చివరలు (dd / mm / yyyy)",
    ddmmyyyy: "(dd/mm/yyyy)",
    by_dayweek: "రోజు / వారం నాటికి",
    never: "నెవర్",
    on_date: "తేదీ",
    alert: "హెచ్చరిక",
    multi_factor_auth: "మల్టీ ఫాక్టర్ ప్రామాణీకరణ (MFA) ను ప్రారంభించండి",
    advanced_settings: "ఆధునిక సెట్టింగులు",
    verify_Otp: "ధృవీకరించు Otp",
    resend_Otp: "OTP ను మళ్ళీ పంపు",
    otp_sent_mobile: "మీ మొబైల్ నంబర్‌కు పంపిన OTP ని నమోదు చేయండి",
    update_mobile: "మొబైల్‌ను నవీకరించు",
    verify_mobile: "మొబైల్‌ను ధృవీకరించండి",
    mob_verfi_pending: "మీ మొబైల్ ధృవీకరణ పెండింగ్‌లో ఉంది.",
    mobile_number: "మొబైల్ సంఖ్య",
    enter_Otp: "ఎంటర్ Otp",
    enter_mob_no: "దయచేసి మొబైల్ నంబర్‌ను నమోదు చేయండి",
    sure_want_to_delete_rec: "ఆర్ యు ష్యూర్ వాంట్ టి 0 డిలీట్ రికార్డింగ్",
    delete_recording: "రికార్డింగ్ తొలగించు",
    invalid_credentials: "Invalid Credentials",
    join_conf_by_clicking_link:
      "దయచేసి ఈ క్రింది లింక్‌ను క్లిక్ చేయడం ద్వారా సమావేశంలో చేరండి",
    hi_there: "హాయ్ దేర్,",
    valid_room_name: "దయచేసి చెల్లుబాటు అయ్యే గది పేరును నమోదు చేయండి",
    internal_server_error: "అంతర్గత సర్వర్ లోపం, దయచేసి మళ్ళీ ప్రయత్నించండి",
    room_limit_exceed: "గది పరిమితి మించిపోయింది",
    cant_start_meeting_already_goingon:
      "ఇప్పటికే సెషన్ జరుగుతున్నందున మీరు సెషన్‌ను ప్రారంభించలేరు.",

    //new
    social_integration: "సామాజిక సమైక్యత",
    advanced: "ఆధునిక",
    add_youtube: "Youtube ని జోడించండి",
    plugins: "ప్లగిన్లు",
    subtitles: "ఉపశీర్షికలు",
    view_local: "స్థానికంగా చూడండి",
    hide_local: "స్థానికంగా దాచు",
    switch_conf_mode: "కాన్ఫరెన్స్ మోడ్‌కు మారండి",
    switch_pres_mode: "ప్రెజెంటర్ మోడ్‌కు మారండి",
    conference_locked: "కాన్ఫరెన్స్ లాక్ చేయబడింది",
    conference_unlocked: "కాన్ఫరెన్స్ అన్‌లాక్ చేయబడింది",
    sharing_tools: "భాగస్వామ్య సాధనాలు",
    record: "రికార్డు",
    recording: "రికార్డింగ్",
    plz_wait_host_shr_video:
      "దయచేసి వేచి ఉండండి! హోస్ట్ వీడియోను భాగస్వామ్యం చేయబోతున్నారు",
    supported_sources_include: "మద్దతు ఉన్న వనరులు ఉన్నాయి",

    team_plugins: "జట్టు ప్లగిన్లు",
    open: "ఓపెన్",
    click: "క్లిక్",
    more_app: "మరిన్ని అనువర్తనాలు",
    upload_custom_app: "అనుకూల అనువర్తనాన్ని అప్‌లోడ్ చేయండి",
    download_team_plugin: "జట్టు ప్లగిన్‌ను డౌన్‌లోడ్ చేయండి",
    install_mng_app_microsoft_team:
      "మైక్రోసాఫ్ట్ జట్లలో అనువర్తనాన్ని ఎలా ఇన్‌స్టాల్ చేయాలి మరియు నిర్వహించాలి",
    microsoft_step1: "దశ 1: మైక్రోసాఫ్ట్ జట్లను తెరవండి",
    microsoft_step1_para1:
      "ప్రారంభించడానికి, మొదట మీరు ఈ పేజీ ఎగువన అందుబాటులో ఉన్న మీ సిస్టమ్‌కు టీమ్ ప్లగిన్‌ను డౌన్‌లోడ్ చేసుకోవాలి. అప్పుడు మీ మైక్రోసాఫ్ట్ జట్లను తెరిచి ఎంచుకోండి",
    microsoft_step1_para2:
      " జట్టు అనువర్తనాలను వీక్షించడానికి సైడ్ నావిగేషన్ నుండి ఎంపికలు.",
    microsoft_step2: "దశ 2: మరిన్ని అనువర్తనాలకు వెళ్లండి",
    microsoft_step2_para1:
      "ఇక్కడ మీరు మరిన్ని అనువర్తనాలు అనే బటన్‌తో పాటు కొన్ని అనువర్తనాలను కనుగొనవచ్చు. నొక్కండి",
    microsoft_step2_para2:
      "అనుకూల అప్‌లోడ్ ఎంపిక మరియు ఇతర స్టోర్ ఎంపికల కోసం మరింత తనిఖీ చేయడానికి.",
    microsoft_step3: "దశ 3: అప్‌లోడ్ అనువర్తనం",
    microsoft_step3_para1:
      "మీరు దుకాణాన్ని తెరిచిన తర్వాత, మీరు ఒకదాన్ని కనుగొనవచ్చు ",
    microsoft_step3_para2:
      " ఎడమ నావిగేషన్‌లో ఎంపిక. దానిపై క్లిక్ చేసి, మీ డౌన్‌లోడ్ చేసిన ప్లగిన్ అనువర్తనాన్ని ఇక్కడ అప్‌లోడ్ చేయండి.",
    microsoft_step4: "దశ 4: నిల్వ నుండి InstaVC అనువర్తనాన్ని ఎంచుకోండి",
    microsoft_step4_para1:
      "విండో ప్రాంప్ట్ చేసినప్పుడు, (సిస్టమ్ 1) లో డౌన్‌లోడ్ చేయబడిన మీ సిస్టమ్ నుండి ఇన్‌స్టావిసి ప్లగిన్ అనువర్తనాన్ని ఎంచుకోండి మరియు క్లిక్ చేయండి",
    microsoft_step5: "దశ 5: మైక్రోసాఫ్ట్ జట్లలో అప్‌లోడ్ చేసిన అనువర్తనం",
    microsoft_step5_para1:
      "ఫైల్‌ను అప్‌లోడ్ చేసిన తర్వాత, ఇది మైక్రోసాఫ్ట్ టీమ్ యాప్స్ జాబితాలో అప్‌లోడ్ అవుతుంది. మీరు దాన్ని చూడటానికి అనువర్తనాన్ని క్లిక్ చేసి జట్లకు జోడించవచ్చు.",
    microsoft_step6: "దశ 6: InstaVC అనువర్తనాన్ని తెరవండి",
    microsoft_step6_para1:
      "మీరు InstaVC అనువర్తనంపై క్లిక్ చేసిన తర్వాత, మీరు ఇప్పుడు ప్లగ్ఇన్ అనువర్తనం యొక్క పూర్తి వివరాలతో పాటు ఒక బటన్‌ను చూడవచ్చు",
    microsoft_step6_para2:
      "మైక్రోసాఫ్ట్ జట్లకు ఈ అనువర్తనాన్ని జోడించడానికి బటన్.",
    microsoft_step7: "దశ 7: మైక్రోసాఫ్ట్ జట్లకు ఇన్‌స్టావిసి జోడించబడింది",
    microsoft_step7_para1:
      "ఇప్పుడు మీ అనువర్తనం సులభమైన మరియు అనుకూలీకరించదగిన ఉపయోగం కోసం ఎడమ వైపు నావిగేషన్‌లోని మైక్రోసాఫ్ట్ జట్లకు జోడించబడుతుంది.",

    ddyymm: "DD/MM/YYYY",
    fill_details_for_webinar:
      "దయచేసి వెబ్‌నార్ కోసం మీ రిజిస్ట్రేషన్ వివరాలను ",
    microsoft_teams: "మైక్రోసాఫ్ట్ జట్లు",
    microsoft_outlook: "మైక్రోసాఫ్ట్ lo ట్లుక్ ",
    select_the_plan: "దయచేసి ప్రణాళికను ఎంచుకోండి",
    enter_company_code: "దయచేసి కంపెనీ కోడ్‌ను నమోదు చేయండి ",
    enter_code: "దయచేసి కోడ్‌ను నమోదు చేయండి",
    enter_valid_coupon_code:
      "దయచేసి చెల్లుబాటు అయ్యే కూపన్ కోడ్‌ను నమోదు చేయండి ",
    coupon_alreadt_taken: "ఈ కూపన్ కోడ్ ఇప్పటికే తీసుకోబడింది ",
    error_updating_plan: "ప్రణాళికను నవీకరించడంలో లోపం",
    unit: "యూనిట్",
    referrals: "సిఫార్సులు",
    sel_coupon: "దయచేసి కూపన్ ఎంచుకోండి",
    share_val_0_99: "వాటా విలువ 0 నుండి 99 మధ్య ఉండాలి",
    enter_share_val: "దయచేసి షేర్ విలువను నమోదు చేయండి",
    valid_commission_per:
      "దయచేసి చెల్లుబాటు అయ్యే కమిషన్ శాతాన్ని నమోదు చేయండి",
    enter_commission_per: "దయచేసి కమిషన్ శాతాన్ని నమోదు చేయండి ",
    enter_commission_name: "దయచేసి కమిషన్ పేరును నమోదు చేయండి ",
    sync_successfully: "వినియోగదారులు విజయవంతంగా సమకాలీకరిస్తారు ",
    room_deleted_suc: "గది విజయవంతంగా తొలగించబడింది",
    lic_deleted_suc: "లైసెన్స్ విజయవంతంగా తొలగించబడింది",
    female: "స్త్రీ",
    male: "పురుషుడు",
    insta_conference: "ఇన్‌స్టా కాన్ఫరెన్స్",
    quick_meeting_by: "త్వరిత సెషన్ ద్వారా",
    in_lobby: "లాబీలో",
    switch_to_broadcast: "ప్రసారానికి మారండి ",
    Broadcasters_5: "ప్రసారకులు (5) ",
    Participants_5: "పాల్గొనేవారు (5) ",
    search_participants: "పాల్గొనేవారిని శోధించండి ",
    host_controls: "హోస్ట్ నియంత్రణలు",
    deleteroom: " గదిని తొలగించు ",
    pm: "PM",
    am: "AM",
    email_exist_inroom: "ఈ గదిలో ఇప్పటికే ఇమెయిల్ ఉంది",
    type_a_message: "సందేశాన్ని టైప్ చేయండి ...",
    please_enter_user_limit: "దయచేసి వినియోగదారు పరిమితిని నమోదు చేయండి",
    user_limit_exceeded: "వినియోగదారు పరిమితి మించిపోయింది",
    sel_country_code: "దయచేసి దేశ కోడ్‌ను ఎంచుకోండి",
    available_storage: "అందుబాటులో నిల్వ",
    enter_phone_number: "ఫోన్ నంబర్‌ను నమోదు చేయండి",
    startdate_less_enddate:
      "దయచేసి ప్రారంభ తేదీని ముగింపు తేదీ కంటే తక్కువ ఎంచుకోండి",
    havent_add_data: "మీరు ఇంకా డేటాను జోడించలేదు, దయచేసి డేటాను జోడించండి. ",
    professional_skills: "వృత్తి నైపుణ్యాలు",
    enter_prof_skills: "వృత్తిపరమైన నైపుణ్యాలను నమోదు చేయండి",
    Present_Invitations: "ప్రస్తుత ఆహ్వానాలు",
    sending: "పంపుతోంది ... ",
    sent: "పంపబడింది",
    invite_10ppl_only: " మీరు 10 మంది వరకు మాత్రమే ఆహ్వానించగలరు ",
    join_meeting: "సెషన్‌లో చేరండి",
    enter_doc_title: "పత్ర శీర్షికను నమోదు చేయండి",
    meeting_name: "సెషన్ పేరు",
    select_the_weeks: "దయచేసి వారాలను ఎంచుకోండి",
    grade: "స్థాయి",
    coference_ID: "కాన్ఫరెన్స్ ఐడి ...",
    dont_find_room_meetingid:
      "ఈ సెషన్ ఐడితో అనుబంధించబడిన గది ఏదీ మాకు కనుగొనబడలేదు",
    wireless_share: "వైర్‌లెస్ షేర్",
    video_layout: "వీడియో లేఅవుట్ ",
    speaker_screen: "స్పీకర్ స్క్రీన్",
    presentation_screen: "ప్రదర్శన తెర",
    multiple_display: "బహుళ ప్రదర్శన",
    hellow: "హలో",
    enter_passcode: "పాస్‌కోడ్‌ను నమోదు చేయండి",
    another_meeting_stillon:
      "మరొక సెషన్ ఇప్పటికీ ఆన్‌లో ఉంది, మీరు ఈ సెషన్‌ను ఇప్పుడే ప్రారంభించలేరు",
    SIP_device: "SIP పరికరం",
    instavc_whiteBoard: "Instavc వైట్బోర్డ్",
    speaker: "స్పీకర్",
    instavc_notepad: "Instavc నోట్ప్యాడ్",
    promote_in: "లో ప్రచారం",
    guest: "అతిథి",
    breakout_rooms: "బ్రేక్అవుట్ గదులు",
    stop_broadcast: "బ్రాడ్కాస్ట్ స్టాప్",
    noise_suppress: "శబ్దం అణచివేత",
    echo_cancel: "ఎకో రద్దు:",
    enter_name_here: "ఇక్కడ పేరును నమోదు చేయండి",
    Viewer: "వీక్షకుడు",
    SIP_user: "సిప్ యూజర్",
    remove_participants: "పాల్గొనేవారిని తొలగించు",
    disable_audio_video: "రిమోట్ ఆడియో & వీడియోని ఆపివేయి",
    disable_audio: "ఆపివేయి ఆడియో",
    enable_audio: "ఆడియోని ఎనేబుల్",
    disable_video: "  వీడియోను ఆపివేయి ",
    enable_video: "వీడియోని ప్రారంభించు",
    audio_video: "ఆడియో & వీడియో",
    audio_only: "ఆడియో మాత్రమే",
    video_only: "వీడియో మాత్రమే",
    outlook_addins: "outlook యాడ్-ఇన్లు",
    install_microsoft:
      "మైక్రోసాఫ్ట్ క్లుప్తంగలో యాడ్-ఇన్లు ఇన్స్టాల్ మరియు నిర్వహించడానికి ఎలా",
    outlook_step1: "స్టెప్ 1: కాపీ లింక్ & ఓపెన్ Outlook",
    first_copy_link: "మొదటి లింక్ కాపీ",
    add_plugin_oulook: "ఇక్కడ నుండి మీ Outlook కు ప్లగిన్ జోడించడానికి.",
    outlook_step2: "దశ 2: జోడించు-ఇన్లు పొందండి",
    outlook_step2_para:
      "ఇప్పుడు Outlook మరియు హోమ్ టాబ్ కింద మీరు ఒక ఎంపికను పొందవచ్చు. Ads-ins మరియు ఇతర కస్టమ్ ఎంపికలను వీక్షించడానికి దానిపై క్లిక్ చేయండి.",
    outlook_step3: "దశ 3: నా అనుబంధాలు",
    outlook_step3_para:
      "మీరు ఇప్పుడు ఎడమ పేజీకి సంబంధించిన లింకులు తో యాడ్-ఇన్ పేజీని చూడవచ్చు. మీ యాడ్-ఇన్లను నిర్వహించడానికి నా యాడ్-ఇన్లకు వెళ్లండి.",
    outlook_step4: "దశ 4: కస్టమ్ యాడ్-ఇన్లు జోడించండి",
    outlook_step4_para:
      "ఇక్కడ మీరు ఒక డౌన్ పొందవచ్చు కస్టమ్ యాడ్ ఇన్ నా యాడ్-ఇన్ పేజీలో కస్టమ్ యాడ్ ఇన్ కింద జోడించండి. డ్రాప్ డౌన్ నుండి URL నుండి జోడించు ఎంచుకోండి.",
    outlook_step5: "దశ 5: URL నుండి ప్రైవేట్ యాడ్-ఇన్ జోడించండి",
    outlook_step5_para:
      "మీరు ఇప్పుడు URL నుండి ప్రైవేట్ యాడ్-ఇన్ జోడించడానికి అడుగుతూ ఒక పాపప్ చూడవచ్చు. ఇప్పుడు మీరు కాపీ చేసిన లింక్ను అతికించండి (దశ 1) ఇన్పుట్ ఫీల్డ్లో మరియు OK క్లిక్ చేయండి, ఆ outlook కు అనుబంధాన్ని ఇన్స్టాల్ చేస్తాయి.",
    outlook_step6: "స్టెప్ 6: Instavc నా యాడ్-ఇన్లలో చేర్చబడింది",
    outlook_step6_para:
      "జోడించిన తరువాత, మీరు మీ నా యాడ్-ఇన్ల జాబితాకు జోడించిన జోడింపును తనిఖీ చేయవచ్చు. ఇక్కడ నుండి మీ అనుబంధాలను మరింత నిర్వహించవచ్చు.",
    outlook_step7: "దశ 7: క్లోజ్ అవుట్ లుక్ మరియు తిరిగి",
    outlook_step7_para:
      "ఇన్స్టాల్ చేసిన తర్వాత, పూర్తి క్లుప్తంగని మూసివేసి, అనుబంధాన్ని చూడడానికి మళ్లీ తెరిచినట్లు నిర్ధారించుకోండి.",
    outlook_step8: "దశ 8: కొత్త అంశాలకు వెళ్లండి",
    outlook_step8_para:
      "Outlook తెరిచిన తరువాత, మీరు ఇప్పుడు కొత్త సమావేశాలకు & # 62 కు వెళ్ళవచ్చు; instavc ను చూడడానికి జోడించు addlook జోడించండి.",
    outlook_step9: "దశ 9: ఓపెన్ Instavc సమావేశం",
    outlook_step9_para:
      "మీరు సమావేశాలు తెరిచిన తర్వాత, మీరు సమావేశాల టాబ్లో ఎగువ బార్లో ఎనేబుల్-ఇన్-ఇన్టాక్ సమావేశంతో పాటు ఒక కంపోజ్ మెయిల్ విండోతో తెరవబడతారు.",
    outlook_step10: "దశ 10: షెడ్యూల్ సృష్టించు",
    outlook_step10_para:
      "కంపోజ్ మెయిల్ లేఅవుట్ నుండి, ఒక కొత్త షెడ్యూల్ను సృష్టించడానికి instavc సమావేశాలపై క్లిక్ చేయండి. ఇది మొదటిసారిగా ఉన్నట్లయితే మీరు Instavc సమావేశం లాగిన్ తో తెరవబడతారు. ఇప్పటికే లాగిన్ అయిన వినియోగదారుల కోసం, వారు గదులు జాబితాకు దర్శకత్వం వహిస్తారు మరియు షెడ్యూల్ను సృష్టించవచ్చు.",
    outlook_step11: "దశ 11: ఓపెన్ Instavc సమావేశం ",
    outlook_step11_para:
      "మీరు ఎడమ వైపున ఒక షెడ్యూల్ను సృష్టించవచ్చు మరియు ఒక ప్రత్యేక గదిలో సమావేశం షెడ్యూల్ చేయడానికి కుడి వైపున ఒక గదిని ఎంచుకోవచ్చు. మీరు ఒక షెడ్యూల్ను సృష్టించిన తర్వాత, మీరు ఇప్పుడు ప్రారంభ సమావేశం బటన్ను చూడవచ్చు. ఇక్కడ నుండి మీరు క్లిక్ చేసి సమావేశం ప్రారంభించవచ్చు.",
    outlook_step12: "దశ 12: క్యాలెండర్లో షెడ్యూల్ను వీక్షించండి",
    outlook_step12_para:
      "మీరు షెడ్యూల్ను సృష్టించిన తర్వాత, మీరు క్యాలెండర్ను తెరిచిన తర్వాత, మీరు క్యాలెండర్లో మీ షెడ్యూల్లను చూడవచ్చు.",
    outlook_step13: "స్టెప్ 13: షెడ్యూల్ సృష్టించబడింది",
    outlook_step13_para:
      "మీరు ఒక షెడ్యూల్ను సృష్టించిన తర్వాత, మీరు కుడి వైపున ప్రారంభ సమావేశ బటన్తో కూర్చిన మెయిల్ను చూడవచ్చు.",
    sel_declaration: "దయచేసి ప్రకటనను ఎంచుకోండి ",
    enter_company_code: "దయచేసి కంపెనీ కోడ్ను నమోదు చేయండి",
    invalid_company_code: "చెల్లని కంపెనీ కోడ్",
    affiliate_acc: "మీ అనుబంధ ఖాతా ఆమోదం పెండింగ్లో ఉంది.",
    aff_acc_approved: "మీ అనుబంధ ఖాతా ఆమోదించబడింది.",
    aff_acc_rej: "మీ అనుబంధ ఖాతా తిరస్కరించబడింది.",
    aff_TC: "అనుబంధ నిబంధనలు మరియు షరతులు ",
    ref_par_agreement: "రిఫరల్ పార్టనర్ ఒప్పందం",
    aff_partner_agreement:
      'ఈ కవర్ పేజీ, ఈ కవర్ పేజీ మరియు జతచేయబడిన వ్యాపార నిబంధనలు (సమిష్టిగా, ఈ "ఒప్పందం"), పీపుల్ లింక్ యూనిఫైడ్ కమ్యూనికేషన్స్ ప్రైవేట్ లిమిటెడ్ (పీపుల్ లింక్ అని పిలుస్తారు) మరియు “భాగస్వామి” లేదా “మీరు  ".  "భాగస్వామి" లేదా "మీరు" అంటే సమర్పించిన ఫారమ్‌లో వివరించిన వ్యక్తి లేదా సంస్థ (కంపెనీ పేరు మరియు ఇతర సమాచారంతో సహా).  ఈ ఒప్పందాన్ని మీరు అంగీకరించడాన్ని సూచించడానికి మీరు రెఫరల్ పార్టనర్ ప్రోగ్రామ్ ఫారం ("ఫారం") ను పూర్తి చేసి సమర్పించిన తర్వాత ఒప్పందం కట్టుబడి ఉంటుంది.  పీపుల్‌లింక్ మరియు భాగస్వామిని కొన్నిసార్లు "పార్టీ" గా మరియు కలిసి "పార్టీలు" గా సూచిస్తారు.',
    background: "నేపథ్య",
    aff_market_advertise:
      'పీపుల్‌లింక్ ఇన్‌స్టావిసి యూనిఫైడ్ కమ్యూనికేషన్ సేవలు మరియు పరిష్కారాలను అందిస్తుంది.  ఈ ఒప్పందానికి అనుగుణంగా, పీపుల్‌లింక్ ఉత్పత్తులు మరియు సంభావ్య పీపుల్‌లింక్ కస్టమర్లకు ("రెఫరల్స్") దాని వెబ్‌సైట్ (లు) మరియు ఇతర మార్కెటింగ్ ఛానెల్‌ల ద్వారా ప్రోత్సహించడానికి, మార్కెట్ చేయడానికి మరియు ప్రచారం చేయాలని భాగస్వామి కోరుకుంటాడు. ',
    agreement: "ఒప్పందం",
    aff_parties_agree: "ఈ క్రింది విధంగా పార్టీలు అంగీకరిస్తాయి:",
    heading1: " ప్రోగ్రామ్ కట్టుబాట్లు ",
    heading2: "క్వాలిఫైడ్ రిఫరల్స్, కమీషన్లు.",
    heading3: "పదం మరియు రద్దు.",
    heading4: "జనరల్",
    the_program: "కార్యక్రమం.",
    to_participate_program_partner:
      'ప్రోగ్రామ్ పార్టనర్లో పాల్గొనడానికి Peoplelink లేదా దాని సంబంధిత వెబ్సైట్లు ("సైట్") మరియు ఈ ఒప్పందాన్ని నమోదు చేసిన కార్యక్రమంలో పాల్గొనడానికి ఆన్లైన్ దరఖాస్తును పూర్తి చేయాలి. Peoplelink దాని స్వంత అభీష్టానుసారం ఏ అప్లికేషన్ అంగీకరించవచ్చు లేదా తిరస్కరించవచ్చు. ',
    aff_str11: "చట్టపరమైన ఒప్పందాలు.",
    aff_str12: "ప్రమోషన్, రిఫెరల్ కార్యకలాపాలు:",
    aff_str13: "నిషేధించబడిన చర్యలు.",
    aff_str14: "పీపుల్లింక్ మార్క్స్ యొక్క అనుమతినిచ్చే ఉపయోగం",
    aff_str15: "బాధ్యతలు.",
    aff_str16: "కస్టమర్ రిలేషన్స్.",
    aff_str11_para:
      "ప్రోగ్రామ్‌లో పాల్గొనడంలో భాగంగా మరియు పీపుల్‌లింక్ భాగస్వామిగా వ్యవహరించడంలో, భాగస్వామి ఈ ఒప్పందం మరియు ప్రోగ్రామ్, మార్గదర్శకాలు మరియు ఎప్పటికప్పపీపుల్‌లింక్ నిర్దేశించిన ఇతర అభ్యర్థనలు మరియు నియమాలను అంగీకరిస్తుంది మరియు అంగీకరిస్తుందసహేతుకమైన అభీష్టానుసారం, ప్రోగ్రామ్‌లో భాగస్వామి కొనసాగుతున్న పాల్గొనడం మరియు పీపుల్‌లిఉత్పత్తులు, పరిష్కారాలు మరియు సేవలను రెఫరల్‌లకు ప్రోత్సహించడం.ఈ ఒప్పందం ప్రకారం దాని యొఅన్ని కార్యకలాపాలలో మరియు పీపుల్‌లింక్ యొక్క భాగస్వామి యొక్క ప్రమోషన్‌కు సంబంధించిన నిర్దిఇటువంటి కార్యకలాపాలలో, భాగస్వామి పీపుల్‌లింక్‌తో సహకరించాలి మరియు  మంచి విశ్వాసవ్యవహరించండి. ఈ ఒప్పందాన్ని ప్రవేశపెట్టడం ద్వారా భాగస్వామి పీపుల్‌లింక్ యొక్క సేవా నిబంధనపేర్కొన్న నిబంధనలు మరియు నియమాలను మరింత గుర్తించి అంగీకరిస్తాడు ",
    aff_str12_para:
      "లైసెన్స్ పొందిన మార్కులు మరియు మార్కెటింగ్ మెటీరియల్స్ ఉపయోగించి వివిధ మార్కెటింగ్ ఛానెళ్ళలో పీపుల్ లింక్ ఉత్పత్తులు మరియు పరిష్కారాల యొక్క నిరంతర, క్రియాశీల ప్రమోషన్లో పాల్గొనడానికి భాగస్వామి అంగీకరిస్తాడు మరియు ఈ ఒప్పందం యొక్క నిబంధనలకు అనుగుణంగా అలా చేయండి.",
    aff_str13_para:
      'మార్కెటింగ్ మెటీరియల్‌లను ఏ విధంగానైనా చట్టవిరుద్ధమైన, లేదా హానికరమైన, బెదిరించే, పరువు నష్టం కలిగించే, అశ్లీలమైన, అప్రియమైన, వేధించే, లైంగిక అసభ్యకరమైన, హింసాత్మక, వివక్షత లేదా పీపుల్‌లింక్ యొక్క స్వంత అభీష్టానుసారం అభ్యంతరకరమైన విషయాలతో సంబంధం కలిగి ఉండకూడదని భాగస్వామి అంగీకరిస్తాడు.  పీపుల్‌లింక్ సేవలు మరియు పరిష్కారాలను ప్రోత్సహించడంలో బహుళ సంబంధం లేని గ్రహీతలకు ("స్పామింగ్") అయాచిత ఎలక్ట్రానిక్ సందేశాలను పంపవద్దని భాగస్వామి అంగీకరిస్తాడు, లేకపోతే ఈ ఒప్పందం ప్రకారం ఆలోచించిన కార్యకలాపాలకు సంబంధించి చట్టం ద్వారా నిషేధించబడిన ఇతర రకాల ఎలక్ట్రానిక్ కమ్యూనికేషన్లలో పాల్గొనడానికి. ',
    aff_str14_para1:
      "లైసెన్స్ పొందిన మార్కులను ఉపయోగించడంలో మరియు మార్కెటింగ్ మెటీరియల్స్ సృష్టించడంలో భాగస్వామి ఇక్కడ ఉన్న అన్ని నిబంధనలను పాటించటానికి స్పష్టంగా అంగీకరిస్తాడు.",
    aff_str14_para2:
      "మార్గదర్శకాల ద్వారా మరియు లేకపోతే, మార్కెటింగ్ మెటీరియల్స్ సృష్టించడంలో మరియు పీపుల్ లింక్ సేవను ప్రోత్సహించడంలో లైసెన్స్ పొందిన మార్కుల యొక్క భాగస్వామి అనుమతించదగిన ఉపయోగం గురించి ఎప్పటికప్పుడు పీపుల్ లింక్ ప్రత్యేకతలు మరియు ఇతర సూచనలను అందిస్తుంది.  మరియు సూచనలు. ",
    aff_str14_para3:
      "దాని మార్కెటింగ్ మెటీరియల్‌లలో కనిపించే అన్ని లైసెన్స్ మార్కులు మార్గదర్శకాలలో పీపుల్‌లింక్ ఆమోదించిన రూపంలో ఉన్నాయని భాగస్వామి నిర్ధారించాలి, లేకపోతే, ఏ పీపుల్‌లింక్ మార్కులను సవరించకూడదు లేదా పీపుల్‌లింక్ అందించిన సహేతుకమైన సూచనలకు విరుద్ధంగా ఇతర మార్కెటింగ్ మెటీరియల్‌లను గణనీయంగా సవరించకూడదు మరియు ఇంకా  మార్కెటింగ్ మెటీరియల్స్ యొక్క రూపం, కంటెంట్ మరియు ప్రదర్శనకు సంబంధించి పీపుల్ లింక్ నుండి సహేతుకమైన సూచనలను పాటించండి. ఏ కారణం చేతనైనా ఈ ఒప్పందం ముగిసిన తరువాత, లేదా పీపుల్ లింక్ యొక్క వ్రాతపూర్వక అభ్యర్థన మేరకు, ఇక్కడ మంజూరు చేయబడిన లైసెన్స్ గడువు ముగుస్తుంది మరియు భాగస్వామి వెంటనే దాని యొక్క అన్ని కార్యకలాపాలను నిలిపివేస్తారు  ఈ ఒప్పందం. ",
    aff_str15_para:
      "ఈ ఒప్పందానికి సంబంధించి సృష్టించబడిన మరియు ఉపయోగించిన భాగస్వామి యొక్క కార్యకలాపాలు మరియు సామగ్రి యొక్క చట్టబద్ధతతో సహా, ఈ ఒప్పందం ప్రకారం పనిచేయడంలో దాని కార్యకలాపాలకు భాగస్వామి మాత్రమే బాధ్యత వహిస్తాడు. పీపుల్ లింక్ మార్క్ మూడవ పక్షాన్ని ఉల్లంఘిస్తోందని ఆరోపించిన దావా తప్ప  ట్రేడ్మార్క్ హక్కులు, భాగస్వామి యొక్క మార్కెటింగ్ మెటీరియల్స్ యొక్క అభివృద్ధి, ఆపరేషన్ లేదా కంటెంట్‌కు పీపుల్‌లింక్ బాధ్యత వహించదు మరియు భాగస్వామి ఏదైనా వాదనలు, చర్యలు, చర్య యొక్క కారణాలు, నష్టాలు లేదా ఖర్చులకు (అటార్నీ ఫీజుతో సహా) వ్యతిరేకంగా పీపుల్‌లింక్‌ను హానిచేయకుండా రక్షించడానికి, నష్టపరిహారం మరియు ఉంచడానికి అంగీకరిస్తాడు.  భాగస్వామి మార్కెటింగ్ మెటీరియల్స్ అభివృద్ధి, ఆపరేషన్, కంటెంట్ మరియు నిర్వహణ. ",
    aff_str16_para:
      "టర్మ్ సమయంలో మరియు తరువాత, పీపుల్‌లింక్ సేవకు సంబంధించి పీపుల్‌లింక్ మరియు రెఫరల్స్ మధ్య భాగస్వామి ద్వారా సృష్టించబడిన అన్ని సంబంధాల యొక్క ప్రత్యేక యజమాని పీపుల్‌లింక్, పీపుల్‌లింక్ సేవ యొక్క ఉపయోగం కోసం పీపుల్‌లింక్‌తో ఒప్పందం కుదుర్చుకునే రెఫరల్‌లను గుర్తించే ఏదైనా మరియు మొత్తం సమాచారంతో సహా.  పీపుల్‌లింక్ సేవ కోసం నిబంధనలు, గోప్యతా విధానం మరియు పీపుల్‌లింక్ యొక్క నియమాలు మరియు విధానాలు ఈ రెఫరల్‌లకు వర్తిస్తాయి మరియు భాగస్వామికి ముందస్తు నోటీసు లేకుండా పీపుల్‌లింక్ ద్వారా మార్చవచ్చు మరియు నిబంధనల ప్రకారం పీపుల్‌లింక్‌తో వారి సంబంధాల స్వభావాన్ని రెఫరల్‌లకు తెలియజేయడానికి భాగస్వామి అంగీకరిస్తాడు.  ",
    aff_str20_para1:
      "Peoplelink భాగస్వామి ద్వారా ప్రస్తావన మరియు విభాగం 3 (B) క్రింద వివరించిన విధానానికి అనుగుణంగా సైన్-అప్ విధానాన్ని పూర్తిచేస్తుంది;",
    aff_str20_para2:
      "వీరిలో పీపుల్‌లింక్ సేవకు సంబంధించి పీపుల్‌లింక్‌కు ఎటువంటి రికార్డ్ లేదు, లేదా పీపుల్‌లింక్‌ను భాగస్వామిచే సూచించబడిన సమయంలో, ఏదైనా ఒప్పంద సంబంధాలలో లేదా పీపుల్‌లింక్‌తో పీపుల్‌లింక్‌తో కొనసాగుతున్న చర్చలలో ఎవరు లేరు;",
    aff_str20_para3:
      "నిబంధనలను అంగీకరించి, రెఫరల్ యొక్క స్వంత అభీష్టానుసారం మరియు భాగస్వామి నుండి ఎటువంటి ద్రవ్య లేదా ఇతర ప్రోత్సాహకాలను పొందకుండా, పీపుల్ లింక్ వెబ్‌సైట్లలో జాబితా చేయబడిన ఈ క్రింది పీపుల్‌లింక్ సేవా ప్రణాళిక కట్టల యొక్క కనీసం వార్షిక చందాలు లేదా (iv) తిరస్కరించబడని వారు  పీపుల్ లింక్ ద్వారా, మరియు పీపుల్ లింక్ సేవను స్వీకరించడానికి కనీసం ఒక చెల్లింపు (వార్షిక ప్రీపే) లేదా మూడు చెల్లింపులు (వార్షిక పదం, నెలవారీ బిల్లింగ్) చేయండి. ",
    aff_str21: "రెఫరల్ ప్రొసీజర్.",
    aff_str22: "కమీషన్లు. బాధ్యతలు.",
    aff_str221: "రెఫరల్ ఫీజు.",
    aff_str222: "రెఫరల్ నుండి కొనసాగుతున్న అమ్మకాలు",
    aff_str223: "అసోసియేటెడ్ ఛార్జీలు.",
    aff_str23: "అమ్మకాలు / కమీషన్ నివేదికలు.",
    aff_str21_para:
      "ప్రతి రెఫరల్‌ను భాగస్వామికి పీపుల్‌లింక్ అందించిన ఆన్‌లైన్ url ద్వారా భాగస్వామి ద్వారా పీపుల్‌లింక్‌కు సూచిస్తారు, అమ్మకాల ప్రక్రియను రెఫరల్‌కు ప్రోత్సహించడంలో పార్టీల నిరంతర మంచి విశ్వాస సహకారానికి లోబడి, అన్ని రెఫరల్‌లకు అమ్మకాల ప్రక్రియకు పీపుల్‌లింక్ బాధ్యత వహించాలి.  ",
    aff_str22_para:
      "పీపుల్ లింక్ ప్రజల కోసం రెఫరల్స్ నుండి రెఫరల్స్ నుండి నేరుగా ఫీజులను రెఫరల్స్ నుండి సేకరిస్తుంది.",
    aff_str22_para1:
      "రెఫరల్ క్వాలిఫైడ్ రెఫరల్‌గా మారిన తర్వాత, పీపుల్‌లింక్ వద్ద ఉన్న లిస్టెడ్ ఫీజుల ఆధారంగా భాగస్వామి రిఫెరల్ ఫీజులను బకాయిల్లో చెల్లించాలి",
    aff_str22_para12:
      "క్వాలిఫైడ్ రెఫరల్ చెల్లించాల్సిన (ఏదైనా డిస్కౌంట్లను మినహాయించి). అటువంటి రెఫరల్ ఫీజులు చెల్లించబడతాయి మరియు చెల్లింపు సేవ ప్రారంభ తేదీ మంజూరు చేసిన చెల్లింపు బాధ్యతలు సాధించిన సుమారు (<జోడించు) తొంభై (90) రోజులలో భాగస్వామికి చెల్లించబడతాయి.",
    aff_str22_para2:
      "- రిఫెరల్ ప్రారంభంలో సమర్పించిన తేదీ నుండి మొదటి 90 రోజులలో జరిగే క్వాలిఫైడ్ రెఫరల్ నుండి అదనపు అమ్మకాల కోసం భాగస్వామి రిఫెరల్ ఫీజులను అందుకుంటారు.",
    aff_str22_para3:
      "రెఫరల్ ఫీజుపై విధించే అన్ని పన్నులు, సుంకాలు, ప్రభుత్వ ఛార్జీలు మరియు ఇతర ఛార్జీల చెల్లింపుకు భాగస్వామి బాధ్యత వహించాలి మరియు పీపుల్ లింక్ నుండి వెలువడే అన్ని ఛార్జీల నుండి లేదా వాటికి వ్యతిరేకంగా మరియు వ్యతిరేకంగా పీపుల్‌లింక్‌ను హాని కలిగించకుండా, రక్షించడానికి మరియు కలిగి ఉండటానికి భాగస్వామి బాధ్యత వహిస్తాడు.  రెఫరల్ ఫీజు చెల్లింపు. ",
    aff_str23_para:
      "పీపుల్ లింక్ వారి ఆన్‌లైన్ డాష్‌బోర్డ్ నివేదికలో భాగస్వామి యొక్క అమ్మకాల కార్యకలాపాలను మరియు రెఫరల్స్ నుండి పొందిన క్వాలిఫైడ్ రెఫరల్స్ కోసం దాని కమీషన్లను సంగ్రహంగా అందిస్తుంది. రెఫరల్స్ మరియు క్వాలిఫైడ్ రెఫరల్స్ గురించి పేర్లు లేదా ఇతర వ్యక్తిగత సమాచారాన్ని పీపుల్ లింక్ బహిర్గతం చేయదు.",
    aff_str31: "ప్రారంభ పదం.",
    aff_str32: "పునరుద్ధరణ పదం.",
    aff_str33: "ప్రారంభ ముగింపు. కారణం లేకుండా.",
    aff_str34: "కారణం కోసం.",
    aff_str35: "ముగింపు ప్రభావం. ",
    aff_str31_para:
      'ఈ ఒప్పందం ప్రభావవంతమైన తేదీ నాటికి అమలులోకి వస్తుంది మరియు ఆ తరువాత పన్నెండు (12) నెలలు ("ప్రారంభ పదం") కొనసాగుతుంది, ఈ కార్యక్రమంలో పాల్గొనడానికి పీపుల్ లింక్ భాగస్వాముల దరఖాస్తును తిరస్కరించకపోతే',
    aff_str32_para:
      'ప్రారంభ పదం గడువు ముగిసిన తరువాత, ఈ ఒప్పందం స్వయంచాలకంగా వరుసగా పన్నెండు (12) నెలల (ప్రతి ఒక్కటి, "పునరుద్ధరణ పదం") పునరుద్ధరించబడుతుంది, ఒక పార్టీ ఇతర పార్టీకి కనీసం ముప్పై (  30) ప్రారంభ పదం లేదా ఏదైనా పునరుద్ధరణ పదం ముగియడానికి రోజుల ముందు. ',
    aff_str33_para:
      "భాగస్వామికి ఐదు (5) రోజుల ముందు వ్రాతపూర్వక నోటీసు ఇవ్వడం ద్వారా ఏ లేదా కారణం లేకుండా ఈ ఒప్పందాన్ని ఎప్పుడైనా ముగించే హక్కు పీపుల్‌లింక్‌కు ఉంటుంది.",
    aff_str34_para:
      "ఈ ఒప్పందాన్ని భౌతికంగా ఉల్లంఘించిన ఇతర పార్టీకి వ్రాతపూర్వక నోటీసు ఇచ్చిన వెంటనే ఏ పార్టీ అయినా ఈ ఒప్పందాన్ని ముగించవచ్చు, ఈ ఒప్పందాన్ని ముగించే ముందు ముగించే పార్టీ అటువంటి భౌతిక ఉల్లంఘన మరియు ముప్పై (30)  అటువంటి ఉల్లంఘనను నయం చేయడానికి ఉల్లంఘించే పార్టీకి రోజుల అవకాశం. ",
    aff_str35_para:
      "ఈ ఒప్పందం ముగిసిన తేదీ నుండి మరియు తరువాత ఈ ఒప్పందం ప్రకారం భాగస్వామి యొక్క హక్కులు ముగుస్తాయి మరియు ఈ ఒప్పందం ప్రకారం ఈ రెఫరల్ ఫీజులు లేదా ఇతర చెల్లింపులను స్వీకరించడానికి భాగస్వామికి అర్హత ఉండదు.  ఒప్పందం. ",
    aff_str41: "అసైన్మెంట్.",
    aff_str42: "మేధో సంపత్తి హక్కులు.",
    aff_str43: "మాఫీ లేదు.",
    aff_str44: "పరిమిత వారంటీ.",
    aff_str45: "డిస్క్లైమర్ ఆఫ్ వారంటీ.",
    aff_str46: "బాధ్యత యొక్క పరిమితి.",
    aff_str47: "  స్వతంత్ర కాంట్రాక్టర్లు. ",
    aff_str48: "నష్ట పరిహారం.",
    aff_str49: "ఫోర్స్ మేజూర్.",
    aff_str410: "మొత్తం ఒప్పందం; తీవ్రత.",
    aff_str411: "కౌంటర్పార్ట్స్; నోటీసులు.",
    aff_str412: "పాలక చట్టం; అధికార పరిధి; వివాద పరిష్కారం.",
    aff_str41_para:
      "పీపుల్‌లింక్ ఈ ఒప్పందాన్ని ఎప్పుడైనా కేటాయించవచ్చు. పీపుల్‌లింక్ యొక్క ముందస్తు వ్రాతపూర్వక అనుమతి లేకుండా భాగస్వామి ఈ ఒప్పందాన్ని కేటాయించలేరు లేదా బదిలీ చేయలేరు, అలాంటి సమ్మతిని అసమంజసంగా నిలిపివేయకూడదు.",
    aff_str42_para:
      "పీపుల్‌లింక్ మార్కులు, పీపుల్‌లింక్ సేవ మరియు ప్రపంచవ్యాప్తంగా సంబంధిత కంటెంట్ మరియు సాంకేతిక పరిజ్ఞానం (పీపుల్‌లింక్ ఐపి హక్కులు) లోని అన్ని మేధో సంపత్తి హక్కులు (ట్రేడ్‌మార్క్‌లు, వాణిజ్య పేర్లు, లోగోలు, పేటెంట్లు, కాపీరైట్‌లు, డొమైన్ పేర్లు మరియు ఉత్పన్న హక్కులు వంటివి)  పీపుల్‌లింక్ మరియు దాని అనుబంధ సంస్థల యొక్క ప్రత్యేకమైన ఆస్తిగా ఉంటాయి. లైసెన్స్ పొందిన మార్కులను ఉపయోగించుకునే భాగస్వామి యొక్క హక్కు పీపుల్‌లింక్ యొక్క అభీష్టానుసారం ఉంటుంది మరియు ఈ ఒప్పందం, మార్గదర్శకాలు మరియు వర్తించే అన్ని చట్టాలు మరియు నిబంధనలతో భాగస్వామి యొక్క సమ్మతికి లోబడి ఉంటుంది.  (ఎ) ఈ ఒప్పందాన్ని ఉల్లంఘించే విధంగా ఏ పీపుల్‌లింక్ ఐపి హక్కులను ఉపయోగించకూడదని భాగస్వామి అంగీకరిస్తాడు; (బి) ఏదైనా పీపుల్‌లింక్ ఐపి హక్కులను పోటీ చేయడం లేదా బలహీనపరచడం; (సి) ఏదైనా మేధో సంపత్తి హక్కులను సృష్టించడం లేదా పొందడం లేదు (వంటివి)  ఏ పీపుల్‌లింక్ ఐపి హక్కులతో గణనీయంగా సమానమైన ట్రేడ్‌మార్క్‌లు, వాణిజ్య పేర్లు, లోగోలు, పేటెంట్లు, కాపీరైట్‌లు, డొమైన్ పేర్లు మరియు ఉత్పన్న హక్కులు) పరిమితం కాదు; (డి) వెంటనే లేదు  భాగస్వామికి నిజమైన జ్ఞానం ఉన్న ఏదైనా పీపుల్‌లింక్ ఐపి హక్కుల యొక్క అనధికార ఉపయోగం యొక్క పీపుల్‌లింక్‌ను సూచించండి;  మరియు (ఇ) ఎల్లప్పుడూ మార్గదర్శకాలకు అనుగుణంగా లైసెన్స్ పొందిన మార్కులు మరియు ఇతర పీపుల్ లింక్ మార్కులను ఉపయోగించండి.  భాగస్వామి సమర్పించిన ఏదైనా మార్కెటింగ్ మెటీరియల్స్ యొక్క పీపుల్ లింక్ ఆవర్తన సమీక్షలను నిర్వహించవచ్చు మరియు భాగస్వామి సమర్పించిన ఏదైనా మార్కెటింగ్ మెటీరియల్స్ యొక్క తొలగింపు మరియు / లేదా సవరణను ఆదేశించే ప్రత్యేక అధికారం మరియు విచక్షణ కలిగి ఉండాలి. ",
    aff_str43_para:
      "ఈ ఒప్పందం యొక్క ఏదైనా నిబంధన యొక్క ఇతర పార్టీ యొక్క కఠినమైన పనితీరును అమలు చేయడంలో పార్టీ వైఫల్యం, అటువంటి నిబంధనను లేదా ఈ ఒప్పందం యొక్క ఏదైనా ఇతర నిబంధనలను అమలు చేయడానికి మొదటి పార్టీ హక్కును వదులుకోదు.",
    aff_str44_para:
      "రెండు పార్టీలు ఈ వ్యవధిలో అన్ని వర్తించే చట్టాలు, నిబంధనలు, అభ్యాస నియమావళి, అలాగే ఈ ఒప్పందం, నిబంధనలు, గోప్యతా విధానం మరియు మార్గదర్శకాలతో కట్టుబడి ఉంటాయని హామీ ఇస్తున్నాయి. ఈ వ్యవధిలో మరియు ఏ కారణం చేతనైనా అది ముగిసిన తరువాత  , పీపుల్‌లింక్ యొక్క వ్యాపారం, ఆసక్తులు లేదా ప్రతిష్టను దెబ్బతీస్తుందని సహేతుకంగా ఆశించే ఏదైనా చేయకూడదని భాగస్వామి స్పష్టంగా తీసుకుంటాడు మరియు పీపుల్‌లింక్, దాని ప్రతినిధులు లేదా పీపుల్‌లింక్ సేవకు సంబంధించి ఎటువంటి అవమానకరమైన వ్యాఖ్యలను చేయడానికి, ప్రచురించడానికి లేదా చేయడానికి అనుమతించరు.  ",
    aff_str45_para:
      "మునుపటి ఉపవిభాగం (ఇ) కింద పీపుల్‌లింక్ యొక్క ఎక్స్‌ప్రెస్ వారంటీ కాకుండా, పీపుల్‌లింక్ ఏ విధమైన వారెంటీ, ఎక్స్‌ప్రెస్ లేదా సూచించదు మరియు పీపుల్‌లింక్ ఏవైనా వారెంటీలు మరియు షరతులను స్పష్టంగా నిరాకరిస్తుంది, వీటిలో వర్తకత్వం యొక్క ఫిట్నెస్, ఫిట్‌నెస్  ఒక నిర్దిష్ట ప్రయోజనం, లభ్యత, భద్రత, శీర్షిక మరియు / లేదా ఈ ఒప్పందం యొక్క విషయం యొక్క ఉల్లంఘన. ",
    aff_str46_para:
      "పీపుల్‌లింక్ లేదా ఏ అధికారి, ఉద్యోగి, డైరెక్టర్ లేదా పీపుల్‌లింక్ యొక్క ఏ ఇతర ప్రతినిధి ఈ ఒప్పందం లేదా దాని రద్దుకు సంబంధించి లేదా కాంట్రాక్టు, ప్రీ-కాంట్రాక్ట్, టార్ట్ లేదా ఇతరత్రా భాగస్వామికి లేదా ఏదైనా మూడవ పక్షానికి బాధ్యత వహించరు.  i) ఏదైనా ఆర్థిక నష్టం (ఆదాయాలు, లాభాలు, ఒప్పందాలు, వ్యాపారం లేదా sav హించిన పొదుపులతో సహా) లేదా (ii) ఏదైనా సద్భావన లేదా ఖ్యాతిని కోల్పోవడం. ఇటువంటి నష్టాలు పరిమితి లేకుండా, ఏదైనా ప్రత్యేక, పరోక్ష, యాదృచ్ఛిక, చట్టబద్ధమైన, శిక్షాత్మక లేదా పర్యవసానంగా ఉంటాయి  నష్టాలు లేదా నష్టాలు అలాగే కార్యకలాపాల అంతరాయం వల్ల కలిగే నష్టాలు లేదా నష్టాలు. పార్టీల మధ్య ఏవైనా సంబంధాలు ఉన్న ఇతర పరిస్థితులు లేదా అవగాహన ఉన్నప్పటికీ, ఈ ఒప్పందం ప్రకారం భాగస్వామికి పీపుల్‌లింక్ యొక్క మొత్తం బాధ్యత ఏదైనా INR (భారతీయ రూపాయి వెయ్యి మాత్రమే) మించకూడదు  మరియు ఈ ఒప్పందం ప్రకారం భాగస్వామి చేసిన ఏ రకమైన నష్టానికి సంబంధించిన అన్ని వాదనలు, మరియు ఈ ఒప్పందాన్ని ప్రవేశపెట్టడం ద్వారా భాగస్వామి ఇక్కడ ఉన్న పరిమితులను గుర్తిస్తారు  n పీపుల్ లింక్ యొక్క బాధ్యత. ",
    aff_str47_para:
      "ఇక్కడ ఉన్న పార్టీలు స్వతంత్ర కాంట్రాక్టర్‌గా తమ తరపున పనిచేస్తాయి. ఈ ఒప్పందంలో ఏదీ జాయింట్ వెంచర్, ఏజెన్సీ, ఫ్రాంచైజ్, అమ్మకాల ప్రతినిధి, ఉద్యోగం లేదా ఈ ఒప్పందంలో పేర్కొన్న సంబంధాలకు మించిన పార్టీల మధ్య ఏదైనా ఇతర సంబంధాన్ని సృష్టించదు, మరియు భాగస్వామి  పీపుల్‌లింక్ తరపున వ్యవహరించకుండా స్పష్టంగా మినహాయించబడింది. ఈ ఒప్పందం ప్రకారం భాగస్వామి లైసెన్స్ పొందిన మార్కుల ప్రదర్శన, భాగస్వామి సమర్పించిన ఇతర కంటెంట్ లేదా భాగస్వామి మరియు మూడవ పార్టీల మధ్య పరిచయం ఇక్కడ వివరించిన సంబంధాలను తప్పుగా సూచించదు. ",
    aff_str48_para:
      'పీపుల్‌లింక్ మరియు దాని అనుబంధ సంస్థలు, అనుబంధ సంస్థలు, అధికారులు మరియు ఉద్యోగులు ("పీపుల్‌లింక్ నష్టపరిహార పార్టీలు") ఏదైనా ఖర్చులు, బాధ్యతలు, నష్టాలు మరియు ఖర్చులు (సహేతుకమైన న్యాయవాదుల ఫీజులతో సహా కానీ పరిమితం కాకుండా) నుండి హాని కలిగించకుండా, నష్టపరిహారాన్ని, రక్షణను కలిగి ఉంటుంది.  కిందివాటి నుండి ఉత్పన్నమయ్యే పీపుల్ లింక్ నష్టపరిహార పార్టీలకు వ్యతిరేకంగా ఏదైనా మూడవ పక్షం తీసుకువచ్చిన ఏదైనా దావా, దావా, చర్య, డిమాండ్ లేదా కొనసాగింపు: (i) భాగస్వామి ఒప్పందాన్ని ఉల్లంఘించడం;  (ii) భాగస్వామి లేదా దాని ఉద్యోగులు, ఏజెంట్లు లేదా కాంట్రాక్టర్ల నిర్లక్ష్యం, స్థూల నిర్లక్ష్యం లేదా ఉద్దేశపూర్వక దుష్ప్రవర్తన;  లేదా (iii) ఇక్కడ ప్రస్తావించిన చట్టాలు మరియు నిబంధనలను పాటించడంలో భాగస్వామి లేదా దాని ఉద్యోగులు, ఏజెంట్లు, కాంట్రాక్టర్లు లేదా ఆహ్వానితుల వైఫల్యం. ',
    aff_str49_para:
      'బలవంతపు మేజూర్ యొక్క పరిస్థితి ద్వారా అలా చేయకుండా నిరోధించబడితే, ఇక్కడ ఒక పార్టీ తన బాధ్యతలను నిర్వర్తించాల్సిన అవసరం లేదు.  "ఫోర్స్ మేజూర్" సంఘటనలలో పార్టీల యొక్క సహేతుకమైన నియంత్రణకు మించిన సంఘటనలు ఉంటాయి, వాటిలో దేవుని చర్యలు, ప్రభుత్వ చర్యలు, ప్రకృతి చర్యలు, సమ్మెలు లేదా అల్లర్లు, అలాగే పీపుల్‌లింక్స్ సరఫరాదారుల యొక్క సరికాని పనితీరు లేదా వస్తువులు, పదార్థాలు లేదా సాఫ్ట్‌వేర్‌లలో లోపాలు  మూడో వ్యక్తులు.  బలవంతపు మేజూర్ యొక్క పరిస్థితి ముప్పై (30) రోజులకు మించి ఉంటే, ఇతర పార్టీకి వ్రాతపూర్వక నోటీసుపై పార్టీ ఈ ఒప్పందాన్ని ముగించవచ్చు. ',
    aff_str410_para:
      "ఈ ఒప్పందం దాని యొక్క విషయానికి సంబంధించి పార్టీల మధ్య ఉన్న మొత్తం ఒప్పందాన్ని మరియు పార్టీల సంబంధిత బాధ్యతలు మరియు కట్టుబాట్లను సూచిస్తుంది. ఈ ఒప్పందంలో పేర్కొన్న ఒప్పందాలపై ఇతర పత్రాలు లేదా పార్టీల మధ్య మౌఖిక లేదా వ్రాతపూర్వక ఒప్పందాలు ఏ విధంగానూ ప్రతిబింబించవు,  మరియు ఈ ఒప్పందం రెండు పార్టీలు అమలు చేసిన రచనలో తప్ప సవరించబడదు. సాధ్యమైనప్పుడల్లా, ఈ ఒప్పందం యొక్క ప్రతి నిబంధన వర్తించే చట్టం ప్రకారం ప్రభావవంతంగా మరియు చెల్లుబాటు అయ్యే విధంగా వివరించబడుతుంది, అయితే ఈ ఒప్పందం యొక్క ఏదైనా నిబంధన ఉంటే  వర్తించే చట్టం ప్రకారం నిషేధించబడింది లేదా చెల్లదు, అటువంటి నిబంధన లేదా ఈ ఒప్పందం యొక్క మిగిలిన నిబంధనలను చెల్లుబాటు చేయకుండా, అటువంటి నిబంధన అటువంటి నిషేధం లేదా చెల్లని మేరకు మాత్రమే పనికిరాదు. ",
    aff_str411_para:
      "ఈ ఒప్పందం ప్రతిరూపాలలో సంతకం చేయబడవచ్చు మరియు అలాంటి ప్రతిరూపాలు చెల్లుబాటు అయ్యేవి మరియు అసలు సంతకాలు మార్పిడి చేసినట్లుగానే పార్టీల మీద కట్టుబడి ఉంటాయి.",
    aff_str412_para:
      "ఈ ఒప్పందం హైదరాబాద్, తెలంగాణ, భారతదేశం యొక్క అధికార పరిధిలోని చట్టాలచే నిర్వహించబడుతుంది, చట్ట వివాదాల యొక్క ఏ సూత్రాలకు ప్రభావం చూపకుండా. అధికార పరిధి భారతదేశంలోని హైదరాబాద్, తెలంగాణ జిల్లా కోర్టులలో ప్రత్యేకంగా ఉంటుంది. ఏకైక మరియు ప్రత్యేకమైన అధికార పరిధి.  మరియు ఈ ఒప్పందం నుండి ఉత్పన్నమయ్యే ఏదైనా వ్యాజ్యం కోసం వేదిక హైదరాబాద్, తెలంగాణ, భారతదేశంలో ఉన్న తగిన జిల్లా లేదా రాష్ట్ర న్యాయస్థానం, మరియు పార్టీలు పెంచకూడదని అంగీకరిస్తాయి మరియు వేదిక లేదా ఫోరమ్ కాని సౌలభ్యం ఆధారంగా ఏదైనా అభ్యంతరాలు లేదా రక్షణలను వదులుకుంటాయి.  ఈ ఒప్పందం ప్రకారం లేదా వాటికి సంబంధించిన ఏదైనా చట్టపరమైన చర్యను ప్రారంభించడానికి ముందు, ఒక పార్టీ ఒక వివాదం గురించి ఇతర పార్టీ వ్రాతపూర్వక నోటీసును అందిస్తుంది మరియు ముప్పై (30) లోపు అటువంటి వివాదాన్ని త్వరగా పరిష్కరించే ఉద్దేశ్యంతో పార్టీలు చురుకుగా మరియు మంచి విశ్వాసంతో చర్చలు జరపాలి.  అటువంటి నోటీసు అందుకున్న వ్యాపార రోజులు. ",
    aff_str40: "ఒప్పందం యొక్క మార్పు.",
    aff_str40_para:
      "పీపుల్ లింక్ ఈ ఒప్పందాన్ని ఎప్పటికప్పుడు దాని సహేతుకమైన అభీష్టానుసారం సైట్లో మార్పును పోస్ట్ చేయడం ద్వారా (www.peoplelinkvc.com/affiliatestermsofservice వద్ద) సవరించవచ్చు లేదా భాగస్వామిని ఇమెయిల్ ద్వారా తెలియజేయవచ్చు. భాగస్వామి అలాంటి మార్పుకు అభ్యంతరం తెలిస్తే, భాగస్వామి రద్దు చేయవచ్చు  కారణం కోసం ఈ ఒప్పందం. ఈ ఒప్పందంలో మార్పుల గురించి నోటీసు అందుకున్న తరువాత భాగస్వామి ప్రోగ్రామ్‌లో నిరంతరం పాల్గొనడం ఈ ఒప్పందాన్ని సవరించినట్లుగా అంగీకరించడం. ",
    qualified_ref: "క్వాలిఫైడ్ రెఫరల్స్",
    mean_referrals: "రెఫరల్స్ అర్థం",
    apply: "Apply",
    company_code_validate: "దయచేసి ధృవీకరించడానికి కంపెనీ కోడ్‌ను నమోదు చేయండి",
    golive_company_code: "గోలివ్ కంపెనీ కోడ్",
    accept_TC: "పై నిబంధనలు మరియు షరతులను నేను అంగీకరిస్తున్నాను",
    by_sub_referral:
      "రెఫరల్ భాగస్వామి అనువర్తనాన్ని సమర్పించడం ద్వారా, భాగస్వామి ఈ ఒప్పందాన్ని చదివినట్లు, అర్థం చేసుకున్నట్లు మరియు అంగీకరించినట్లు ప్రాతినిధ్యం వహిస్తుంది మరియు హామీ ఇస్తుంది.",
    term: "నిబంధనలు",
    found_at: "found at",
    our_privacy_policy: "మరియు మా గోప్యతా విధానం",
    privacy_policy: "గోప్యతా విధానం",
    as_applicable: "వర్తించే విధంగా.",
    "screen-sharing": "స్క్రీన్ భాగస్వామ్యం",
    whiteboard_access: "వైట్బోర్డ్ యాక్సెస్",
    Document_access: "పత్ర ప్రాప్యత",
    share_the_screen: "స్క్రీన్ భాగస్వామ్యం!",
    to_collaborate: "సహకరించడానికి!",
    share_document: "పత్రాన్ని భాగస్వామ్యం చేయండి!",

    exit_or_end: "సెషన్ నుండి నిష్క్రమించాలా లేదా ముగించాలా?",
    exit_from_meeting: "సెషన్ నుండి నిష్క్రమించాలా?",
    are_sure_exit_meeting_everyone:
      "మీరు ఖచ్చితంగా సెషన్ నుండి నిష్క్రమించాలనుకుంటున్నారా? మీరు అందరి కోసం సెషన్‌ను ముగించవచ్చు లేదా మీరు సమావేశం నుండి నిష్క్రమించవచ్చు.",
    are_sure_exit_meeting:
      "మీరు ఖచ్చితంగా సెషన్ నుండి నిష్క్రమించాలనుకుంటున్నారా?",
    exit_meeting: "సెషన్ నుండి నిష్క్రమించు",
    end_for_all: "అందరికీ ముగింపు సెషన్",
    end_meeting: "సెషన్ ముగింపు",
    will_let_alone_exit:
      "సెషన్ నుండి నిష్క్రమించడానికి లేదా నిష్క్రమించడానికి మిమ్మల్ని ఒంటరిగా అనుమతిస్తుంది.",
    will_end_for_everyone:
      "కాన్ఫరెన్స్‌లోని ప్రతి ఒక్కరికీ (పాల్గొనేవారు & హాజరైన వారందరూ) సమావేశాన్ని ముగించారు.",
    user_already_exists: "వినియోగదారులు ఇప్పటికే ఉన్నారు",
    already_user_avail:
      "కాన్ఫరెన్స్‌లో ఇప్పటికే కొంతమంది వినియోగదారులు అందుబాటులో ఉన్నారు. ",
    if_like_continue: "మీరు కొనసాగించాలనుకుంటే, క్లిక్ చేయండి ",
    force_start_meetinh: "బలవంతంగా మరొక సమావేశాన్ని ప్రారంభించండి ",
    otherwise_click: "లేకపోతే క్లిక్ చేయండి ",
    to_go_back: "తిరిగి వెళ్ళుటకు.",

    //New by Keerthi - 17th Sep 2020
    lang_settings: "భాష సెట్టింగులు",
    lang_info: "అప్లికేషన్‌ను ఉపయోగించడానికి మీకు ఇష్టమైన భాషను ఎంచుకోండి.",
    select_language: "భాషను ఎంచుకోండి",
    settings_languages: "భాషలు",

    rec_plugin: "Recording Plugin",
    rec_heading1:
      "How to install and manage InstaVC Screen-Video Recorder with the plugin",
    rec_step1: "Step 1: Copy & open Link in Chrome",
    rec_step1_para: "First copy the link ",
    rec_step1_para_br:
      "from here and open it in chrome to add the plugin to your browser. Click on ",
    rec_step1_para_bold: "Add to Chrome",
    rec_step1_para_ct: "to add this extension.",

    rec_step2: "Step 2: Pop Up for Permission",
    rec_step2_para_br:
      "When you click on Add to chrome, here appears a popup asking for permission to display notification access your content. Click on ",
    rec_step2_para_bold: "Add Extension",
    rec_step2_para_ct: "to proceed.",

    rec_step3: "Step 3: Extension Added to Chrome",
    rec_step3_para:
      "When the extension is added to chrome, it shows a window giving you an information with a plugin icon and how to manage this plugin from here.",

    rec_step4: "Step 4: Pin the plugin on the toolbar",
    rec_step4_para_br:
      "To pin the plugin to your toolbar, you need to click on manage extensions, go to ",
    rec_step4_para_bold: "InstaVC Screen-Recording",
    rec_step4_para_ct: "and click on the pin icon to add.",

    rec_step5: "Step 5: Extension/Plugin Pinned to Toolbar",
    rec_step5_para:
      "Once the extension is pinned, you can now see an instavc recording icon in your browser toolbar and start using it for easy access.",

    rec_step6: "Step 6: InstVC Recorder Setup",
    rec_step6_para_br:
      "Once you have installed the plugin and the next time when you open it, you can now see the ",
    rec_step6_para_bold: "InstaVC Recorder Setup",
    rec_step6_para_ct:
      "page to enable or disable the recording tools. By default both the options will be enabled. Click on ",
    rec_step6_para_bold1: "Next",
    rec_step6_para_ct1: "to continue.",

    rec_step7: "Step 7: Additional Permissions",
    rec_step7_para_br:
      "Once the Next button is clicked, system will then show you a popup asking for additional permissions to read and change your data. Click ",
    rec_step7_para_bold: "Allow",
    rec_step7_para_ct: "to continue.",

    rec_step8: "Step 8: Permissions Allowed",
    rec_step8_para:
      "After allowing the permission, this page now gets frozen or in a disabled mode from where you can now start exploring recording options now.",

    rec_heading2: "Desktop Screen-Recording Plugin",

    rec_step9: "Step 9: Desktop Screen-Recording",
    rec_step9_para_br:
      "After allowing all permissions, you can now access recording menus from the plugin extension in your toolbar. Click on it to see further options. Here we have selected ",
    rec_step9_para_bold: "Desktop Screen Recording",
    rec_step9_para_ct: "and click on the",
    rec_step9_para_bold1: "Record",
    rec_step9_para_ct1: "button to start.",

    rec_step9a: "Step 9(a): Share your Screen Popup",
    rec_step9a_para_br:
      "Now the system shows up this popup asking to select the contents of your screen, whether its an Entire Screen or only application window. Click on the tab which you want to share and click on ",
    rec_step9a_para_bold: "Share",
    rec_step9a_para_ct:
      "button and go to that screen which you want to start recording.",

    rec_step9b: "Step 9(b): Desktop Screen Recording Started",
    rec_step9b_para_br:
      "The Desktop Screen recording is now started and you can see a blink in the toolbar while its in recording mode. Also, you can see a tab at the bottom showing buttons for ",
    rec_step9b_para_bold: "Stop Sharing",
    rec_step9b_para_ct: "or",
    rec_step9b_para_bold1: "Hide",
    rec_step9b_para_ct1:
      ". You can see the bottom message on any screen you are opening until you are in the desktop screen recording mode.",

    rec_step9c: "Step 9(c): Restart / Pause or Stop Desktop Screen Recording",
    rec_step9c_para_br:
      "Once you want to stop Recording. Click on the plugin in the toolbar and here you can see the options to ",
    rec_step9c_para_bold: "Restart, Pause",
    rec_step9c_para_ct: "and",
    rec_step9c_para_bold1: "Stop",
    rec_step9c_para_ct1: "buttons. You can click any of those accordingly.",

    rec_step9d: "Step 9(d):Recent Recording View",
    rec_step9d_para_br:
      "Once you stop the recording from the toolbar, the recent recording will now automatically open the recording in a new tab along with Title and ",
    rec_step9d_para_bold: "Download",
    rec_step9d_para_ct:
      "option in the top and the recording details in the right column.",

    rec_heading3: "Browser Tab Screen-Recording Plugin",

    rec_step10: "Step 10: Browser Tab Screen-Recording",
    rec_step10_para_br: "When we want to select ",
    rec_step10_para_bold: "Browser Tab",
    rec_step10_para_ct:
      "option for recording your browser screen. First open your screen(url) in chrome whichever you want to record and then open the plugin and click on Browser Tab, adjust microphone options and then click",
    rec_step10_para_bold1: "Record",
    rec_step10_para_ct1: "button to start recording.",

    rec_step10a: "Step 10(a): Browser Tab is being Recorded",
    rec_step10a_para:
      "Once the Browser tab is started recording, you can see a red dot blinking in your toolbar which indicates the tab is being recorded and also a blue box blinking in your browser title bar",

    rec_step10b: "Step 10(b): Record another tab",
    rec_step10b_para_br:
      "At the time of current screen recording, if you open another url and open the plugin, it will show you the recording status along with an option",
    rec_step10b_para_bold: "Record This Tab",
    rec_step10b_para_ct:
      "if you want to change the recording scree to the new url. Meanwhile the blue box blinking in the title bar of the browser indicates the tab that is being recorded at the moment.",

    rec_step10c: "Step 10(C): Stop and View recording",
    rec_step10c_para_br:
      "Later, when you stop the recording, the browser itself opens the recording in a new tab along with Title and",
    rec_step10c_para_bold: "Download",
    rec_step10c_para_ct:
      "Option at the top and the recording details in the right column.",

    rec_heading4: "Webcam Recording",

    rec_step11: "Step 11: Start Webcam Screen Recording",
    rec_step11_para_br:
      "When you start with Webcam screen recording, make sure to select the microphone & camera settings among the devices detected by the plugin. and then click on the",
    rec_step11_para_bold: "Record",
    rec_step11_para_ct: "button to start with.",

    rec_step11a: "Step 11(a): Webcam opens Self Video and starts Recording",
    rec_step11a_para_br:
      "The recording opens a web page with yourself video with",
    rec_step11a_para_bold: "Pause",
    rec_step11a_para_ct: "and",
    rec_step11a_para_bold1: "Stop",
    rec_step11a_para_ct1: "recording options at the bottom.",

    rec_step11b: "Step 11(b): View Webcam Recorded Video",
    rec_step11b_para:
      "When you stop the recording in the previous screen, the browser then opens the recording in a new tab to view and download along with the recording details.",

    rec_heading5: "Top Menus in Recording Plugin",

    rec_step12: "Step 12: Navigation Menus",
    rec_step12_para_br:
      "The plugin has few navigation menus to fetch your data as well as manage different actions related to the plugin. One of them is a",
    rec_step12_para_bold: "Hamburger Menu",
    rec_step12_para_ct: "Click on it to open.",

    rec_step12a: "Step 12(a): Open Hamburger Menu",
    rec_step12a_para_br: "On click of",
    rec_step12a_para_bold: "Hamburger Menu",
    rec_step12a_para_ct: ", you can find 2 tabs named",
    rec_step12a_para_bold1: "My Recordings",
    rec_step12a_para_ct1: "and",
    rec_step12a_para_bold2: "Options",
    rec_step12a_para_ct2:
      "which manages all the data you have been recording and options you have enabled or disabled for that plugin. Click on",
    rec_step12a_para_bold3: "My Recordings",
    rec_step12a_para_ct3: "to see the videos you have recorded till date.",

    rec_step12b: "Step 12(b): Access My Recordings",
    rec_step12b_para_br: "There is another way of accessing",
    rec_step12b_para_bold: "My Recordings",
    rec_step12b_para_ct:
      ", page from the top menu in the plugin which can be considered as a shortcut to navigate.",

    rec_step12c: "Step 12(c): My Recordings",
    rec_step12c_para:
      "Here will be the detailed list of videos(recordings) you have recorded till date. Each video contains the date, duration, size of the video along with delete icon in the thumbnail view. When you click on any video it opens the details in the view recording page. Note that all the videos will be stored locally here.",

    rec_step12d: "Step 12(d): Delete All recordings",
    rec_step12d_para_br:
      "Looking at My recordings Page, there is a more icon in the top right corner which opens the",
    rec_step12d_para_bold: "Delete All",
    rec_step12d_para_ct:
      "option to easily delete all recordings with a single click.",

    rec_step12e: "Step 12(e): Side Navigation",
    rec_step12e_para_br:
      "Instead of opening the plugin again and change, You can directly navigate to another tab from here using the Hamburger Menu in the top left corner of the page that opens the navigation to navigate to the",
    rec_step12e_para_bold: "Options",
    rec_step12e_para_ct: "page",

    rec_heading6: "Plugin Options",

    rec_step13: "Step 13: Plugin Options",
    rec_step13_para_br:
      "On click on Hamburger Menu, you can find another tab named Options which manages all the options you have enabled or disabled for that plugin. Click on",
    rec_step13_para_bold: "Options",
    rec_step13_para_ct: "to see the options that are enabled for you.",

    rec_step13a: "Step 13(a): Recorder Options",
    rec_step13a_para:
      "Recorder Options ask you for various options like video storage, Notifications, Keyboard Shortcuts",

    rec_step13b: "Step 13(b): Recorder Options",
    rec_step13b_para:
      "Recorder Options contain various other options like Recording Settings and advanced.",

    rec_heading7: "Plugin Notifications",

    rec_step14: "Step 14: Plugin Notifications",
    rec_step14_para:
      "On the top navigation part, you can find a bell icon for notifications if any related to instavc screen recording plugin.",

    rec_step14a: "Step 14(a): Open Notifications",
    rec_step14a_para:
      "On click on the notification icon, you can find the list of notifications if any or it shows an empty slide in.",

    rec_heading8: "Recording Settings",

    rec_step15: "Step 15: Settings",
    rec_step15_para_br:
      "Then comes the last navigation menu on the top right corner named",
    rec_step15_para_bold: "Settings",
    rec_step15_para_ct:
      "where you can open and manage the recording settings accordingly.",

    rec_step15a: "Step 15(a): Advanced Settings Options",
    rec_step15a_para:
      "Here you can adjust the settings based on the Resize tab, Limit resolution and maximum frame rate which are given by plugin.",

    crteContent_upload_medialist: "Uploaded Media List",
    content_upld_desc_txt:
      "The files you upload here will be available to users who view content.",
    content_browse_txt: "Browse Files to Upload",
    content_upld_types:
      "Files with only .jpg, .jpeg, .png, and .pdf are allowed limiting the max size upto 15MB",

    video_qlty: "వీడియో నాణ్యత",
    audio_qlty: "ఆడియో నాణ్యత",
    cntnt_shrng: "కంటెంట్ భాగస్వామ్యం",
    fdb_poor: "పేద",
    fdb_good: "మంచిది",
    fdb_avg: "సగటు",
    fdb_excellent: "అద్భుతమైన",
    share_feedback: "మీ ఫీడ్‌బ్యాక్‌ను భాగస్వామ్యం చేయండి",
    ovrl_rating: "మొత్తం రేటింగ్",
    fdb_cmnts: "మీ వ్యాఖ్యలు ఎంతో ప్రశంసించబడ్డాయి",
    no_thnks: "వద్దు ధన్యవాదాలు",
    upload_size_max_15mb: "మీరు అప్‌లోడ్ చేయవచ్చు గరిష్ట పరిమాణ పరిమితి 15MB",

    pastMeeting_feedback: "అభిప్రాయం",
    pastMeeting_comments: "వ్యాఖ్యలు",

    microsoft_webplugin: "మైక్రోసాఫ్ట్ lo ట్లుక్ వెబ్ ప్లగిన్",
    microsoft_installable: "మైక్రోసాఫ్ట్ lo ట్లుక్ ఇన్‌స్టాల్ చేయదగిన ప్లగిన్",
    outlook_installable: "Lo ట్లుక్ ఇన్‌స్టాల్ చేయదగినది",
    customization_installer: "అనుకూలీకరణ ఇన్స్టాలర్ను ఎలా యాక్సెస్ చేయాలి",
    plugin_step1: "దశ 1: ఫైల్‌ను డౌన్‌లోడ్ చేయడానికి లింక్‌పై క్లిక్ చేయండి",
    click_link_download: "ఫైల్‌ను డౌన్‌లోడ్ చేయడానికి లింక్‌ను క్లిక్ చేయండి",
    first_click_link: "మొదట క్రింది లింక్‌పై క్లిక్ చేయండి",
    to_download_file:
      "మీ సిస్టమ్‌లోకి ఫైల్‌ను డౌన్‌లోడ్ చేయడానికి. అప్పుడు ఇన్‌స్టాలేషన్ ప్రారంభించడానికి డౌన్‌లోడ్ చేసిన ఫైల్‌ను తెరిచి క్లిక్ చేయండి",
    install_txt: "ఇన్‌స్టాల్ చేయండి",
    plugin_step2: "దశ 2: అనుకూలీకరణ వ్యవస్థాపించబడింది",
    plugin_step2_para:
      "Once you start installing, wait untill the file gets installed and you get a popup showing successfully Installed and then close.",
    plugin_step3: "దశ 3: Out ట్లుక్ తెరవండి & సమావేశాలకు వెళ్ళండి",
    plugin_step3_para:
      "ఇన్‌స్టాలేషన్ తర్వాత, Microsoft Outlookని తెరిచి, సెషన్‌కు వెళ్లండి.",
    plugin_step3_para1: "కొత్త ఇమెయిల్ > సెషన్‌లకు వెళ్లండి",
    plugin_step4: "దశ 4: సెషన్ తెరవండి",
    plugin_step4_para:
      "ఒకసారి సెషన్‌ల విండో ఎగువ ట్యాబ్‌ల జాబితాలోకి తెరిచిన తర్వాత, మీరు ట్యాబ్‌ను క్లిక్ చేయడం కొనసాగించవచ్చు",
    plugin_step4_para1: "పీపుల్‌లింక్",
    plugin_step5: "దశ 5: షెడ్యూల్ సమావేశం",
    plugin_step5_para: "పీపుల్‌లింక్ కింద మీకు పేరున్న ఉప టాబ్ ఉంది",
    plugin_step5_para1: "షెడ్యూల్ సమావేశం.",
    plugin_step5_para2:
      "దానిపై క్లిక్ చేయండి మరియు మీరు విండో యొక్క కుడి వైపున షెడ్యూల్ ఎంపికలను చూడవచ్చు. ఇక్కడ మీరు inVC షెడ్యూల్‌లను నిర్వహించవచ్చు.",
    plugin_step6: "దశ 6: షెడ్యూల్‌లను నిర్వహించండి లేదా అనుకూలీకరించండి",
    plugin_step6_para:
      "ఇక్కడ మీరు గదులు, సమయాల జాబితా ద్వారా షెడ్యూల్‌లను నిర్వహించవచ్చు లేదా అనుకూలీకరించవచ్చు మరియు ఇక్కడ నుండి క్రొత్త షెడ్యూల్‌ను సృష్టించవచ్చు, ఇది మిమ్మల్ని బ్రౌజర్‌కు మళ్ళిస్తుంది మరియు తిరిగి క్లుప్తంగకు మళ్ళిస్తుంది.",
    plugin_step6_para1: "షెడ్యూల్‌తో మీరు సరేనంటే మీరు క్లిక్ చేయవచ్చు",
    plugin_step6_para2: "లింక్ పొందండి",
    plugin_step7: "లింక్ రూపొందించబడింది",
    plugin_step7_para:
      "మెయిల్‌లో ఉత్పత్తి చేయబడిన మరియు కంపోజ్ చేసిన లింక్‌ను ఇక్కడ పొందుతారు, ఇది మీరు ఆన్‌లైన్‌లో భాగస్వామ్యం చేయడానికి కూడా ఉపయోగించవచ్చు లేదా మరింత ముందుకు సాగవచ్చు.",

    sessions: "సెషన్స్",
    schedule_session: "షెడ్యూల్ సెషన్",
    join_session: "సెషన్‌లో చేరండి",
    no_of_sessions_attended_by_teacher: "ఉపాధ్యాయులు హాజరైన సెషన్ల సంఖ్య",
    no_of_sessions_attended_by_student: "విద్యార్థులు హాజరైన సెషన్‌ల సంఖ్య",
    teacher_attendance: "ఉపాధ్యాయుల హాజరు",
    students_attendance: "విద్యార్థుల హాజరు",
    virtual_classroom:
      "అసమానమైన అనుభవంతో ఆన్‌లైన్ వర్చువల్ క్లాస్‌రూమ్ ప్లాట్‌ఫారమ్",
    today_sessions: "ఈరోజు సెషన్స్",
    no_sessions: "సెషన్‌లు లేవు...",
    session_quote:
      "ప్రాథమిక మరియు అధునాతన సమావేశ లక్షణాలతో సెషన్ పాస్‌వర్డ్ సృష్టిని ప్రారంభించడం లేదా డైనమిక్ మీటింగ్ ఐడిని ప్రారంభించడం వంటి ఎంపికలతో కొత్త సెషన్‌ను షెడ్యూల్ చేయండి.",
    session_title: "సెషన్ శీర్షిక",
    create_session_name: "సెషన్ పేరును సృష్టించండి",
    session_password: "సెషన్ పాస్‌వర్డ్",
    meeting_password: "సెషన్ పాస్వర్డ్ను సృష్టించండి",
    selectClass: "తరగతిని ఎంచుకోండి",
    selectSubject: "సబ్జెక్ట్ ఎంచుకోండి",
    select_time: "సమయాన్ని ఎంచుకోండి",
    select_meeting_date_time: "సెషన్ తేదీ & సమయాన్ని ఎంచుకోండి",
    select_slot: "స్లాట్‌ని ఎంచుకోండి",
    select_numberof_participant_seats: "పాల్గొనే సీట్ల సంఖ్యను ఎంచుకోండి",
    advanced_options: "అధునాతన ఎంపికలు",
    custom_registration_url: "అనుకూల నమోదు URL",
    custom_feedback_url: "అనుకూల అభిప్రాయ URL",
    allow_guest_control: "నియంత్రించడానికి అతిథులను అనుమతించండి",
    meeting_details: "సెషన్ వివరాలు",
    meeting_title: "సెషన్ శీర్షిక",
    meeting_type: "సెషన్ రకం",
    seats: "సీట్లు",
    meeting_Password: "సెషన్ పాస్వర్డ్",
    meeting_only_url: "సెషన్ మాత్రమే URL:",
    join_meeting_quote:
      "పాల్గొనేవారిని ఆహ్వానించకుండా లేదా ఆహ్వానించకుండా సెషన్‌లో చేరండి",
    copy_invitation: "ఆహ్వానాన్ని కాపీ చేయండి",
    invite_users_list: "ఆహ్వానించండి - వినియోగదారుల జాబితా",
    update_meeting: "సెషన్‌ను నవీకరించండి",
    custom: "కస్టమ్",
    frequency: "తరచుదనం",
    occurences_end: "సంభవం ముగుస్తుంది",
    occurences: "సంఘటనలు",
    hr: "గం",
    every_day: "ప్రతి రోజు",
    hours: "గంటలు",
    hour: "గంట",
    errorTxt_slots: "మీరు అనుకూల సమయాన్ని పూరించాలి - గంటలు లేదా నిమిషాలు",
    participantSeats: "పార్టిసిపెంట్ సీట్లు",
    participant_seat: "పాల్గొనే సీటు",
    subjects: "సబ్జెక్టులు",
    visible: "కనిపించే",
    hidden: "దాచబడింది",
    create_topic: "అంశాన్ని సృష్టించండి",
    edit_topic: "అంశాన్ని సవరించండి",
    topicName: "అంశం పేరు",
    topicDescripiton: "అంశం వివరణ",
    public: "ప్రజా",
    classDescription: "తరగతి వివరణ",
    editNewClass: "కొత్త తరగతిని సవరించండి",
    topics: "అంశాలు",
    topicView: "టాపిక్ వీక్షణ",
    no_of_sessions_conducted: "నిర్వహించిన సెషన్ల సంఖ్య",
    no_of_students_attended_session: "మీ సెషన్‌లకు హాజరైన విద్యార్థుల సంఖ్య",
    yourAssignments: "మీ అసైన్‌మెంట్‌లు",
    attendance: "హాజరు",
    recent_topics: "ఇటీవలి అంశాలు",
    no_subjects: "ఇంకా సబ్జెక్ట్‌లు ఏవీ సృష్టించబడలేదు!",
    no_subjects_create:
      "ఎగువన సృష్టించు సబ్జెక్ట్ బటన్‌ను క్లిక్ చేయడం ద్వారా కొత్త విషయాన్ని సృష్టించండి",
    no_topics: "ఇంకా అంశాలు ఏవీ సృష్టించబడలేదు!",
    no_topics_create:
      "ఎగువన సృష్టించు టాపిక్ బటన్‌ను క్లిక్ చేయడం ద్వారా టాపిక్‌ని సృష్టించండి",
    assgnlist_noassignments: "ఇంకా అసైన్‌మెంట్‌లు ఏవీ కేటాయించబడలేదు!",
    assgnlist_assign_new_assign:
      "ఎగువ అసైన్‌మెంట్ బటన్‌ను క్లిక్ చేయడానికి కొత్త అసైన్‌మెంట్‌ను కేటాయించండి",
    start_date_time: "ప్రారంభ తేదీ & సమయం",
    end_date_time: "ముగింపు తేదీ & సమయం",
    join_conference_quote:
      "సెషన్‌లో చేరడానికి, దిగువ ఇన్‌పుట్ బాక్స్‌లో సెషన్ IDని అందించండి",
    edit_student: "విద్యార్థిని సవరించండి",
    editTeacher: "గురువును సవరించండి",
    subject_name: "విషయం పేరు",
    subject_description: "విషయ వివరణ",
    select_type: "రకాన్ని ఎంచుకోండి",
    others: "ఇతరులు",
    Institute_name: "సంస్థ పేరు",
    first_name_contact: "పరిచయం యొక్క మొదటి పేరు",
    last_name_contact: "సంప్రదింపు చివరి పేరు",
    institute_type: "ఇన్స్టిట్యూట్ రకం",
    institute_name: "సంస్థ పేరు",
    contact_number: "సంప్రదింపు నంబర్",
    signup_as_institute: "ఇన్‌స్టిట్యూట్‌గా సైన్ అప్ చేయండి",
    signup_as_student: "విద్యార్థిగా సైన్ అప్ చేయండి",
    state: "రాష్ట్రం",
    city: "నగరం",
    institute_name_error: "ఇన్స్టిట్యూట్ పేరు అక్షరాలు మాత్రమే అయి ఉండాలి",
    institute_type_error: "ఇన్స్టిట్యూట్ రకాన్ని ఎంచుకోవాలి",
    address_error: "చిరునామా ప్రత్యేక అక్షరాలను అంగీకరించవచ్చు",
    student: "విద్యార్థి",
    institute: "ఇన్స్టిట్యూట్",
    signUpas: "ఇలా సైన్ అప్ చేయండి",
    submitted: "సమర్పించారు",
    notSubmitted: "సమర్పించలేదు",
    review: "సమీక్ష",
    inReview: "పరిశీలించబడుతోంది",
    questionTitle: "ప్రశ్న శీర్షిక",
    questionDescription: "ప్రశ్న వివరణ",
    questionnaireTitle: "ప్రశ్నార్థక శీర్షిక",
    started: "ప్రారంభించారు",
    testName: "పరీక్ష పేరు",
    timeTaken: "తీసుకున్న సమయం",
    showAnswers: "సమాధానాలను చూపించు",
    downloadCertificate: "సర్టిఫికేట్ డౌన్‌లోడ్ చేయండి",
    startTime: "ప్రారంభ సమయం",
    endTime: "ముగింపు సమయం",
    assignmentTitle: "అసైన్‌మెంట్ శీర్షిక",
    editor: "ఎడిటర్",
    save_submit: "సేవ్ & సమర్పించండి",
    assigned_students: "కేటాయించిన విద్యార్థులు",
    total_marks: "మొత్తం మార్కులు",
    not_yet_Submitted: "ఇంకా సమర్పించబడలేదు",
    completed: "పూర్తయింది",
    due_date: "గడువు తేది",
    marks_obtained: "వచ్చిన మార్కులు",
    assign_marks: "మార్కులు కేటాయించండి",
    home_inclass_copyright: "© 2022 InstaVC Inc. All Rights Reserved.",
    // "© 2022 InstaVC Inc. అన్ని హక్కులు రిజర్వు చేయబడ్డాయి | పవర్డ్‌బై Peoplelink Unified Communication Pvt. Ltd.",
    back_to_classes: "తిరిగి తరగతులకు",
    className: "తరగతి పేరు",
    attendanceReports: "హాజరు నివేదికలు",
    present: "వర్తమానం",
    absent: "గైర్హాజరు",
    ratio: "నిష్పత్తి",
    sessionsAttended: "సెషన్స్‌కు హాజరయ్యారు",
    totalSessions: "మొత్తం సెషన్‌లు",
    filters: "ఫిల్టర్లు",
    teacher: "టీచర్",
    userType: "వినియోగదారు రకం",
    class: "తరగతి",
    clear: "క్లియర్",
    sessionsConducted: "సెషన్స్ నిర్వహించారు",
    Topic: "అంశం",
    uploadMediaSizeLimit: "పరిమాణం పరిమితి 15MB వరకు.",
    assessments: "అంచనాలు",
    assessment: "మూల్యాంకనం",
    totalStudents: "మొత్తం విద్యార్థులు",
    totalAssignments: "మొత్తం అసైన్‌మెంట్‌లు",
    assignmentsCompleted: "అసైన్‌మెంట్‌లు పూర్తయ్యాయి",
    assignmentsPending: "అసైన్‌మెంట్‌లు పెండింగ్‌లో ఉన్నాయి",
    score: "స్కోర్",
    submittedDate: "సమర్పించిన తేదీ",
    dueDateOfSubmission: "సమర్పణ గడువు తేదీ",
    clearSelections: "ఎంపికలను క్లియర్ చేయండి",
    noschedule_meetings: "మీకు రాబోయే సెషన్‌లు ఏవీ లేవు.",
    nopast_meetings: "మీకు గత సెషన్‌లు ఏవీ లేవు",
    id: "ID",
    export: "ఎగుమతి చేయండి",
    import: "దిగుమతి",
    sample_excel: "నమూనా Excel",
    subject_access: "సబ్జెక్ట్ యాక్సెస్",
    submitted_date_time: "సమర్పించిన తేదీ/సమయం",
    passed: "ఉత్తీర్ణులయ్యారు",
    failed: "విఫలమైంది",
    average_score: "సగటు స్కోరు",
    total_reviewed: "మొత్తం సమీక్షించబడింది",
    pending_review: "పెండింగ్ రివ్యూ",
    total_students_finished: "మొత్తం విద్యార్థులు పూర్తి చేసారు",
    total_students_passed: "మొత్తం విద్యార్థులు ఉత్తీర్ణులయ్యారు",
    total_students_failed: "మొత్తం విద్యార్థులు విఫలమయ్యారు",
    total_students_absent: "మొత్తం గైర్హాజరు విద్యార్థులు",
    time_exceed: "సమయ పరిమితి మించిపోయింది",
    time_exceed_assgn_msg:
      "ఈ అసైన్‌మెంట్‌ను సమర్పించాల్సిన సమయ పరిమితి మించిపోయింది",
    time_exceed_quess_msg:
      "ఈ ప్రశ్నాపత్రాన్ని సమర్పించాల్సిన సమయ పరిమితి మించిపోయింది",
    class_code: "తరగతి పేరు",
    updateQuestion: "ప్రశ్నను నవీకరించండి",
    subject_code: "సబ్జెక్ట్ కోడ్",
    enroll: "నమోదు చేయండి",
    create_new_passwd: "కొత్త పాస్‌వర్డ్‌ని సృష్టించండి",
    actions: "చర్యలు",
    please_enter_topic_name: "దయచేసి అంశం పేరును నమోదు చేయండి",
    please_enter_topic_description: "దయచేసి టాపిక్ వివరణను నమోదు చేయండి",
    plz_select_questionary: "దయచేసి ప్రశ్నను ఎంచుకోండి.",
    plz_select_duration_checkbox: "దయచేసి వ్యవధి చెక్‌బాక్స్‌ని ఎంచుకోండి.",
    Plz_select_assignment: "దయచేసి అసైన్‌మెంట్‌ని ఎంచుకోండి.",
    plz_select_valid_date_time:
      "దయచేసి చెల్లుబాటు అయ్యే తేదీ సమయాన్ని ఎంచుకోండి.",
    Plz_enter_valid_marks: "దయచేసి చెల్లుబాటు అయ్యే మార్కులను నమోదు చేయండి.",
    Plz_enter_subject_title: "దయచేసి విషయ శీర్షికను నమోదు చేయండి.",
    class_code:"తరగతి కోడ్",
    Plz_enter_class_name: "దయచేసి తరగతి పేరును నమోదు చేయండి",
    Plz_enter_subject_description: "దయచేసి విషయ వివరణను నమోదు చేయండి.",
    Plz_enter_subject_type: "దయచేసి విషయ రకాన్ని నమోదు చేయండి.",
    Plz_enter_subject_code: "దయచేసి సబ్జెక్ట్ కోడ్‌ని నమోదు చేయండి.",
    Plz_enter_valid_subject_code:
      "దయచేసి చెల్లుబాటు అయ్యే సబ్జెక్ట్ కోడ్‌ని నమోదు చేయండి",
    Plz_enter_class_code: "దయచేసి తరగతి కోడ్‌ని నమోదు చేయండి.",
    Plz_enter_valid_class_code:
      "దయచేసి చెల్లుబాటు అయ్యే తరగతి కోడ్‌ని నమోదు చేయండి",
    plz_enter: "దయచేసి పూరించండి",
    Plz_enter_valid: "దయచేసి చెల్లుబాటు అయ్యేది అని నమోదు చేయండి",
    Plz_enter_title: "దయచేసి శీర్షికను నమోదు చేయండి.",
    Plz_enter_description: "దయచేసి వివరణను నమోదు చేయండి.",
    Plz_select_class: "దయచేసి తరగతిని ఎంచుకోండి",
    Plz_select_subject: "దయచేసి సబ్జెక్ట్‌ని ఎంచుకోండి.",
    something_went_wrong: "ఏదో తప్పు జరిగింది.",
    data_is_not_selected: "డేటా ఎంపిక చేయబడలేదు",
    data_added_successfully: "డేటా విజయవంతంగా జోడించబడింది",
    plz_enter_question: "దయచేసి ప్రశ్నను నమోదు చేయండి",
    plz_enter_marks: "దయచేసి మార్కులను నమోదు చేయండి",
    Plz_select_type: "దయచేసి రకాన్ని ఎంచుకోండి",
    opt_should_have_minimum: "ఎంపికలు కనీసం 2 ఉండాలి",
    opt_should_not_empty: "ఎంపికలు ఖాళీగా ఉండకూడదు",
    opt_should_not_duplicate: "ఎంపికలు నకిలీ చేయకూడదు",
    plz_select_the_answer: "దయచేసి సమాధానాన్ని ఎంచుకోండి",
    question_updated_successfully: "ప్రశ్న విజయవంతంగా నవీకరించబడింది",
    question_created_successfully: "ప్రశ్న విజయవంతంగా సృష్టించబడింది",
    marks_less_than_total_marks:
      "నమోదు చేసిన మార్కులు మొత్తం మార్కుల కంటే తక్కువగా ఉండాలి",
    marks_not_negative: "మార్కులు నెగెటివ్‌లో ఉండకూడదు",
    assgn_successfully_verifed: "అసైన్‌మెంట్ సేవ్ విజయవంతంగా ధృవీకరించబడింది.",
    assgn_save_submited_succes:
      "అసైన్‌మెంట్ సేవ్ చేసి విజయవంతంగా సమర్పించబడింది",
    assgn_save_succes: "అసైన్‌మెంట్ విజయవంతంగా సేవ్ చేయబడింది",
    Plz_enter_valid_content: "దయచేసి చెల్లుబాటు అయ్యే కంటెంట్‌ను నమోదు చేయండి.",
    Assgn_updated_success: "అసైన్‌మెంట్ విజయవంతంగా నవీకరించబడింది",
    Assgn_created_success: "అసైన్‌మెంట్ విజయవంతంగా సృష్టించబడింది",
    Assgn_assigned_success: "అసైన్‌మెంట్ విజయవంతంగా అప్పగించబడింది",
    Assgn_disabled_success: "అసైన్‌మెంట్ విజయవంతంగా నిలిపివేయబడింది.",
    Assgn_enabled_success: "అసైన్‌మెంట్ విజయవంతంగా ప్రారంభించబడింది.",
    Assgn_deleted_success: "అసైన్‌మెంట్ విజయవంతంగా తొలగించబడింది.",
    Quest_creat_success: "ప్రశ్నాపత్రం విజయవంతంగా రూపొందించబడింది",
    Quest_updated_success: "ప్రశ్నాపత్రం విజయవంతంగా నవీకరించబడింది",
    Poll_created_success: "పోల్ విజయవంతంగా సృష్టించబడింది",
    Poll_updated_success: "పోల్ విజయవంతంగా నవీకరించబడింది",
    opt_minimum: "ఎంపికలు కనీసం 2 ఎంపికలను కలిగి ఉండాలి",
    Poll_deleted_success: "పోల్ విజయవంతంగా తొలగించబడింది",
    Poll_enabled_success: "పోలింగ్ విజయవంతంగా ప్రారంభించబడింది",
    Poll_disabled_success: "పోలింగ్ విజయవంతంగా నిలిపివేయబడింది",
    Quest_deleted_success: "ప్రశ్న విజయవంతంగా తొలగించబడింది",
    Invit_send_success: "దయచేసి 15MB ఫైల్ పరిమాణాన్ని తక్కువగా ఎంచుకోండి.",
    teacher_deleted_success: "ఉపాధ్యాయుడు విజయవంతంగా తొలగించబడ్డారు",
    error_some_thing_went_wrong: "లోపం, ఏదో తప్పు జరిగింది.",
    user_updated_success: "వినియోగదారు స్థితి విజయవంతంగా నవీకరించబడింది",
    teacher_updated_success: "టీచర్ విజయవంతంగా నవీకరించబడింది",
    student_remove_success: "విద్యార్థి విజయవంతంగా తీసివేయబడ్డాడు",
    teachers_created_success: "ఉపాధ్యాయులు విజయవంతంగా సృష్టించారు",
    error_occured_try_again: "లోపం సంభవించింది, మళ్లీ ప్రయత్నించండి!",
    please_select_less: "దయచేసి 15MB ఫైల్ పరిమాణాన్ని తక్కువగా ఎంచుకోండి.",
    submit_success: "విజయవంతంగా సమర్పించబడింది",
    grad_updat_success: "గ్రేడ్‌లు విజయవంతంగా నవీకరణలు",
    Quest_delet_succes: "ప్రశ్నాపత్రం విజయవంతంగా తొలగించబడింది",
    Quest_disab_succes: "ప్రశ్నాపత్రం విజయవంతంగా నిలిపివేయబడింది",
    Quest_enabled_succes: "ప్రశ్నాపత్రం విజయవంతంగా ప్రారంభించబడింది",
    student_add_succes: "విద్యార్థి విజయవంతంగా జోడించబడ్డారు",
    plz_select_atleast_std: "దయచేసి కనీసం 1 విద్యార్థిని ఎంచుకోండి",
    fail_add_some_student: "కొంతమంది విద్యార్థులను జోడించడంలో విఫలమైంది",
    std_add_succes: "విద్యార్థులు విజయవంతంగా జోడించబడ్డార",
    sub_updat_succes: "విషయం విజయవంతంగా నవీకరించబడింది",
    sub_creat_succes: "విషయం విజయవంతంగా సృష్టించబడింది",
    sub_dlt_succes: "విషయం విజయవంతంగా తొలగించబడింది",
    sub_enabl_succes: "విషయం విజయవంతంగా ప్రారంభించబడింది",
    sub_disab_succes: "విషయం విజయవంతంగా నిలిపివేయబడింది",
    tchr_add_success: "ఉపాధ్యాయుడు విజయవంతంగా జోడించబడ్డారు",
    plz_slc_atlst_tchr: "దయచేసి కనీసం 1 ఉపాధ్యాయుడిని ఎంచుకోండి",
    tchr_remo_success: "ఉపాధ్యాయుడు విజయవంతంగా తీసివేయబడ్డాడు",
    plz_etr_valid_duration: "దయచేసి చెల్లుబాటు అయ్యే వ్యవధిని నమోదు చేయండి",
    topic_updat_success: "అంశం విజయవంతంగా నవీకరించబడింది",
    class_dlt_success: "తరగతి విజయవంతంగా తొలగించబడింది",
    class_upt_succes: "తరగతి విజయవంతంగా నవీకరించబడింది",
    class_creat_succes: "తరగతి విజయవంతంగా సృష్టించబడింది",
    plz_select_quest: "దయచేసి ప్రశ్నాపత్రాన్ని ఎంచుకోండి",
    first_add_data: "డేటాను జోడించడానికి ప్లస్ బటన్‌పై క్లిక్ చేయండి",
    certfct_generat_success: "సర్టిఫికెట్ విజయవంతంగా రూపొందించబడింది",
    plz_select_min_seats: "దయచేసి కనీసం 2 సీట్లను ఎంచుకోండి",
    plz_enter_mtng_name: "దయచేసి సెషన్ పేరును నమోదు చేయండి",
    fail_to_updt_mtng_try_again:
      "సెషన్‌ను నవీకరించడంలో విఫలమైంది! మళ్ళీ ప్రయత్నించండి",
    fail_update_scdle: "షెడ్యూల్‌ని నవీకరించడంలో విఫలమైంది",
    std_delet_success: "విద్యార్థి విజయవంతంగా తొలగించబడ్డారు",
    std_updat_succes: "విద్యార్థి విజయవంతంగా నవీకరించబడింది",
    std_creat_succes: "విద్యార్థి విజయవంతంగా సృష్టించారు",
    fail_create_some_std: "కొంతమంది విద్యార్థులను సృష్టించడం విఫలమైంది",
    std_creat_success: "విద్యార్థులు విజయవంతంగా సృష్టించారు",
    tchr_creat_succes: "ఉపాధ్యాయుడు విజయవంతంగా సృష్టించారు",
    fail_crt_some_user: "కొంతమంది వినియోగదారులను సృష్టించడం విఫలమైంది",
    fail_create_mtg_try_again:
      "సెషన్‌ను సృష్టించడం విఫలమైంది! మళ్ళీ ప్రయత్నించండి",
    fail_create_schedu: "షెడ్యూల్‌ని రూపొందించడంలో విఫలమైంది",
    plz_enter_metng_title: "దయచేసి సెషన్ శీర్షికను నమోదు చేయండి",
    invalid_phn_nmb: "చెల్లని ఫోన్ నంబర్",
    plz_enter_phn_num: "దయచేసి ఫోన్ నంబర్‌ని నమోదు చేయండి",
    topic_crt_succes: "అంశం విజయవంతంగా సృష్టించబడింది",
    topic_enabled_succes: "అంశం విజయవంతంగా ప్రారంభించబడింది",
    topic_disabl_success: "అంశం విజయవంతంగా నిలిపివేయబడింది",
    topic_delet_success: "అంశం విజయవంతంగా తొలగించబడింది",
    Media_delet_success: "మీడియా విజయవంతంగా తొలగించబడింది",
    plz_enter_title_upload_doc:
      "దయచేసి మొదట శీర్షికను నమోదు చేసి, పత్రాన్ని అప్‌లోడ్ చేయండి",
    doc_add_succes: "పత్రం విజయవంతంగా జోడించబడింది",
    plz_fst_ent_title_and_media:
      "దయచేసి మొదట శీర్షికను నమోదు చేసి, మీడియా ఫైల్‌ను నమోదు చేయండి",
    media_add_success: "మీడియా విజయవంతంగా జోడించబడింది",
    plz_first_title_and_URL:
      "దయచేసి మొదట శీర్షికను నమోదు చేసి, మీడియా URLని నమోదు చేయండి",
    plz_etr_valid_url: "దయచేసి చెల్లుబాటు అయ్యే urlని నమోదు చేయండి",
    generate: "సృష్టించు",
    issue_cert: "సర్టిఫికేట్ జారీ చేయండి",
    total_score: "మొత్తం స్కోరు",
    created_by: "సృష్టికర్త",
    certificate: "సర్టిఫికేట్",
    not_completed: "పూర్తి కాలేదు",
    view_cert: "సర్టిఫికేట్ చూడండి",
    issue_certificate: "సర్టిఫికేట్ జారీ చేయండి",
    title: "శీర్షిక",
    issue_date: "జారీ చేసిన తేదీ",
    note_edit_and_delete_txt:
      "గమనిక : ఎడిట్ మరియు డిలీట్ బటన్‌లు పరీక్షకు 10 నిమిషాల ముందు నుండి దాచబడతాయి",
    verify_email_msg: "దయచేసి నిర్ధారణ కోడ్ కోసం మీ ఇమెయిల్‌ను తనిఖీ చేయండి",
    start_time_greater_currnt_time:
      "ప్రారంభ సమయం ప్రస్తుత సమయం కంటే 10 నిమిషాల కంటే ఎక్కువగా ఉండాలి",
    copi_to_clipboard: "క్లిప్‌బోర్డ్‌కి కాపీ చేయబడింది!",
    host_msg: "హోస్ట్",
    date_time: "తేదీ - సమయం",
    invities: "ఆహ్వానితులు",
    no_chat_history_avai: "చాట్ చరిత్ర అందుబాటులో లేదు.",
    no_feedbacks_avai: "ఫీడ్‌బ్యాక్‌లు ఏవీ అందుబాటులో లేవు",
    no_invities_list_avai: "ఆహ్వానితుల జాబితా అందుబాటులో లేదు",
    no_conference_note_avai: "సమావేశ గమనికలు అందుబాటులో లేవు.",
    total_notes: "మొత్తం గమనికలు ( 15 )",
    view_log_history: "లాగ్ చరిత్రను వీక్షించండి",
    total_duration: "మొత్తం వ్యవధి:",
    min: "కనిష్ట",
    total_time_spent: "గడిపిన మొత్తం సమయం:",
    entry: "ప్రవేశం",
    exit: "బయటకి దారి",
    time_spent: "గడిపిన సమయం",
    no_conference_recording_avai: "కాన్ఫరెన్స్ రికార్డింగ్‌లు అందుబాటులో లేవు",
    no_meetings: "సెషన్‌లు లేవు!",
    this_brow_dont_support_video_tag:
      "ఈ బ్రౌజర్ వీడియో ట్యాగ్‌లకు మద్దతు ఇవ్వదు.",
    no_participants_list_avai: "పాల్గొనేవారి జాబితా అందుబాటులో లేదు.",
    total_number_session: "సెషన్‌ల మొత్తం సంఖ్య",
    start_date: "ప్రారంబపు తేది:",
    join_mtg_provide_id_below_input:
      "సెషన్‌లో చేరడానికి, దిగువ ఇన్‌పుట్ బాక్స్‌లో సెషన్ IDని అందించండి.",
    You_enter_inva_meet: "మీరు చెల్లని సెషన్ IDని నమోదు చేసారు.",
    no_ques_creat_yet: "ఇంకా ప్రశ్నాపత్రాలు ఏవీ సృష్టించబడలేదు!",
    creat_quest_click_creat:
      "ప్రశ్నాపత్రాన్ని సృష్టించు బటన్‌ను క్లిక్ చేయడం ద్వారా ప్రశ్నావళిని సృష్టించండి.",
    only_invit_can_join: "ఆహ్వానితులు మాత్రమే చేరగలరు",
    invc_login_mandato: "inVC లాగిన్ తప్పనిసరి",
    training_mode: "శిక్షణ మోడ్",
    audio_only_mode: "ఆడియో మోడ్ మాత్రమే",
    mute_parti_upon_entry: "ప్రవేశించిన తర్వాత పాల్గొనేవారిని మ్యూట్ చేయండి",
    join_before_host: "హోస్ట్ ముందు చేరండి",
    enable_breakout_session: "Eబ్రేక్అవుట్ సెషన్‌లను ప్రారంభించండి",
    anonymous_access: "అనామక యాక్సెస్",
    send_invite: "ఆహ్వానం పంపండి",
    add_part_email_address_mobil_msg:
      "పాల్గొనేవారి ఇమెయిల్ చిరునామా లేదా మొబైల్ నంబర్‌ని జోడించడం ద్వారా వారిని జోడించండి, బహుళ ఎంట్రీల కోసం ఎంటర్ నొక్కండి.",
    add_email_mobile: "ఇమెయిల్ / మొబైల్ నంబర్ జోడించండి",
    make_sure_the_msg:
      "1 - మొబైల్ నంబర్ దేశం కోడ్‌తో ఉండాలని నిర్ధారించుకోండి (ఉదా: +91-99XXXXXXXX)",
    email_id_note:
      "2 - ఇమెయిల్ ఐడి చిన్న అక్షరంగా ఉండాలి (ఉదా: username@xxx.com)",
    meet_before_schedul_time:
      "మీరు షెడ్యూల్ చేసిన సమయానికి ముందు ఈ సెషన్‌లో చేరలేరు.",
    go_to_dashboard: "డాష్బోర్డ్ కు వెళ్ళండి",
    if_you_are_host_msg:
      "మీరు హోస్ట్ అయితే, దయచేసి మీ డాష్‌బోర్డ్ నుండి మరొక త్వరిత సెషన్‌ను ప్రారంభించండి",
    this_meet_expir_on: "ఈ సెషన్ గడువు ముగిసింది",
    this_meet_link__expired: "ఈ సెషన్ లింక్ గడువు ముగిసింది",
    this_meet_schedul_for: "ఈ సెషన్ షెడ్యూల్ చేయబడింది",
    meet_min_before_schedule_time:
      "మీరు షెడ్యూల్ చేసిన సమయానికి 5 నిమిషాల ముందు ఈ సెషన్‌లో చేరవచ్చు.",
    this_assign_start_yet: "ఈ అసైన్‌మెంట్ సమయం ఇంకా ప్రారంభించబడలేదు...",
    time_not_yet_start: "సమయం ఇంకా ప్రారంభం కాలేదు",
    field_once_generat_cannot_edit:
      "దయచేసి ఒకసారి రూపొందించిన అన్ని ఫీల్డ్‌లను సవరించడం సాధ్యం కాదని తనిఖీ చేయండి",
    certificate_title: "సర్టిఫికేట్ శీర్షిక",
    invalid_meet_code: "చెల్లని సెషన్ కోడ్",
    meeting_id_below_input_box:
      "సెషన్‌లో చేరడానికి మరియు స్క్రీన్‌ను షేర్ చేయడానికి, దిగువ ఇన్‌పుట్ బాక్స్‌లో సెషన్ IDని అందించండి.",
    meeting_configuration: "సెషన్ కాన్ఫిగరేషన్",
    room_participant_limit_exceed: "రూమ్ పార్టిసిపెంట్ పరిమితి మించిపోయింది.",
    only_audio_call_auto_mute_enabl:
      "ఆడియో కాల్ & ఆటో మ్యూట్ మాత్రమే ప్రారంభించబడ్డాయి",
    you_audio_video_mute: "మీ ఆడియో & వీడియో మ్యూట్ చేయబడింది!",
    only_audio_call: "ఆడియో కాల్ మాత్రమే",
    your_video_mute: "మీ వీడియో మ్యూట్ చేయబడింది!",
    your_name: "నీ పేరు",
    ok_you_r_ready: "సరే, మీరు సిద్ధంగా ఉన్నారు",
    room_empty_meeting_wait_until_host_join:
      "గది ఖాళీ! సెషన్‌ను ప్రారంభించడానికి మీరు లాగిన్ చేయవచ్చు లేదా హోస్ట్ చేరే వరకు వేచి ఉండండి",
    room_lock_hang_until_somebody_lets:
      "గది లాక్ చేయబడింది - ఎవరైనా మిమ్మల్ని లోపలికి అనుమతించే వరకు ఆగండి ...",
    your_audio_is_muted: "మీ ఆడియో మ్యూట్ చేయబడింది!",
    view_assignment: "అసైన్‌మెంట్‌ని వీక్షించండి",
    assigned_assignment: "అసైన్డ్ అసైన్‌మెంట్",
    attempte_assignment_written_anything:
      "మీరు అసైన్‌మెంట్‌ని ప్రయత్నించారు కానీ దానిలో ఏమీ వ్రాయలేదు.",
    Marks_not_alloted: "మార్కులు అనుమతించబడవు",
    view_questionnaire: "ప్రశ్నాపత్రాన్ని వీక్షించండి",
    assign_questionnaire_list: "ప్రశ్నాపత్రం జాబితాను కేటాయించండి",
    assign_assignment: "అసైన్‌మెంట్‌ల జాబితాను కేటాయించండి",
    type: "టైప్ చేయండి",
    class_description: "తరగతి వివరణ",
    password_updated: "పాస్‌వర్డ్ నవీకరించబడింది!",
    numberOfLicense: "లైసెన్స్ సంఖ్య",
    topic: "అంశం",
    del_poll: "పోలింగ్",
    std: "విద్యార్థి",
    profile: "ప్రొఫైల్",
    your_test: "మీ పరీక్ష",
    unattended_incomplete_Questionaire_txt_msg:
      "కొన్ని కారణాల వల్ల గమనించబడలేదు లేదా అసంపూర్ణంగా ఉంది. అందువల్ల స్కోర్ కార్డ్‌ని రూపొందించడం సాధ్యం కాలేదు",
    Assgnmnt_time_not_started: "అసైన్‌మెంట్ సమయం ఇంకా ప్రారంభం కాలేదు...",
    submitted_cnt: "సమర్పించిన కంటెంట్",
    stud_list: "విద్యార్థి జాబితా",
    test_submitted_successfully: "మీ పరీక్ష విజయవంతంగా సమర్పించబడింది",
    score_time_finished_successfully:
      "సమయం ముగిసిన తర్వాత స్కోర్ ప్రదర్శించబడుతుంది",
    topics_list: "అంశాల జాబితా",
    upload_highResImg: "అధిక-రిజల్యూషన్ చిత్రాలను మాత్రమే అప్‌లోడ్ చేయండి",
    meetingList_upcoming_meetings: "రాబోయే సెషన్‌లు",
    subject_list: "విషయ జాబితా",
    plz_enter_valid_number_license:
      "దయచేసి లైసెన్స్ యొక్క చెల్లుబాటు అయ్యే సంఖ్యను నమోదు చేయండి",
    no_class_assigned: "తరగతి కేటాయించబడలేదు",
    class_list: "తరగతి జాబితా",
    plz_fill_all_details: "దయచేసి అన్ని వివరాలను పూరించండి",
    plz_click_upload_media_url: "దయచేసి అప్‌లోడ్ మీడియా urlని క్లిక్ చేయండి",
    please_enter_msg: "దయచేసి పూరించండి",
    Media_msg: "మీడియా.",
    media_url: "మీడియా URL.",
    title: "శీర్షిక",
    and_msg: "మరియు",
    wrong_answer: "తప్పు సమాధానం",
    right_answer: "సరైన సమాధానం",
    User_list: "వినియోగదారుల జాబితా",
    questionaire_time_not_yet_start:
      "ప్రశ్నోత్తరాల సమయం ఇంకా ప్రారంభం కాలేదు...",
    submitted_list: "సమర్పించిన జాబితా",
    search_by_name: "పేరు ద్వారా శోధించండి",
    scheduleDate: "షెడ్యూల్ తేదీ",
    view_all: "అన్నీ వీక్షించండి",
    view_card: "కార్డ్ వీక్షణ",
    confirm_submit: "మీరు ఖచ్చితంగా అసైన్‌మెంట్‌ను సమర్పించాలనుకుంటున్నారా?",
    confirm_finish: "మీరు ఖచ్చితంగా పరీక్షను పూర్తి చేయాలనుకుంటున్నారా?",
    questionaire: "ప్రశ్నాపత్రం",
    list_of_questns_for_above_questionaire:
      "పై ప్రశ్నాపత్రం కోసం కేటాయించిన ప్రశ్నల జాబితా క్రింద ఉన్నాయి",
    view_all_assignments: "అన్ని అసైన్‌మెంట్‌లను వీక్షించండి",
    action: "చర్య",
    start_dte: "ప్రారంబపు తేది",
    subject: "విషయం",
    digital_file_upload_and_digital_signature:
      "ఇక్కడ అప్‌లోడ్ చేయబడిన డిజిటల్ ఫైల్‌లు విద్యార్థులకు జారీ చేయబడిన డిజిటల్ సర్టిఫికేట్‌లపై కనిపిస్తాయి",
    upload_logo: "లోగోను అప్‌లోడ్ చేయండి",
    upload_signature: "సంతకాన్ని అప్‌లోడ్ చేయండి",
    upload_stamp: "స్టాంపును అప్‌లోడ్ చేయండి",
    drag_and_drop_file: "మీ ఫైల్‌ని ఇక్కడకు లాగి వదలండి లేదా ",
    max_file_mb_dimensions: "గరిష్ట ఫైల్ పరిమాణం 20MB కొలతలు",
    note_assgn_qusnr_text:
      "గమనిక *: అసైన్‌మెంట్ ప్రారంభమయ్యే 10 నిమిషాల ముందు నుండి మీరు మీ ఎంట్రీలను సవరించలేరు లేదా తొలగించలేరు",
    note_qusnr_text:
      "గమనిక *: మీరు ప్రశ్నాపత్రం ప్రారంభమయ్యే 10 నిమిషాల ముందు నుండి మీ ఎంట్రీలను సవరించలేరు లేదా తొలగించలేరు",
    not_attended: "హాజరు కాలేదు",
    not_started: "మొదలవలేదు",
    dont_have_stu_acc: "విద్యార్థి ఖాతా లేదు",
    buy_more: "ఇంకా కొనుము",
    product: "ఉత్పత్తి",
    no_subject_assigned: "సబ్జెక్ట్‌లు ఏవీ కేటాయించబడలేదు",
    logo: "లోగో",
    stamp: "స్టాంపు",
    signature: "సంతకం",
    uploaded_successfully: "విజయవంతంగా అప్‌లోడ్ చేయబడింది",
    renewal: "పునరుద్ధరణ",
    domain_name: "డొమైన్ పేరు",
    pls_sel_frequency:
      "దయచేసి మీరు షెడ్యూల్ చేయాలనుకుంటున్న వారంలో ఏ రోజును ఎంచుకోండి",
    your_test_successfully_submitted: "మీ పరీక్ష విజయవంతంగా సమర్పించబడింది",
    score_will_finished: "సమయం ముగిసిన తర్వాత స్కోర్ ప్రదర్శించబడుతుంది",
    license_expired: "లైసెన్స్ గడువు ముగిసింది",
    application_longer_accessed_since__license_expired:
      "మీ లైసెన్స్ గడువు ముగిసినందున అప్లికేషన్ ఇకపై యాక్సెస్ చేయబడదు. యాక్సెస్‌ని మళ్లీ సక్రియం చేయడానికి,",
    respective_admin_license_renewal:
      "లైసెన్స్ పునరుద్ధరణ కోసం దయచేసి మీ సంబంధిత నిర్వాహకులను సంప్రదించండి.",
    okay: " సరే",
    delete_recurring_schedule: "పునరావృత షెడ్యూల్‌ను తొలగించండి",
    are_you_sure_delete_recurring_schedule:
      "మీరు ఈ పునరావృత షెడ్యూల్‌ని ఖచ్చితంగా తొలగించాలనుకుంటున్నారా?",
    delete_all_recurring_days_completely:
      "పునరావృతమయ్యే అన్ని రోజులను పూర్తిగా తొలగించండి.",
    will_eleminate_all_selected:
      "షెడ్యూల్ నుండి ఎంచుకున్న అన్ని రోజులను తొలగిస్తుంది",
    remove_only_selected_days: "ఎంచుకున్న రోజులను మాత్రమే తీసివేయండి",
    delete_selected_days_schedule:
      "ఇది షెడ్యూల్ నుండి ఎంచుకున్న రోజులను మాత్రమే తొలగిస్తుంది",
    recurring_dates: "పునరావృత తేదీలు",
    enter_the_coupon_code: "కూపన్ కోడ్‌ను నమోదు చేయండి",
    coupon_applied: "కూపన్ వర్తింపజేయబడింది",
    coupon_id: "కూపన్ ID",
    del_recurring_by_dates: "మీరు ఏ సెషన్‌ను తొలగించాలనుకుంటున్నారో ఎంచుకోండి",
    more_details: "మరిన్ని వివరాలు",
    removeStudentUser: "మీరు ఖచ్చితంగా ఈ విద్యార్థిని తీసివేయాలనుకుంటున్నారా?",
    removeTeacherUser: "మీరు ఖచ్చితంగా ఈ ఉపాధ్యాయుడిని తీసివేయాలనుకుంటున్నారా?",
    sure_you_want_to_delete: "మీరు ఖచ్చితంగా దీన్ని తొలగించాలనుకుంటున్నారా",
    deleting_information_database: "దీన్ని తొలగించడం వలన డేటాబేస్ నుండి మొత్తం సమాచారం తొలగించబడుతుంది.",
    to_confirm_type: "రకాన్ని నిర్ధారించడానికి",
    name_not_matched: "పేరు సరిపోలలేదు.",
    confirm_this_type: "దీన్ని నిర్ధారించడానికి, టైప్ చేయండి",
    topic_title: "అంశం శీర్షిక",
    select: "ఎంచుకోండి",
    plz_enter_integers: "దయచేసి పూర్ణాంక విలువలను మాత్రమే నమోదు చేయండి",
    help_Center:"సహాయ కేంద్రం",

  },
};
